var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _g2, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _g3, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReceiptsMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.86 53.84V5.41A5.43 5.43 0 0 1 16.31 0h26.56c3.01 0 5.45 2.42 5.45 5.41v48.43a5.43 5.43 0 0 1-5.45 5.42H16.31c-3 0-5.45-2.43-5.45-5.42Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.75V6.1c0-2.34 1.9-4.23 4.25-4.23h25.1c2.35 0 4.26 1.9 4.26 4.23v46.63c0 2.34-1.9 4.23-4.26 4.23h-25.1a4.24 4.24 0 0 1-4.25-4.22Z",
    fill: "#DFDDEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.75V6.1c0-2.33 1.9-4.23 4.25-4.23h25.1c2.35 0 4.26 1.9 4.26 4.23v46.64c0 2.33-1.9 4.22-4.26 4.22h-25.1a4.24 4.24 0 0 1-4.25-4.22Z",
    fill: "#E0DEEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.23 4.25-4.23h25.1c2.35 0 4.25 1.9 4.25 4.23v46.64c0 2.33-1.9 4.22-4.25 4.22h-25.1a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E1DFEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.23 4.25-4.23h25.1c2.35 0 4.25 1.9 4.25 4.23v46.63c0 2.34-1.9 4.23-4.25 4.23h-25.1a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E2E0ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.23 4.25-4.23h25.1c2.35 0 4.25 1.9 4.25 4.23v46.63c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E3E1EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.23 4.25-4.23h25.1c2.35 0 4.25 1.9 4.25 4.23v46.63c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E4E2EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.22 4.25-4.22h25.1c2.34 0 4.25 1.89 4.25 4.22v46.63c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E5E3EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.22 4.25-4.22h25.1c2.34 0 4.25 1.89 4.25 4.22v46.63c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E6E4EF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.11c0-2.33 1.9-4.22 4.25-4.22h25.1c2.34 0 4.25 1.89 4.25 4.22v46.63c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E6E5F0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.34 1.9-4.23 4.25-4.23h25.1c2.34 0 4.25 1.9 4.25 4.23v46.62c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E7E6F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.34 1.9-4.23 4.25-4.23H42c2.35 0 4.25 1.9 4.25 4.23v46.62c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E8E7F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.34 1.9-4.23 4.25-4.23H42c2.35 0 4.25 1.9 4.25 4.23v46.62c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#E9E8F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.34 1.9-4.23 4.25-4.23H42c2.35 0 4.25 1.9 4.25 4.23v46.62c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#EAE9F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.34 1.9-4.23 4.25-4.23H42c2.35 0 4.25 1.9 4.25 4.23v46.62c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#EBEAF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.34 1.9-4.23 4.25-4.23H42c2.35 0 4.26 1.9 4.26 4.23v46.62c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#ECEBF4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.23 4.25-4.23H42c2.35 0 4.26 1.9 4.26 4.23v46.62c0 2.33-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#EDECF5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.23 4.25-4.23H42c2.35 0 4.26 1.9 4.26 4.23v46.62c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#EEEDF5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.23 4.25-4.23H42c2.35 0 4.26 1.9 4.26 4.23v46.62c0 2.33-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#EFEEF6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.23 4.25-4.23H42c2.35 0 4.26 1.9 4.26 4.23v46.62c0 2.33-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F0EFF6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.22 4.25-4.22h25.08c2.34 0 4.25 1.89 4.25 4.22v46.62c0 2.33-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F1F0F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.22 4.25-4.22h25.08c2.34 0 4.25 1.9 4.25 4.22v46.62c0 2.33-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F2F1F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.22 4.25-4.22h25.07c2.35 0 4.26 1.9 4.26 4.22v46.62c0 2.33-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F3F2F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.12c0-2.33 1.9-4.22 4.25-4.22h25.07c2.35 0 4.26 1.9 4.26 4.22v46.62c0 2.33-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F4F3F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.34 1.9-4.23 4.25-4.23h25.07c2.35 0 4.25 1.9 4.25 4.23v46.61c0 2.33-1.9 4.23-4.25 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F4F4FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.34 1.9-4.23 4.25-4.23h25.07c2.35 0 4.25 1.9 4.25 4.23v46.61c0 2.33-1.9 4.23-4.25 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F5F5FA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.34 1.9-4.23 4.25-4.23h25.07c2.35 0 4.25 1.9 4.25 4.23v46.6c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.22Z",
    fill: "#F6F6FB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.34 1.9-4.23 4.25-4.23h25.07c2.35 0 4.25 1.9 4.25 4.23v46.6c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.22Z",
    fill: "#F7F7FB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.33 1.9-4.23 4.25-4.23h25.07c2.34 0 4.25 1.9 4.25 4.23v46.61c0 2.33-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#F8F8FC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.33 1.9-4.23 4.25-4.23h25.07c2.34 0 4.25 1.9 4.25 4.23v46.6c0 2.34-1.9 4.23-4.25 4.23H16.9a4.24 4.24 0 0 1-4.25-4.22Z",
    fill: "#F9F9FD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.13c0-2.33 1.9-4.23 4.25-4.23h25.06c2.35 0 4.26 1.9 4.26 4.23v46.6c0 2.34-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.22Z",
    fill: "#FAFAFD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 52.74V6.14c0-2.34 1.9-4.23 4.25-4.23h25.06c2.35 0 4.26 1.89 4.26 4.22v46.61c0 2.33-1.9 4.23-4.26 4.23H16.91a4.24 4.24 0 0 1-4.25-4.23Z",
    fill: "#FBFBFE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7 7.41H15.62c-.81 0-1.47-.65-1.47-1.46 0-.8.66-1.46 1.47-1.46H42.7c.8 0 1.47.66 1.47 1.46 0 .8-.67 1.46-1.48 1.46Z",
    fill: "#DBDFEE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.68 7.4H15.63c-.8 0-1.47-.65-1.47-1.45 0-.8.66-1.46 1.47-1.46h27.05c.8 0 1.47.65 1.47 1.46 0 .8-.66 1.46-1.47 1.46Z",
    fill: "#DCE0EE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66 7.4H15.63c-.8 0-1.46-.65-1.46-1.45 0-.8.66-1.46 1.46-1.46h27.03c.81 0 1.47.66 1.47 1.46 0 .8-.66 1.45-1.47 1.45Z",
    fill: "#DDE0EF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M42.65 7.4H15.64c-.8 0-1.46-.66-1.46-1.45 0-.8.65-1.46 1.46-1.46h27.01a1.46 1.46 0 1 1 0 2.9Z",
    fill: "#DEE1EF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.64 7.39h-27c-.8 0-1.46-.65-1.46-1.45 0-.8.66-1.45 1.46-1.45h27c.8 0 1.46.65 1.46 1.45 0 .8-.66 1.45-1.46 1.45Z",
    fill: "#DFE2F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.63 7.39H15.64c-.8 0-1.45-.66-1.45-1.45 0-.8.65-1.45 1.45-1.45h26.99c.8 0 1.45.65 1.45 1.45 0 .8-.66 1.45-1.45 1.45Z",
    fill: "#E0E2F0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 7.38H15.66c-.8 0-1.46-.65-1.46-1.44 0-.8.66-1.45 1.46-1.45H42.6c.8 0 1.45.65 1.45 1.45 0 .79-.65 1.44-1.45 1.44Z",
    fill: "#E1E3F1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 7.38H15.65c-.8 0-1.45-.65-1.45-1.45 0-.79.65-1.44 1.45-1.44H42.6c.8 0 1.45.65 1.45 1.44 0 .8-.66 1.45-1.45 1.45Z",
    fill: "#E2E4F1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.58 7.37H15.65c-.8 0-1.44-.65-1.44-1.44 0-.79.65-1.43 1.44-1.43h26.93c.8 0 1.45.64 1.45 1.43 0 .8-.65 1.44-1.45 1.44Z",
    fill: "#E3E4F2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.57 7.37H15.65c-.79 0-1.44-.65-1.44-1.44 0-.79.65-1.43 1.44-1.43h26.92c.79 0 1.44.64 1.44 1.43 0 .79-.65 1.44-1.44 1.44Z",
    fill: "#E4E5F2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55 7.36h-26.9c-.79 0-1.43-.65-1.43-1.43 0-.8.65-1.43 1.44-1.43h26.9c.79 0 1.43.64 1.43 1.43 0 .78-.65 1.43-1.44 1.43Z",
    fill: "#E5E5F2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.54 7.35H15.66c-.79 0-1.44-.64-1.44-1.42 0-.8.65-1.43 1.44-1.43h26.88c.8 0 1.44.64 1.44 1.43 0 .78-.65 1.42-1.44 1.42Z",
    fill: "#E6E6F3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M42.53 7.35H15.66c-.79 0-1.43-.65-1.43-1.43 0-.78.64-1.43 1.43-1.43h26.87c.78 0 1.43.65 1.43 1.43 0 .79-.65 1.43-1.43 1.43Z",
    fill: "#E7E7F3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M42.51 7.34H15.67c-.8 0-1.44-.64-1.44-1.42 0-.79.65-1.43 1.44-1.43H42.5c.79 0 1.43.64 1.43 1.43 0 .78-.64 1.42-1.43 1.42Z",
    fill: "#E8E7F4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 7.34H15.67c-.79 0-1.43-.64-1.43-1.42 0-.79.64-1.43 1.43-1.43H42.5c.78 0 1.43.64 1.43 1.43 0 .78-.65 1.42-1.43 1.42Z",
    fill: "#E9E8F4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M42.48 7.33h-26.8c-.8 0-1.43-.64-1.43-1.41 0-.78.64-1.42 1.42-1.42h26.81c.79 0 1.43.64 1.43 1.42 0 .77-.64 1.41-1.43 1.41Z",
    fill: "#EAE9F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.47 7.33h-26.8c-.78 0-1.42-.64-1.42-1.42 0-.78.64-1.41 1.42-1.41h26.8c.78 0 1.42.64 1.42 1.41 0 .78-.64 1.42-1.42 1.42Z",
    fill: "#EBE9F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.46 7.32H15.68c-.78 0-1.42-.63-1.42-1.4 0-.79.64-1.42 1.42-1.42h26.78c.78 0 1.41.63 1.41 1.41 0 .78-.63 1.41-1.41 1.41Z",
    fill: "#ECEAF6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.44 7.32H15.68c-.78 0-1.41-.64-1.41-1.41 0-.78.63-1.41 1.41-1.41h26.76c.78 0 1.42.63 1.42 1.4 0 .78-.64 1.42-1.42 1.42Z",
    fill: "#ECEBF6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42.43 7.31H15.68c-.77 0-1.41-.63-1.41-1.4 0-.78.64-1.41 1.41-1.41h26.75c.78 0 1.41.63 1.41 1.4 0 .78-.63 1.41-1.41 1.41Z",
    fill: "#EDEBF6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M42.41 7.3H15.7c-.78 0-1.41-.63-1.41-1.4 0-.77.63-1.4 1.4-1.4h26.73c.78 0 1.41.63 1.41 1.4 0 .77-.63 1.4-1.4 1.4Z",
    fill: "#EEECF7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4 7.3H15.69a1.4 1.4 0 0 1-1.41-1.4c0-.77.63-1.4 1.4-1.4H42.4c.77 0 1.4.63 1.4 1.4 0 .77-.63 1.4-1.4 1.4Z",
    fill: "#EFEDF7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.38 7.3H15.7a1.4 1.4 0 0 1-1.4-1.4c0-.77.63-1.4 1.4-1.4h26.7c.77 0 1.4.63 1.4 1.4 0 .77-.63 1.4-1.4 1.4Z",
    fill: "#F0EDF8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.37 7.29H15.7a1.4 1.4 0 0 1-1.4-1.4c0-.76.63-1.39 1.4-1.39h26.67c.77 0 1.4.63 1.4 1.4 0 .76-.63 1.39-1.4 1.39Z",
    fill: "#F1EEF8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.36 7.28H15.7a1.4 1.4 0 0 1-1.4-1.39c0-.76.63-1.39 1.4-1.39h26.66a1.4 1.4 0 1 1 0 2.78Z",
    fill: "#F2EFF9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42.34 7.28H15.7a1.4 1.4 0 0 1-1.4-1.39c0-.76.63-1.39 1.4-1.39h26.64a1.4 1.4 0 1 1 0 2.78Z",
    fill: "#F3EFF9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M42.33 7.27H15.7a1.4 1.4 0 0 1-1.39-1.38c0-.76.63-1.39 1.4-1.39h26.62c.76 0 1.4.62 1.4 1.39a1.4 1.4 0 0 1-1.4 1.38Z",
    fill: "#F4F0F9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.31 7.27h-26.6a1.4 1.4 0 0 1-1.4-1.38c0-.77.63-1.39 1.4-1.39h26.6c.77 0 1.4.62 1.4 1.39a1.4 1.4 0 0 1-1.4 1.38Z",
    fill: "#F5F0FA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 7.26H15.71c-.76 0-1.39-.62-1.39-1.38 0-.76.62-1.38 1.39-1.38H42.3c.76 0 1.39.62 1.39 1.38a1.4 1.4 0 0 1-1.39 1.38Z",
    fill: "#F6F1FA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M42.28 7.26H15.71c-.76 0-1.38-.62-1.38-1.38 0-.76.62-1.38 1.38-1.38H42.3c.76 0 1.38.62 1.38 1.38 0 .76-.62 1.38-1.39 1.38Z",
    fill: "#F7F2FB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.27 7.25H15.72c-.76 0-1.38-.62-1.38-1.37 0-.76.62-1.38 1.38-1.38h26.55c.76 0 1.38.62 1.38 1.38 0 .75-.62 1.37-1.38 1.37Z",
    fill: "#F8F2FB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.26 7.25H15.72c-.76 0-1.38-.62-1.38-1.37 0-.76.62-1.38 1.38-1.38h26.54c.75 0 1.38.62 1.38 1.38 0 .75-.62 1.37-1.38 1.37Z",
    fill: "#F9F3FC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.24 7.24H15.72c-.76 0-1.37-.61-1.37-1.37 0-.75.61-1.37 1.37-1.37h26.52c.76 0 1.38.62 1.38 1.37 0 .76-.62 1.37-1.38 1.37Z",
    fill: "#FAF4FC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 7.24h-26.5c-.76 0-1.38-.62-1.38-1.37 0-.75.62-1.37 1.38-1.37h26.5c.76 0 1.37.62 1.37 1.37 0 .75-.61 1.37-1.37 1.37Z",
    fill: "#FBF4FD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 7.23h-26.5c-.75 0-1.36-.61-1.36-1.36 0-.75.61-1.37 1.37-1.37H42.2c.76 0 1.38.62 1.38 1.37 0 .75-.62 1.36-1.37 1.36Z",
    fill: "#FCF5FD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 7.23h-26.5c-.75 0-1.36-.61-1.36-1.36 0-.75.61-1.37 1.37-1.37H42.2c.76 0 1.38.62 1.38 1.37 0 .75-.62 1.36-1.37 1.36Z",
    fill: "url(#b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M43.45 8.35H16.1a1.92 1.92 0 0 1-1.91-1.9c0-1.06.86-1.91 1.91-1.91h27.34c1.05 0 1.91.85 1.91 1.9 0 1.05-.86 1.9-1.91 1.9Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M43.44 8.34H16.11a1.91 1.91 0 0 1-1.9-1.9c0-1.05.85-1.9 1.9-1.9h27.33c1.06 0 1.91.85 1.91 1.9 0 1.04-.86 1.9-1.9 1.9Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M43.44 8.33H16.1a1.9 1.9 0 0 1-1.9-1.9c0-1.04.85-1.9 1.9-1.9h27.33c1.04 0 1.9.86 1.9 1.9a1.9 1.9 0 0 1-1.9 1.9Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M43.43 8.32H16.1a1.9 1.9 0 0 1-1.9-1.89 1.9 1.9 0 0 1 1.9-1.89h27.32c1.04 0 1.9.85 1.9 1.89a1.9 1.9 0 0 1-1.9 1.89Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M43.42 8.31H16.11a1.9 1.9 0 0 1-1.9-1.89 1.9 1.9 0 0 1 1.9-1.88h27.31c1.05 0 1.9.85 1.9 1.88a1.9 1.9 0 0 1-1.9 1.89Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M43.41 8.3h-27.3a1.9 1.9 0 0 1-1.9-1.88 1.9 1.9 0 0 1 1.9-1.88h27.3c1.04 0 1.9.85 1.9 1.88a1.9 1.9 0 0 1-1.9 1.88Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M43.4 8.29H16.1a1.89 1.89 0 0 1-1.88-1.88c0-1.03.85-1.87 1.88-1.87h27.3c1.05 0 1.9.84 1.9 1.87 0 1.04-.85 1.88-1.9 1.88Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M43.4 8.28H16.1a1.88 1.88 0 0 1-1.88-1.87c0-1.03.85-1.87 1.88-1.87h27.3c1.03 0 1.88.84 1.88 1.87 0 1.03-.85 1.87-1.88 1.87Z",
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M43.39 8.27h-27.3a1.88 1.88 0 0 1-1.87-1.87c0-1.02.84-1.86 1.88-1.86h27.29c1.03 0 1.88.84 1.88 1.86 0 1.03-.85 1.87-1.88 1.87Z",
    fill: "#F6F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.38 8.26H16.1a1.87 1.87 0 0 1-1.87-1.86c0-1.02.84-1.86 1.87-1.86h27.3c1.02 0 1.87.83 1.87 1.86 0 1.03-.85 1.86-1.88 1.86Z",
    fill: "#F5F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M43.38 8.25H16.09a1.87 1.87 0 0 1-1.87-1.86c0-1.02.85-1.85 1.87-1.85h27.29c1.02 0 1.86.83 1.86 1.85 0 1.03-.84 1.86-1.86 1.86Z",
    fill: "#F4F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M43.37 8.24H16.09a1.86 1.86 0 0 1-1.86-1.85c0-1.02.84-1.85 1.86-1.85h27.28c1.02 0 1.86.83 1.86 1.85s-.84 1.85-1.86 1.85Z",
    fill: "#F3F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M43.36 8.23H16.1a1.86 1.86 0 0 1-1.86-1.84c0-1.02.84-1.85 1.86-1.85h27.27c1.02 0 1.86.83 1.86 1.85 0 1.01-.84 1.84-1.86 1.84Z",
    fill: "#F2F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M43.35 8.22H16.1a1.85 1.85 0 0 1-1.86-1.84c0-1.01.84-1.84 1.86-1.84h27.26c1.02 0 1.86.83 1.86 1.84 0 1.02-.84 1.84-1.86 1.84Z",
    fill: "#F1F1F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M43.35 8.22H16.08a1.85 1.85 0 0 1-1.84-1.84c0-1.01.83-1.84 1.84-1.84h27.27c1.01 0 1.84.83 1.84 1.84 0 1.01-.83 1.84-1.84 1.84Z",
    fill: "#F0F0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M43.34 8.2H16.09a1.84 1.84 0 0 1-1.85-1.83c0-1 .83-1.83 1.85-1.83h27.25c1.01 0 1.84.83 1.84 1.83 0 1.01-.83 1.84-1.84 1.84Z",
    fill: "#EFEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M43.33 8.2H16.08a1.84 1.84 0 0 1-1.84-1.83c0-1 .83-1.83 1.84-1.83h27.25c1.01 0 1.84.82 1.84 1.83 0 1-.83 1.83-1.84 1.83Z",
    fill: "#EEEEF2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M43.33 8.19H16.08c-1.01 0-1.83-.82-1.83-1.83 0-1 .82-1.82 1.83-1.82h27.25c1 0 1.83.82 1.83 1.82s-.83 1.83-1.83 1.83Z",
    fill: "#EDEDF1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M43.32 8.18H16.08c-1 0-1.83-.82-1.83-1.82s.82-1.82 1.83-1.82h27.24c1 0 1.83.82 1.83 1.82s-.83 1.82-1.83 1.82Z",
    fill: "#ECECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.31 8.17H16.07c-1 0-1.82-.82-1.82-1.81 0-1 .82-1.82 1.82-1.82h27.24a1.82 1.82 0 0 1 0 3.62Z",
    fill: "#EBEBEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M43.3 8.16H16.07c-1 0-1.81-.82-1.81-1.8 0-1 .81-1.82 1.81-1.82H43.3c1 0 1.82.82 1.82 1.81 0 1-.82 1.8-1.82 1.8Z",
    fill: "#EAEAEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M43.3 8.15H16.07c-1 0-1.81-.81-1.81-1.8 0-1 .82-1.8 1.81-1.8H43.3c1 0 1.8.8 1.8 1.8.01.99-.8 1.8-1.8 1.8Z",
    fill: "#E9E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M43.29 8.14H16.07c-1 0-1.81-.8-1.81-1.8 0-.99.81-1.8 1.81-1.8h27.22c1 0 1.8.81 1.8 1.8 0 1-.8 1.8-1.8 1.8Z",
    fill: "#E8E8ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M43.28 8.13H16.07c-1 0-1.8-.8-1.8-1.8 0-.98.8-1.79 1.8-1.79h27.21c1 0 1.8.8 1.8 1.8 0 .98-.8 1.8-1.8 1.8Z",
    fill: "#E7E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M43.27 8.12h-27.2c-1 0-1.8-.8-1.8-1.79 0-.98.8-1.79 1.8-1.79h27.2a1.8 1.8 0 1 1 0 3.58Z",
    fill: "#E6E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M43.27 8.11h-27.2c-1 0-1.8-.8-1.8-1.78s.8-1.79 1.8-1.79h27.2c.98 0 1.8.8 1.8 1.79 0 .98-.82 1.78-1.8 1.78Z",
    fill: "#E5E5EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M43.26 8.1h-27.2a1.8 1.8 0 0 1-1.79-1.78c0-.97.8-1.78 1.8-1.78h27.19c.98 0 1.79.8 1.79 1.78s-.8 1.78-1.79 1.78Z",
    fill: "#E4E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M43.25 8.1H16.06c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78h27.2c.98 0 1.78.8 1.78 1.78s-.8 1.77-1.79 1.77Z",
    fill: "#E3E3E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M43.25 8.09h-27.2c-.97 0-1.77-.8-1.77-1.77 0-.98.8-1.77 1.78-1.77h27.19c.97 0 1.78.8 1.78 1.77s-.8 1.77-1.78 1.77Z",
    fill: "#E2E2E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.24 8.08H16.05c-.97 0-1.77-.8-1.77-1.77s.8-1.76 1.77-1.76h27.19c.97 0 1.77.8 1.77 1.76 0 .97-.8 1.77-1.77 1.77Z",
    fill: "#E1E1E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M43.23 8.07H16.05c-.97 0-1.76-.8-1.76-1.76 0-.97.8-1.76 1.76-1.76h27.18c.98 0 1.77.79 1.77 1.76 0 .96-.8 1.76-1.77 1.76Z",
    fill: "#E0E0E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M43.22 8.06H16.05c-.97 0-1.76-.8-1.76-1.76s.8-1.75 1.76-1.75h27.18c.97 0 1.76.79 1.76 1.75 0 .97-.8 1.76-1.77 1.76Z",
    fill: "#DFDFE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M43.21 8.05H16.05c-.97 0-1.76-.79-1.76-1.75s.79-1.75 1.76-1.75H43.2c.97 0 1.76.79 1.76 1.75s-.79 1.75-1.76 1.75Z",
    fill: "#DEDEE5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M43.21 8.04H16.05c-.97 0-1.76-.79-1.76-1.75s.8-1.74 1.76-1.74H43.2c.96 0 1.75.79 1.75 1.74 0 .96-.79 1.75-1.75 1.75Z",
    fill: "#DDDDE4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M43.2 8.03H16.04c-.96 0-1.75-.79-1.75-1.74 0-.96.8-1.74 1.75-1.74H43.2c.96 0 1.75.78 1.75 1.74s-.79 1.74-1.75 1.74Z",
    fill: "#DCDCE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M43.2 8.02H16.04c-.96 0-1.74-.78-1.74-1.73 0-.96.79-1.74 1.74-1.74H43.2c.96 0 1.74.78 1.74 1.74 0 .95-.79 1.73-1.74 1.73Z",
    fill: "#DBDBE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M43.19 8.01H16.04c-.96 0-1.74-.78-1.74-1.73s.78-1.73 1.74-1.73H43.2c.96 0 1.74.78 1.74 1.73S44.15 8 43.19 8Z",
    fill: "#DADAE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M43.18 8H16.04c-.96 0-1.74-.78-1.74-1.73s.78-1.72 1.74-1.72h27.14c.96 0 1.74.77 1.74 1.72S44.14 8 43.18 8Z",
    fill: "#D9D9E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M43.17 7.99H16.04c-.95 0-1.74-.77-1.74-1.72s.78-1.72 1.74-1.72h27.13c.95 0 1.73.77 1.73 1.72s-.77 1.72-1.73 1.72Z",
    fill: "#D8D8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.16 7.98H16.03c-.95 0-1.72-.77-1.72-1.71 0-.95.77-1.72 1.72-1.72h27.13c.95 0 1.73.77 1.73 1.72 0 .94-.78 1.71-1.73 1.71Z",
    fill: "#D7D7DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M43.16 7.97H16.03c-.94 0-1.72-.77-1.72-1.7 0-.95.77-1.72 1.72-1.72h27.13c.94 0 1.72.77 1.72 1.71s-.77 1.71-1.72 1.71Z",
    fill: "#D6D6DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M43.15 7.96H16.03c-.94 0-1.72-.77-1.72-1.7 0-.94.78-1.71 1.72-1.71h27.12c.94 0 1.72.77 1.72 1.7 0 .95-.78 1.71-1.72 1.71Z",
    fill: "#D5D5DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M43.14 7.95H16.03c-.94 0-1.71-.76-1.71-1.7 0-.93.77-1.7 1.7-1.7h27.12c.95 0 1.72.77 1.72 1.7 0 .94-.77 1.7-1.72 1.7Z",
    fill: "#D4D4DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M43.14 7.94H16.03a1.7 1.7 0 0 1-1.71-1.7c0-.92.77-1.69 1.7-1.69h27.12c.93 0 1.7.77 1.7 1.7 0 .93-.77 1.7-1.7 1.7Z",
    fill: "#D3D3DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M43.13 7.93h-27.1a1.7 1.7 0 0 1-1.7-1.69c0-.93.76-1.69 1.7-1.69h27.1c.93 0 1.7.76 1.7 1.7 0 .92-.77 1.68-1.7 1.68Z",
    fill: "#D2D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M43.12 7.92h-27.1a1.7 1.7 0 0 1-1.7-1.68c0-.93.77-1.69 1.7-1.69h27.1c.93 0 1.7.76 1.7 1.69a1.7 1.7 0 0 1-1.7 1.68Z",
    fill: "#D1D1DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M43.11 7.92H16.02a1.7 1.7 0 0 1-1.69-1.68c0-.93.76-1.69 1.7-1.69H43.1c.93 0 1.7.76 1.7 1.69a1.7 1.7 0 0 1-1.7 1.68Z",
    fill: "#D0D0DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M43.1 7.9H16.03c-.93 0-1.69-.75-1.69-1.67 0-.92.76-1.68 1.69-1.68H43.1c.92 0 1.68.76 1.68 1.68 0 .92-.76 1.68-1.68 1.68Z",
    fill: "#CFCFD9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M43.1 7.9H16.02c-.93 0-1.68-.76-1.68-1.67 0-.92.75-1.68 1.68-1.68H43.1c.92 0 1.68.76 1.68 1.68 0 .92-.76 1.67-1.68 1.67Z",
    fill: "#CECED8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M43.1 7.89H16.01c-.93 0-1.68-.75-1.68-1.67 0-.92.76-1.67 1.68-1.67h27.07c.93 0 1.68.76 1.68 1.67 0 .92-.76 1.67-1.68 1.67Z",
    fill: "#CECED8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M43.09 7.88H16c-.92 0-1.67-.75-1.67-1.66 0-.92.75-1.67 1.67-1.67H43.1c.92 0 1.67.75 1.67 1.67 0 .91-.76 1.66-1.67 1.66Z",
    fill: "#CDCDD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M43.08 7.87H16c-.92 0-1.67-.75-1.67-1.66 0-.91.75-1.66 1.67-1.66h27.07c.92 0 1.67.75 1.67 1.66 0 .91-.75 1.66-1.67 1.66Z",
    fill: "#CCCCD6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M43.07 7.86H16.01c-.92 0-1.66-.74-1.66-1.65 0-.91.74-1.66 1.66-1.66h27.06c.92 0 1.66.75 1.66 1.66 0 .9-.74 1.65-1.66 1.65Z",
    fill: "#CBCBD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M43.06 7.85H16.01c-.92 0-1.66-.74-1.66-1.65 0-.9.74-1.65 1.66-1.65h27.05c.92 0 1.66.75 1.66 1.65 0 .9-.74 1.65-1.66 1.65Z",
    fill: "#CACAD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M43.06 7.84H16c-.91 0-1.66-.74-1.66-1.64 0-.9.75-1.65 1.66-1.65h27.05c.9 0 1.65.74 1.65 1.65 0 .9-.74 1.64-1.65 1.64Z",
    fill: "#C9C9D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M43.05 7.83H16c-.9 0-1.64-.73-1.64-1.64 0-.9.74-1.64 1.64-1.64h27.05c.9 0 1.65.74 1.65 1.64 0 .9-.74 1.64-1.65 1.64Z",
    fill: "#C8C8D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M43.04 7.82H16c-.9 0-1.64-.73-1.64-1.63 0-.9.74-1.64 1.64-1.64h27.04c.9 0 1.64.74 1.64 1.64 0 .9-.74 1.63-1.64 1.63Z",
    fill: "#C7C7D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M43.04 7.81H16c-.9 0-1.64-.73-1.64-1.62 0-.9.74-1.63 1.64-1.63h27.04c.9 0 1.63.73 1.63 1.63 0 .89-.73 1.62-1.63 1.62Z",
    fill: "#C6C6D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M43.03 7.8H16c-.9 0-1.64-.73-1.64-1.62 0-.9.74-1.62 1.64-1.62h27.02c.9 0 1.64.73 1.64 1.62 0 .9-.73 1.62-1.63 1.62Z",
    fill: "#C5C5D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M43.02 7.8H16c-.9 0-1.63-.73-1.63-1.62 0-.9.73-1.62 1.63-1.62h27.02c.9 0 1.63.73 1.63 1.62 0 .89-.73 1.61-1.63 1.61Z",
    fill: "#C4C4D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M43.01 7.79H16c-.89 0-1.62-.73-1.62-1.62 0-.88.73-1.61 1.62-1.61h27.02c.9 0 1.63.73 1.63 1.61 0 .89-.74 1.62-1.63 1.62Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M43 7.78H16c-.89 0-1.62-.73-1.62-1.61 0-.89.73-1.61 1.62-1.61H43c.9 0 1.62.72 1.62 1.6 0 .9-.73 1.62-1.62 1.62Z",
    fill: "#C2C2CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M43 7.77H15.99c-.89 0-1.62-.73-1.62-1.6 0-.89.73-1.61 1.62-1.61h27c.9 0 1.62.72 1.62 1.6 0 .88-.73 1.6-1.61 1.6Z",
    fill: "#C1C1CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M42.99 7.76h-27a1.6 1.6 0 0 1-1.61-1.6c0-.88.72-1.6 1.6-1.6H43c.88 0 1.6.72 1.6 1.6.01.88-.72 1.6-1.6 1.6Z",
    fill: "#C0C0CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M42.98 7.75h-27a1.6 1.6 0 0 1-1.6-1.6c0-.87.73-1.59 1.6-1.59h27c.89 0 1.6.72 1.6 1.6 0 .87-.72 1.59-1.6 1.59Z",
    fill: "#BFBFCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M42.98 7.74h-27a1.6 1.6 0 0 1-1.6-1.6c0-.87.72-1.58 1.6-1.58h27c.88 0 1.6.71 1.6 1.59a1.6 1.6 0 0 1-1.6 1.59Z",
    fill: "#BEBECB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M42.97 7.73H15.98a1.6 1.6 0 0 1-1.6-1.59c0-.87.72-1.58 1.6-1.58h26.99c.88 0 1.6.71 1.6 1.58a1.6 1.6 0 0 1-1.6 1.59Z",
    fill: "#BDBDCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M42.96 7.72H15.98c-.88 0-1.6-.71-1.6-1.58 0-.87.72-1.58 1.6-1.58h26.98c.88 0 1.6.71 1.6 1.58 0 .87-.72 1.58-1.6 1.58Z",
    fill: "#BCBCC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M42.95 7.71H15.98c-.88 0-1.59-.7-1.59-1.57 0-.87.71-1.58 1.59-1.58h26.97c.88 0 1.59.7 1.59 1.58 0 .86-.71 1.57-1.59 1.57Z",
    fill: "#BBBBC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M42.95 7.7H15.98c-.87 0-1.58-.7-1.58-1.57 0-.86.7-1.57 1.58-1.57h26.97c.87 0 1.58.7 1.58 1.57 0 .86-.71 1.57-1.58 1.57Z",
    fill: "#BABAC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M42.94 7.69H15.97c-.86 0-1.57-.7-1.57-1.57 0-.86.7-1.56 1.57-1.56h26.97c.87 0 1.57.7 1.57 1.56 0 .87-.7 1.57-1.57 1.57Z",
    fill: "#B9B9C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M42.93 7.68H15.97c-.86 0-1.57-.7-1.57-1.56 0-.85.7-1.56 1.57-1.56h26.96c.86 0 1.57.7 1.57 1.56 0 .86-.7 1.56-1.57 1.56Z",
    fill: "#B8B8C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M42.93 7.67H15.97c-.86 0-1.57-.7-1.57-1.55 0-.86.7-1.56 1.57-1.56h26.95c.86 0 1.57.7 1.57 1.56 0 .85-.7 1.55-1.56 1.55Z",
    fill: "#B7B7C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M42.92 7.66H15.97c-.86 0-1.56-.7-1.56-1.55 0-.85.7-1.55 1.56-1.55h26.95c.85 0 1.56.7 1.56 1.55 0 .85-.7 1.55-1.56 1.55Z",
    fill: "#B6B6C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M42.91 7.65H15.97c-.86 0-1.56-.7-1.56-1.54 0-.85.7-1.55 1.56-1.55H42.9c.86 0 1.56.7 1.56 1.55 0 .85-.7 1.54-1.56 1.54Z",
    fill: "#B5B5C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M42.9 7.64H15.96c-.85 0-1.55-.69-1.55-1.54 0-.84.7-1.54 1.55-1.54H42.9c.86 0 1.55.7 1.55 1.54 0 .85-.7 1.54-1.55 1.54Z",
    fill: "#B4B4C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M42.9 7.63H15.96c-.85 0-1.54-.69-1.54-1.53 0-.84.7-1.54 1.54-1.54H42.9c.84 0 1.54.7 1.54 1.54 0 .84-.7 1.53-1.54 1.53Z",
    fill: "#B3B3C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M42.89 7.62H15.96c-.85 0-1.54-.68-1.54-1.53 0-.84.7-1.53 1.54-1.53h26.93c.85 0 1.54.7 1.54 1.53 0 .85-.7 1.53-1.54 1.53Z",
    fill: "#B2B2C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M42.88 7.62H15.96c-.85 0-1.54-.69-1.54-1.53 0-.84.7-1.52 1.54-1.52h26.92c.85 0 1.54.68 1.54 1.52s-.7 1.53-1.54 1.53Z",
    fill: "#B1B1C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M42.87 7.6H15.96c-.85 0-1.54-.68-1.54-1.52 0-.83.7-1.52 1.54-1.52h26.92c.84 0 1.53.69 1.53 1.52 0 .84-.7 1.53-1.54 1.53Z",
    fill: "#B0B0C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M42.87 7.6H15.95c-.84 0-1.52-.69-1.52-1.52 0-.83.68-1.52 1.52-1.52h26.92c.84 0 1.52.69 1.52 1.52 0 .84-.69 1.52-1.52 1.52Z",
    fill: "#AFAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M42.86 7.59h-26.9c-.85 0-1.53-.68-1.53-1.51s.68-1.52 1.52-1.52h26.91c.84 0 1.52.69 1.52 1.52 0 .83-.69 1.5-1.52 1.5Z",
    fill: "#AEAEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M42.85 7.58h-26.9c-.84 0-1.52-.68-1.52-1.5 0-.84.68-1.52 1.52-1.52h26.9c.83 0 1.52.68 1.52 1.51s-.68 1.5-1.52 1.5Z",
    fill: "#ADADBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M42.85 7.57h-26.9c-.83 0-1.51-.68-1.51-1.5 0-.83.68-1.5 1.5-1.5h26.9c.84 0 1.52.67 1.52 1.5 0 .82-.68 1.5-1.51 1.5Z",
    fill: "#ACACBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M42.84 7.56h-26.9a1.5 1.5 0 0 1-1.5-1.5c0-.82.68-1.5 1.5-1.5h26.9c.83 0 1.5.68 1.5 1.5 0 .83-.67 1.5-1.5 1.5Z",
    fill: "#ABABBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M42.83 7.55H15.94a1.5 1.5 0 0 1-1.5-1.5c0-.81.68-1.48 1.5-1.48h26.89c.83 0 1.5.67 1.5 1.49s-.67 1.5-1.5 1.5Z",
    fill: "#AAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M42.82 7.54H15.94a1.5 1.5 0 0 1-1.5-1.49c0-.81.68-1.48 1.5-1.48h26.88c.83 0 1.5.67 1.5 1.48a1.5 1.5 0 0 1-1.5 1.5Z",
    fill: "#A9A9BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M42.81 7.53H15.94a1.5 1.5 0 0 1-1.5-1.48c0-.81.68-1.48 1.5-1.48h26.88c.81 0 1.49.67 1.49 1.48 0 .82-.67 1.48-1.5 1.48Z",
    fill: "#A8A8BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M42.8 7.52H15.95c-.82 0-1.49-.66-1.49-1.48 0-.8.67-1.47 1.49-1.47H42.8c.81 0 1.48.66 1.48 1.47 0 .82-.66 1.48-1.48 1.48Z",
    fill: "#A7A7B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M42.8 7.51H15.94c-.82 0-1.48-.66-1.48-1.47 0-.8.66-1.47 1.48-1.47H42.8c.82 0 1.48.66 1.48 1.47 0 .81-.66 1.47-1.48 1.47Z",
    fill: "#A6A6B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M42.8 7.5H15.92c-.8 0-1.47-.66-1.47-1.46 0-.81.66-1.47 1.47-1.47H42.8c.82 0 1.48.66 1.48 1.47 0 .8-.66 1.46-1.48 1.46Z",
    fill: "#A5A5B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M42.79 7.5H15.93c-.8 0-1.47-.66-1.47-1.47 0-.8.66-1.46 1.47-1.46h26.86c.8 0 1.47.66 1.47 1.46 0 .8-.67 1.46-1.47 1.46Z",
    fill: "#A4A4B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M42.78 7.49H15.93c-.8 0-1.47-.66-1.47-1.46 0-.8.66-1.46 1.47-1.46h26.85c.8 0 1.47.66 1.47 1.46 0 .8-.66 1.46-1.47 1.46Z",
    fill: "#A3A3B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M42.77 7.48H15.93c-.8 0-1.47-.66-1.47-1.46 0-.8.66-1.45 1.47-1.45h26.84c.8 0 1.46.65 1.46 1.45 0 .8-.65 1.46-1.46 1.46Z",
    fill: "#A2A2B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M42.76 7.47H15.92c-.8 0-1.45-.66-1.45-1.45 0-.8.65-1.45 1.45-1.45h26.84c.8 0 1.46.65 1.46 1.45 0 .8-.66 1.45-1.46 1.45Z",
    fill: "#A1A1B4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M42.76 7.46H15.92c-.8 0-1.45-.65-1.45-1.45 0-.8.65-1.44 1.45-1.44h26.84c.8 0 1.45.65 1.45 1.44 0 .8-.66 1.45-1.45 1.45Z",
    fill: "#A0A0B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M42.75 7.45H15.92c-.8 0-1.45-.65-1.45-1.44 0-.8.65-1.44 1.45-1.44h26.83c.8 0 1.45.65 1.45 1.44 0 .79-.65 1.44-1.45 1.44Z",
    fill: "#9F9FB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M42.74 7.44H15.92c-.8 0-1.45-.65-1.45-1.44 0-.78.65-1.43 1.45-1.43h26.82c.8 0 1.44.65 1.44 1.43 0 .8-.64 1.44-1.44 1.44Z",
    fill: "#9E9EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.74 7.43H15.92c-.8 0-1.44-.64-1.44-1.43 0-.79.65-1.43 1.44-1.43h26.82c.79 0 1.43.64 1.43 1.43 0 .79-.64 1.43-1.43 1.43Z",
    fill: "#9D9DB1"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M42.72 7.43h-27.1c-.8 0-1.46-.65-1.46-1.45 0-.8.65-1.45 1.46-1.45h27.1c.8 0 1.45.66 1.45 1.45 0 .8-.65 1.45-1.45 1.45Z",
    fill: "url(#c)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M20.52 6.8H16.6a.59.59 0 1 1 0-1.18h3.9a.6.6 0 1 1 0 1.17Z",
    fill: "#FEFEFE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M20.51 6.79h-3.9a.58.58 0 0 1-.6-.58c0-.32.27-.58.6-.58h3.9c.33 0 .59.26.59.58 0 .32-.26.58-.59.58Z",
    fill: "#FDFDFD"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M20.51 6.79h-3.9a.58.58 0 0 1-.6-.58c0-.32.27-.58.6-.58h3.9c.32 0 .58.26.58.58 0 .32-.26.58-.58.58Z",
    fill: "#FCFCFC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M20.51 6.78h-3.9a.58.58 0 1 1 0-1.15h3.9a.58.58 0 1 1 0 1.15Z",
    fill: "#FBFBFB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M20.5 6.78h-3.9a.57.57 0 1 1 0-1.15h3.9c.32 0 .58.26.58.57 0 .32-.26.58-.57.58Z",
    fill: "#FBFAFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M20.5 6.77h-3.9a.57.57 0 0 1-.57-.57c0-.31.26-.57.57-.57h3.9a.57.57 0 1 1 0 1.13Z",
    fill: "#FAF9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.5 6.76h-3.9a.56.56 0 0 1-.56-.56c0-.3.25-.56.56-.56h3.9c.32 0 .57.25.57.56 0 .31-.25.56-.57.56Z",
    fill: "#F9F8F8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M20.5 6.76h-3.9a.56.56 0 0 1-.56-.56c0-.3.25-.56.56-.56h3.9c.31 0 .56.25.56.56 0 .3-.25.56-.56.56Z",
    fill: "#F8F7F7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M20.5 6.75h-3.9a.56.56 0 0 1-.56-.55c0-.31.25-.56.56-.56h3.9c.3 0 .56.25.56.56 0 .3-.25.55-.56.55Z",
    fill: "#F7F6F6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M20.5 6.74h-3.9a.55.55 0 0 1-.56-.55c0-.3.25-.55.56-.55h3.9c.3 0 .55.25.55.55 0 .3-.25.55-.55.55Z",
    fill: "#F6F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.5 6.74h-3.9a.55.55 0 1 1 0-1.1h3.9a.55.55 0 1 1 0 1.1Z",
    fill: "#F5F4F4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M20.5 6.73h-3.9a.54.54 0 1 1 0-1.08h3.9a.54.54 0 1 1 0 1.08Z",
    fill: "#F4F3F3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M20.5 6.73h-3.9a.54.54 0 0 1-.55-.54c0-.3.25-.54.55-.54h3.9c.3 0 .54.24.54.54 0 .3-.25.54-.55.54Z",
    fill: "#F3F2F3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M20.5 6.72h-3.9a.54.54 0 0 1-.54-.53c0-.3.24-.54.54-.54h3.9c.29 0 .53.24.53.54 0 .3-.24.53-.54.53Z",
    fill: "#F3F1F2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M20.49 6.72h-3.9a.53.53 0 0 1-.53-.53c0-.3.24-.54.54-.54h3.89c.3 0 .53.24.53.53 0 .3-.23.54-.53.54Z",
    fill: "#F2F0F1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M20.49 6.71h-3.9a.53.53 0 0 1-.52-.53c0-.29.23-.53.53-.53h3.89a.53.53 0 1 1 0 1.06Z",
    fill: "#F1EFF0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M20.49 6.7h-3.9a.53.53 0 1 1 0-1.05h3.9c.29 0 .52.24.52.53 0 .29-.23.52-.52.52Z",
    fill: "#F0EEEF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M20.48 6.7H16.6a.52.52 0 1 1 0-1.04h3.9a.52.52 0 1 1 0 1.04Z",
    fill: "#EFEDEE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M20.48 6.7H16.6a.52.52 0 0 1-.51-.52c0-.29.23-.52.51-.52h3.9c.28 0 .5.24.5.52.01.28-.22.51-.5.51Z",
    fill: "#EEECED"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M20.48 6.69H16.6a.51.51 0 0 1-.51-.51c0-.29.23-.52.51-.52h3.9c.28 0 .5.23.5.52 0 .28-.22.5-.5.5Z",
    fill: "#EDEBEC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M20.48 6.68h-3.89a.5.5 0 0 1-.5-.5c0-.29.22-.51.5-.51h3.89a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.51Z",
    fill: "#ECEAEB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M20.48 6.68h-3.89a.5.5 0 0 1-.5-.5v-.01c0-.28.22-.5.5-.5h3.89c.28 0 .5.22.5.5a.5.5 0 0 1-.5.5Z",
    fill: "#EBE9EA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M20.48 6.67h-3.89a.5.5 0 0 1-.5-.5c0-.28.23-.5.5-.5h3.89a.5.5 0 1 1 0 1Z",
    fill: "#EBE8E9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M20.47 6.66H16.6a.5.5 0 1 1 0-1h3.88c.28.01.5.24.5.5v.01a.5.5 0 0 1-.5.5Z",
    fill: "#EAE7E8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.47 6.66H16.6a.5.5 0 1 1 0-.99h3.88c.28 0 .5.22.5.5a.5.5 0 0 1-.5.49Z",
    fill: "#E9E6E7"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M20.47 6.65H16.6a.49.49 0 0 1-.49-.48c0-.27.22-.5.5-.5h3.87c.27 0 .5.23.5.5 0 .26-.23.48-.5.48Z",
    fill: "#E8E5E6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M20.47 6.65h-3.88a.49.49 0 0 1-.49-.49c0-.27.22-.48.49-.48h3.88c.27 0 .49.21.49.48s-.22.49-.5.49Z",
    fill: "#E7E4E5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M20.47 6.64h-3.88a.48.48 0 1 1 0-.96h3.88a.48.48 0 1 1 0 .96Z",
    fill: "#E6E3E4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.47 6.64h-3.88a.48.48 0 1 1 0-.96h3.88c.26 0 .48.21.48.48 0 .26-.22.48-.48.48Z",
    fill: "#E5E2E3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M20.46 6.63H16.6a.47.47 0 0 1-.48-.47c0-.26.22-.48.48-.48h3.87c.26 0 .48.22.48.48s-.22.47-.48.47Z",
    fill: "#E4E1E2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M20.46 6.62H16.6a.47.47 0 0 1-.47-.46c0-.26.2-.47.47-.47h3.87c.26 0 .47.2.47.47 0 .25-.2.46-.47.46Z",
    fill: "#E3E0E1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M20.46 6.62H16.6a.46.46 0 1 1 0-.93h3.87c.26 0 .47.2.47.46s-.21.47-.47.47Z",
    fill: "#E3DFE0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M20.46 6.61h-3.88a.46.46 0 0 1-.46-.45v-.01c0-.25.21-.46.46-.46h3.88a.46.46 0 1 1 0 .92Z",
    fill: "#E2DEDF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M20.46 6.6h-3.87a.46.46 0 0 1-.46-.45c0-.25.2-.46.46-.46h3.87a.46.46 0 1 1 0 .91Z",
    fill: "#E1DDDE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M20.46 6.6h-3.88a.45.45 0 1 1 0-.9h3.88c.25 0 .45.2.45.45s-.2.45-.45.45Z",
    fill: "#E0DCDD"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.45 6.6H16.6a.45.45 0 1 1 0-.9h3.86a.45.45 0 1 1 0 .9Z",
    fill: "#DFDCDD"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M20.45 6.59h-3.87a.45.45 0 0 1-.44-.44c0-.25.2-.45.44-.45h3.87c.25 0 .45.2.45.44 0 .25-.2.45-.45.45Z",
    fill: "#DEDBDC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M20.45 6.58h-3.87a.44.44 0 0 1-.44-.43c0-.25.2-.45.44-.45h3.87c.24 0 .44.2.44.44 0 .25-.2.44-.44.44Z",
    fill: "#DDDADB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M20.45 6.58h-3.87a.44.44 0 0 1-.44-.44c0-.24.2-.44.44-.44h3.87a.44.44 0 1 1 0 .87Z",
    fill: "#DCD9DA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M20.45 6.57h-3.87a.43.43 0 1 1 0-.86h3.87c.24 0 .43.2.43.43 0 .24-.2.43-.43.43Z",
    fill: "#DBD8D9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M20.45 6.57h-3.87a.43.43 0 1 1 0-.86h3.87c.24 0 .43.19.43.42 0 .24-.2.44-.43.44Z",
    fill: "#DBD7D8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M20.44 6.56h-3.86a.42.42 0 1 1 0-.85h3.86c.24 0 .43.19.43.42 0 .24-.2.43-.43.43Z",
    fill: "#DAD6D7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.44 6.56h-3.86a.42.42 0 0 1-.42-.42c0-.24.19-.43.42-.43h3.86a.42.42 0 1 1 0 .84Z",
    fill: "#D9D5D6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M20.44 6.55h-3.86a.42.42 0 0 1-.42-.42c0-.23.19-.42.42-.42h3.86a.42.42 0 1 1 0 .84Z",
    fill: "#D8D4D5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M20.44 6.54h-3.86a.41.41 0 0 1-.41-.4v-.01c0-.23.18-.41.4-.41h3.87c.23 0 .41.18.41.4v.01c0 .23-.18.41-.41.41Z",
    fill: "#D7D3D4"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M20.44 6.54h-3.86a.4.4 0 0 1-.41-.41c0-.23.18-.41.4-.41h3.87a.4.4 0 0 1 .4.4v.01a.4.4 0 0 1-.4.4Z",
    fill: "#D6D2D3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M20.44 6.53h-3.86a.4.4 0 0 1-.4-.4c0-.23.18-.4.4-.4h3.86c.22 0 .4.17.4.4a.4.4 0 0 1-.4.4Z",
    fill: "#D5D1D2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M20.43 6.53h-3.85a.4.4 0 0 1-.4-.4v-.01c0-.22.17-.4.4-.4h3.85c.23 0 .4.18.4.4a.4.4 0 0 1-.4.4Z",
    fill: "#D4D0D1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M20.43 6.52h-3.85a.4.4 0 1 1 0-.8h3.85c.22 0 .4.18.4.4a.4.4 0 0 1-.4.4Z",
    fill: "#D3CFD0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M20.43 6.52h-3.85a.4.4 0 0 1-.4-.4c0-.22.18-.4.4-.4h3.85c.22 0 .4.19.4.4a.4.4 0 0 1-.4.4Z",
    fill: "#D3CECF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M20.43 6.51h-3.85a.39.39 0 0 1-.4-.39c0-.22.18-.4.4-.4h3.85c.21 0 .39.18.39.4 0 .22-.18.4-.4.4Z",
    fill: "#D2CDCE"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M20.43 6.5h-3.86a.38.38 0 1 1 0-.77h3.86c.2 0 .38.17.38.38v.01c0 .21-.17.38-.38.38Z",
    fill: "#D1CCCD"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M20.43 6.5h-3.86a.38.38 0 1 1 0-.77h3.86c.2 0 .38.17.38.38 0 .22-.17.39-.38.39Z",
    fill: "#D0CBCC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M20.42 6.5h-3.85a.38.38 0 0 1-.37-.38c0-.21.17-.38.38-.38h3.84c.21 0 .38.17.38.37 0 .21-.17.38-.38.38Z",
    fill: "#CFCACB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M20.42 6.49h-3.85a.37.37 0 0 1-.37-.38c0-.2.17-.37.37-.37h3.85c.2 0 .37.17.37.37 0 .2-.16.38-.37.38Z",
    fill: "#CEC9CA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M20.42 6.48h-3.84a.37.37 0 1 1 0-.74h3.84c.2 0 .37.16.37.37 0 .2-.17.37-.37.37Z",
    fill: "#CDC8C9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M20.42 6.48h-3.85a.36.36 0 0 1-.36-.37c0-.2.16-.37.36-.37h3.85c.2 0 .36.17.36.37 0 .2-.16.37-.36.37Z",
    fill: "#CCC7C8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M20.42 6.47h-3.85a.36.36 0 0 1-.36-.36c0-.2.16-.37.36-.37h3.85c.2 0 .36.17.36.36v.01c0 .2-.16.36-.36.36Z",
    fill: "#CBC6C7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M20.41 6.46h-3.84a.36.36 0 1 1 0-.72h3.84c.2 0 .36.17.36.36 0 .2-.16.36-.36.36Z",
    fill: "#CBC5C6"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M20.41 6.46h-3.84a.35.35 0 1 1 0-.71h3.84c.2 0 .36.15.36.35 0 .2-.16.36-.36.36Z",
    fill: "#CAC4C6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M20.41 6.45h-3.84a.35.35 0 0 1-.35-.35c0-.2.16-.35.35-.35h3.84a.35.35 0 1 1 0 .7Z",
    fill: "#C9C3C5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M20.4 6.45h-3.83a.34.34 0 0 1-.35-.35c0-.2.16-.35.35-.35h3.84c.19 0 .34.16.34.35 0 .2-.15.35-.34.35Z",
    fill: "#C8C2C4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M20.4 6.44h-3.83a.34.34 0 0 1-.34-.34c0-.2.15-.35.34-.35h3.84c.19 0 .34.16.34.34v.01c0 .19-.15.34-.34.34Z",
    fill: "#C7C1C3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M20.4 6.43h-3.83a.34.34 0 1 1 0-.68h3.84c.19 0 .33.16.33.34v.01c0 .18-.15.33-.33.33Z",
    fill: "#C6C0C2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M20.4 6.43h-3.83a.33.33 0 1 1 0-.67h3.83c.19 0 .34.15.34.33 0 .2-.15.34-.34.34Z",
    fill: "#C5BFC1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M20.4 6.42h-3.83a.33.33 0 1 1 0-.66h3.83c.19 0 .33.15.33.33 0 .19-.14.33-.33.33Z",
    fill: "#C4BEC0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M20.4 6.42h-3.83a.32.32 0 0 1-.33-.33c0-.18.15-.32.33-.32h3.83c.18 0 .32.14.32.32s-.14.33-.32.33Z",
    fill: "#C3BDBF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M20.4 6.41h-3.84a.32.32 0 0 1-.32-.32c0-.18.15-.33.32-.33h3.84c.17 0 .32.15.32.32v.01c0 .18-.15.32-.32.32Z",
    fill: "#C3BCBE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M20.4 6.4h-3.83a.32.32 0 0 1-.32-.31c0-.18.14-.32.32-.32h3.83c.17 0 .31.14.31.31v.01c0 .17-.14.31-.31.31Z",
    fill: "#C2BBBD"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M20.4 6.4h-3.84a.31.31 0 0 1-.31-.31v-.01c0-.17.14-.31.31-.31h3.83c.18 0 .32.14.32.31 0 .18-.14.32-.32.32Z",
    fill: "#C1BABC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M20.4 6.4h-3.83a.31.31 0 0 1-.31-.31v-.01c0-.17.14-.3.3-.3h3.83c.17 0 .31.13.31.3a.3.3 0 0 1-.3.31Z",
    fill: "#C0B9BB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 6.39h-3.84a.3.3 0 0 1-.3-.3v-.01c0-.17.13-.3.3-.3h3.83c.17 0 .3.13.3.3a.3.3 0 0 1-.3.31Z",
    fill: "#BFB8BA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.4h-4a.35.35 0 0 1-.35-.34c0-.2.16-.35.35-.35h4c.19 0 .35.16.35.35 0 .2-.16.35-.35.35Z",
    fill: "#687BC1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.4h-4a.34.34 0 0 1-.34-.34c0-.19.15-.34.34-.34h4c.19 0 .34.15.34.34 0 .19-.15.34-.34.34Z",
    fill: "#697CC2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.4h-4a.34.34 0 0 1-.34-.34c0-.19.15-.34.34-.34h4a.34.34 0 1 1 0 .68Z",
    fill: "#697CC3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.39h-4a.34.34 0 1 1 0-.67h4c.19 0 .34.15.34.33 0 .19-.15.34-.33.34Z",
    fill: "#6A7DC4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.38h-4a.33.33 0 0 1-.34-.33c0-.18.15-.33.33-.33h4.01c.19 0 .34.15.34.33 0 .18-.15.33-.34.33Z",
    fill: "#6A7DC5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.37h-4a.33.33 0 0 1-.34-.32c0-.18.15-.33.33-.33h4.02c.18 0 .32.15.32.33 0 .18-.14.32-.32.32Z",
    fill: "#6B7EC6"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.37H16.5a.32.32 0 0 1-.32-.32c0-.18.14-.32.32-.32h4.02c.18 0 .32.14.32.32 0 .17-.14.32-.32.32Z",
    fill: "#6B7EC7"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 6.36H16.5a.32.32 0 0 1-.32-.32c0-.17.14-.31.32-.31h4.02c.18 0 .32.14.32.31 0 .18-.14.32-.32.32Z",
    fill: "#6C7FC8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 6.35h-4.03a.31.31 0 0 1-.31-.31c0-.17.14-.31.31-.31h4.03c.17 0 .32.14.32.3 0 .18-.15.32-.32.32Z",
    fill: "#6C80C9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.34h-4.04a.3.3 0 1 1 0-.61h4.04a.3.3 0 1 1 0 .61Z",
    fill: "#6D80CA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.34h-4.04a.3.3 0 0 1-.3-.3c0-.17.13-.3.3-.3h4.04c.16 0 .3.13.3.3a.3.3 0 0 1-.3.3Z",
    fill: "#6D81CB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.33h-4.05a.3.3 0 0 1-.3-.3c0-.16.14-.3.3-.3h4.05c.16 0 .3.14.3.3a.3.3 0 0 1-.3.3Z",
    fill: "#6E81CC"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.32h-4.05a.3.3 0 0 1-.3-.29c0-.16.14-.3.3-.3h4.05c.16 0 .3.14.3.3a.3.3 0 0 1-.3.3Z",
    fill: "#6E82CD"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.32h-4.05a.3.3 0 0 1-.3-.3.3.3 0 0 1 .3-.28h4.05c.16 0 .3.13.3.29a.3.3 0 0 1-.3.29Z",
    fill: "#6F82CE"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 6.3h-4.07a.29.29 0 1 1 0-.56h4.07c.15 0 .28.13.28.28 0 .16-.13.29-.28.29Z",
    fill: "#6F83CF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 6.3h-4.07a.28.28 0 0 1-.28-.28c0-.15.12-.28.28-.28h4.07c.15 0 .28.13.28.28 0 .16-.13.28-.28.28Z",
    fill: "#7083D0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 6.3h-4.07a.28.28 0 0 1-.28-.28c0-.15.12-.27.28-.27h4.07c.15 0 .27.12.27.27 0 .15-.12.28-.27.28Z",
    fill: "#7084D1"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 6.29h-4.08a.27.27 0 0 1-.27-.27c0-.15.12-.27.27-.27h4.08c.15 0 .27.12.27.27 0 .15-.12.27-.27.27Z",
    fill: "#7185D2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 6.28h-4.08a.27.27 0 0 1-.27-.27c0-.14.12-.26.27-.26h4.08c.15 0 .27.12.27.26 0 .15-.12.27-.27.27Z",
    fill: "#7185D3"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 6.27h-4.08a.26.26 0 1 1 0-.52h4.08a.26.26 0 1 1 0 .52Z",
    fill: "#7286D4"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 6.27h-4.1A.26.26 0 0 1 16.2 6c0-.14.11-.26.25-.26h4.1c.14 0 .25.12.25.26s-.11.26-.25.26Z",
    fill: "#7286D5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 6.26h-4.1a.25.25 0 0 1-.25-.25c0-.14.11-.25.25-.25h4.1c.14 0 .25.11.25.25s-.11.25-.25.25Z",
    fill: "#7387D6"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 6.25h-4.1a.25.25 0 0 1-.25-.24c0-.14.1-.25.25-.25h4.1c.13 0 .25.11.25.25 0 .13-.11.24-.25.24Z",
    fill: "#7387D7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 6.25h-4.1a.25.25 0 0 1-.25-.25c0-.13.1-.24.24-.24h4.11c.13 0 .25.1.25.24 0 .14-.12.25-.25.25Z",
    fill: "#7488D8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 6.24h-4.11a.24.24 0 1 1 0-.48h4.11a.24.24 0 1 1 0 .48Z",
    fill: "#7489D9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 6.23h-4.12A.24.24 0 0 1 16.2 6c0-.13.1-.24.23-.24h4.12c.12 0 .23.11.23.24s-.1.23-.23.23Z",
    fill: "#7589DA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 6.23h-4.12A.23.23 0 0 1 16.2 6c0-.13.1-.23.23-.23h4.12a.23.23 0 1 1 0 .46Z",
    fill: "#758ADB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 6.22h-4.13a.23.23 0 0 1-.22-.23c0-.12.1-.22.22-.22h4.13c.12 0 .22.1.22.22 0 .13-.1.23-.22.23Z",
    fill: "#768ADC"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 6.21h-4.13A.22.22 0 0 1 16.2 6c0-.12.1-.22.22-.22h4.13c.12 0 .22.1.22.22s-.1.22-.22.22Z",
    fill: "#768BDC"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 6.2h-4.13A.22.22 0 0 1 16.2 6c0-.12.1-.22.22-.22h4.13c.12 0 .22.1.22.22s-.1.22-.22.22Z",
    fill: "#778BDD"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 6.2h-4.14a.21.21 0 0 1-.21-.21c0-.12.1-.22.21-.22h4.14c.12 0 .21.1.21.22 0 .11-.09.2-.2.2Z",
    fill: "#778CDE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 6.19H16.4a.2.2 0 0 1-.2-.2c0-.12.09-.21.2-.21h4.15c.11 0 .2.09.2.2 0 .12-.09.21-.2.21Z",
    fill: "#788CDF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 6.18H16.4a.2.2 0 0 1-.2-.2c0-.11.09-.2.2-.2h4.15c.1 0 .2.09.2.2 0 .11-.1.2-.2.2Z",
    fill: "#788DE0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 6.18H16.4a.2.2 0 0 1-.2-.2c0-.11.1-.2.2-.2h4.16c.1 0 .2.09.2.2 0 .1-.1.2-.2.2Z",
    fill: "#798EE1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 6.17H16.4a.2.2 0 0 1-.2-.2c0-.1.1-.19.2-.19h4.16c.1 0 .2.09.2.2 0 .1-.1.19-.2.19Z",
    fill: "#798EE2"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 6.16H16.4a.2.2 0 0 1-.2-.19c0-.1.1-.19.2-.19h4.16c.1 0 .2.09.2.2a.2.2 0 0 1-.2.18Z",
    fill: "#7A8FE3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.16H16.4a.19.19 0 0 1-.19-.19c0-.1.08-.18.19-.18h4.17c.1 0 .18.08.18.18 0 .1-.08.19-.18.19Z",
    fill: "#7A8FE4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.15h-4.18a.18.18 0 0 1-.18-.18c0-.1.08-.18.18-.18h4.18c.1 0 .18.08.18.18 0 .1-.08.18-.18.18Z",
    fill: "#7B90E5"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.14h-4.18a.17.17 0 0 1-.18-.17c0-.1.08-.18.18-.18h4.18c.1 0 .17.08.17.18 0 .1-.08.17-.17.17Z",
    fill: "#7B90E6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.14H16.4a.17.17 0 0 1-.18-.18c0-.09.08-.17.18-.17h4.18c.1 0 .17.08.17.17 0 .1-.08.18-.17.18Z",
    fill: "#7C91E7"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.13h-4.19a.17.17 0 1 1 0-.34h4.2a.17.17 0 1 1 0 .34Z",
    fill: "#7C92E8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.12h-4.2a.16.16 0 0 1-.16-.16c0-.09.08-.16.17-.16h4.2c.08 0 .15.07.15.16s-.07.16-.16.16Z",
    fill: "#7D92E9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 6.11h-4.2a.16.16 0 0 1-.15-.15c0-.09.07-.16.15-.16h4.2c.1 0 .16.07.16.16 0 .08-.07.15-.16.15Z",
    fill: "#7D93EA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 6.1h-4.2a.15.15 0 0 1-.16-.14c0-.09.07-.16.15-.16h4.2c.1 0 .16.07.16.16 0 .08-.07.15-.15.15Z",
    fill: "#7E93EB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 6.1h-4.21a.15.15 0 0 1-.15-.15c0-.08.06-.15.15-.15h4.2c.09 0 .16.07.16.15 0 .08-.07.15-.15.15Z",
    fill: "#7E94EC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 6.1h-4.21a.14.14 0 1 1 0-.3h4.21c.08 0 .15.07.15.15 0 .08-.07.14-.15.14Z",
    fill: "#7F94ED"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 6.08h-4.22a.14.14 0 0 1-.14-.13c0-.08.07-.14.14-.14h4.22c.08 0 .14.06.14.14 0 .07-.06.13-.14.13Z",
    fill: "#7F95EE"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 6.08h-4.22a.13.13 0 0 1-.14-.14c0-.07.07-.13.14-.13h4.22c.08 0 .14.06.14.13 0 .08-.06.14-.14.14Z",
    fill: "#8095EF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 6.07h-4.23a.13.13 0 0 1-.13-.13c0-.07.06-.13.13-.13h4.23c.07 0 .13.06.13.13s-.06.13-.13.13Z",
    fill: "#8096F0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 6.06h-4.23a.13.13 0 0 1-.13-.12c0-.07.05-.13.13-.13h4.23c.07 0 .13.06.13.13s-.06.12-.13.12Z",
    fill: "#8197F1"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.06h-4.25a.12.12 0 0 1-.12-.12c0-.07.05-.13.12-.13h4.24c.07 0 .12.06.12.13 0 .06-.05.12-.12.12Z",
    fill: "#8197F2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.05h-4.25a.12.12 0 0 1-.12-.12c0-.06.05-.11.12-.11h4.24c.06 0 .12.05.12.11 0 .07-.05.12-.12.12Z",
    fill: "#8298F3"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.04h-4.26a.11.11 0 0 1-.1-.1c0-.07.04-.12.1-.12h4.25a.11.11 0 1 1 0 .22Z",
    fill: "#8298F4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.04h-4.26a.1.1 0 0 1-.1-.1v-.01c0-.06.04-.1.1-.1h4.26c.05 0 .1.04.1.1a.1.1 0 0 1-.1.1Z",
    fill: "#8399F5"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.03h-4.26a.1.1 0 0 1-.1-.1c0-.06.04-.11.1-.11h4.26c.05 0 .1.05.1.1a.1.1 0 0 1-.1.1Z",
    fill: "#8399F6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.02h-4.26a.1.1 0 0 1-.1-.1c0-.05.04-.1.1-.1h4.26c.05 0 .1.05.1.1a.1.1 0 0 1-.1.1Z",
    fill: "#849AF7"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M22 6.8h-.19a.44.44 0 0 1-.44-.44v-.3c0-.24.2-.43.44-.43h.2c.24 0 .43.2.43.43v.3c0 .24-.2.44-.44.44Z",
    fill: "#FEFEFE"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M22 6.79h-.19a.44.44 0 0 1-.44-.44v-.3c0-.23.2-.43.44-.43h.2c.24 0 .43.2.43.44v.3c0 .24-.2.43-.44.43Z",
    fill: "#FDFDFD"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M22 6.79h-.2a.43.43 0 0 1-.43-.44v-.3c0-.23.2-.42.44-.42h.2c.24 0 .43.19.43.43v.3c0 .23-.2.43-.44.43Z",
    fill: "#FCFCFC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M22 6.78h-.19a.43.43 0 0 1-.43-.43v-.29c0-.24.2-.43.43-.43h.2c.24 0 .43.2.43.43v.29c0 .24-.2.43-.43.43Z",
    fill: "#FBFBFB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M22 6.78h-.2a.43.43 0 0 1-.43-.44v-.28c0-.23.2-.43.44-.43h.2c.24 0 .43.2.43.43v.28c0 .24-.2.44-.43.44Z",
    fill: "#FBFAFA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M22 6.77h-.2a.43.43 0 0 1-.42-.43v-.28c0-.24.19-.43.43-.43h.2c.24 0 .43.2.43.43v.28c0 .24-.2.43-.43.43Z",
    fill: "#FAF9F9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22 6.76h-.2a.43.43 0 0 1-.42-.42v-.28c0-.23.19-.42.43-.42h.2c.23 0 .43.19.43.42v.28c0 .23-.2.42-.43.42Z",
    fill: "#F9F8F8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M22.01 6.76h-.2a.42.42 0 0 1-.43-.43v-.27c0-.23.19-.42.42-.42h.21c.24 0 .43.19.43.42v.27c0 .24-.2.43-.43.43Z",
    fill: "#F8F7F7"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M22.01 6.75h-.2a.42.42 0 0 1-.43-.42v-.27c0-.23.19-.42.42-.42h.21c.24 0 .43.19.43.42v.27c0 .23-.2.42-.43.42Z",
    fill: "#F7F6F6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M22.01 6.75h-.2a.42.42 0 0 1-.43-.43v-.26c0-.23.19-.42.42-.42h.21c.23 0 .42.19.42.42v.26c0 .24-.19.43-.42.43Z",
    fill: "#F6F5F5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.01 6.74h-.21a.42.42 0 0 1-.42-.42v-.26c0-.23.19-.41.42-.41h.21c.23 0 .42.18.42.41v.26c0 .23-.19.42-.42.42Z",
    fill: "#F5F4F4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M22.01 6.73h-.21a.42.42 0 0 1-.42-.41v-.25c0-.23.19-.42.42-.42H22c.23 0 .42.19.42.42v.25c0 .23-.19.41-.42.41Z",
    fill: "#F4F3F3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M22.01 6.73h-.21a.42.42 0 0 1-.42-.42v-.25c0-.23.19-.41.42-.41H22c.23 0 .42.18.42.41v.25c0 .23-.19.42-.42.42Z",
    fill: "#F3F2F3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M22.01 6.72h-.21a.41.41 0 0 1-.42-.41v-.25c0-.22.19-.4.42-.4H22c.23 0 .42.18.42.4v.25c0 .23-.19.41-.42.41Z",
    fill: "#F3F1F2"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M22.01 6.72h-.22a.41.41 0 0 1-.4-.41v-.24c0-.23.18-.41.4-.41h.22c.23 0 .42.18.42.4v.25c0 .22-.19.4-.42.4Z",
    fill: "#F2F0F1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M22.01 6.71h-.21a.41.41 0 0 1-.42-.41v-.24c0-.22.19-.4.42-.4H22c.23 0 .42.18.42.4v.24c0 .23-.19.41-.42.41Z",
    fill: "#F1EFF0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M22.01 6.7h-.22a.4.4 0 0 1-.4-.4v-.24c0-.22.18-.4.4-.4h.22a.4.4 0 0 1 .41.4v.24a.4.4 0 0 1-.4.4Z",
    fill: "#F0EEEF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M22.01 6.7h-.22a.4.4 0 0 1-.4-.4v-.23c0-.23.18-.4.4-.4h.22c.23 0 .41.17.41.4v.22a.4.4 0 0 1-.4.41Z",
    fill: "#EFEDEE"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M22.02 6.7h-.23a.4.4 0 0 1-.4-.4v-.23c0-.23.18-.4.4-.4h.23c.22 0 .4.18.4.4v.22a.4.4 0 0 1-.4.4Z",
    fill: "#EEECED"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M22.02 6.69h-.23a.4.4 0 0 1-.4-.4v-.23c0-.22.18-.4.4-.4h.23c.22 0 .4.18.4.4v.22a.4.4 0 0 1-.4.4Z",
    fill: "#EDEBEC"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M22.02 6.68h-.23a.4.4 0 0 1-.4-.4v-.21c0-.22.18-.4.4-.4h.23c.22 0 .4.18.4.4v.21a.4.4 0 0 1-.4.4Z",
    fill: "#ECEAEB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M22.02 6.68h-.23a.4.4 0 0 1-.4-.4v-.21c0-.22.18-.4.4-.4h.23c.22 0 .4.18.4.4v.2a.4.4 0 0 1-.4.4Z",
    fill: "#EBE9EA"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M22.02 6.67h-.23a.4.4 0 0 1-.4-.4v-.2c0-.22.18-.4.4-.4h.23c.22 0 .4.18.4.4v.2a.4.4 0 0 1-.4.4Z",
    fill: "#EBE8E9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M22.02 6.66h-.23a.4.4 0 0 1-.4-.4v-.2c0-.21.18-.39.4-.39h.23c.22 0 .4.18.4.4v.2a.4.4 0 0 1-.4.4Z",
    fill: "#EAE7E8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.02 6.66h-.23a.4.4 0 0 1-.4-.4v-.2c0-.21.18-.39.4-.39h.23c.22 0 .4.18.4.4v.2a.4.4 0 0 1-.4.39Z",
    fill: "#E9E6E7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M22.02 6.65h-.24a.4.4 0 0 1-.39-.39v-.19c0-.22.18-.4.4-.4h.23c.22 0 .4.19.4.4v.2a.4.4 0 0 1-.4.38Z",
    fill: "#E8E5E6"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M22.02 6.65h-.24a.4.4 0 0 1-.4-.4v-.18c0-.22.18-.4.4-.4h.24c.22 0 .4.18.4.4v.19a.4.4 0 0 1-.4.39Z",
    fill: "#E7E4E5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M22.02 6.64h-.24a.39.39 0 0 1-.39-.39v-.18c0-.22.18-.4.4-.4h.23c.22 0 .4.18.4.4v.18a.4.4 0 0 1-.4.4Z",
    fill: "#E6E3E4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.02 6.64h-.24a.39.39 0 0 1-.39-.39v-.18c0-.21.18-.39.4-.39h.23c.22 0 .4.18.4.39v.18c0 .21-.18.39-.4.39Z",
    fill: "#E5E2E3"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M22.02 6.63h-.24a.38.38 0 0 1-.39-.38v-.18c0-.21.18-.38.39-.38h.24c.22 0 .39.17.39.38v.18c0 .2-.17.38-.39.38Z",
    fill: "#E4E1E2"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M22.02 6.62h-.24a.38.38 0 0 1-.39-.38v-.17c0-.21.17-.39.39-.39h.24c.21 0 .39.18.39.39v.17c0 .21-.18.38-.39.38Z",
    fill: "#E3E0E1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M22.03 6.62h-.25a.38.38 0 0 1-.38-.38v-.17c0-.21.17-.38.38-.38h.25c.2 0 .38.17.38.38v.17c0 .2-.17.38-.38.38Z",
    fill: "#E3DFE0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M22.03 6.61h-.25a.38.38 0 0 1-.38-.37v-.17c0-.2.17-.38.38-.38h.25c.2 0 .38.17.38.38v.17c0 .2-.17.37-.38.37Z",
    fill: "#E2DEDF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M22.03 6.6h-.26a.38.38 0 0 1-.37-.37v-.16c0-.21.17-.38.37-.38h.26c.2 0 .37.17.37.38v.16c0 .2-.16.38-.37.38Z",
    fill: "#E1DDDE"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M22.03 6.6h-.26a.38.38 0 0 1-.37-.37v-.16c0-.2.17-.38.37-.38h.26c.2 0 .37.17.37.38v.16c0 .2-.17.37-.37.37Z",
    fill: "#E0DCDD"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.03 6.6h-.26a.37.37 0 0 1-.37-.38v-.15c0-.2.17-.37.37-.37h.26c.2 0 .37.17.37.37v.15c0 .21-.17.38-.37.38Z",
    fill: "#DFDCDD"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M22.03 6.59h-.26a.37.37 0 0 1-.37-.37v-.15c0-.2.17-.37.37-.37h.26c.2 0 .37.17.37.37v.15c0 .2-.17.37-.37.37Z",
    fill: "#DEDBDC"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M22.03 6.58h-.26a.37.37 0 0 1-.37-.37v-.14c0-.2.17-.37.37-.37h.26c.2 0 .37.17.37.37v.14c0 .21-.17.37-.37.37Z",
    fill: "#DDDADB"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M22.03 6.58h-.26a.37.37 0 0 1-.37-.37v-.14c0-.2.16-.37.37-.37h.26c.2 0 .37.17.37.37v.14c0 .2-.17.37-.37.37Z",
    fill: "#DCD9DA"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M22.03 6.57h-.26a.37.37 0 0 1-.37-.36v-.14c0-.2.17-.36.37-.36h.26c.2 0 .37.16.37.36v.14c0 .2-.17.36-.37.36Z",
    fill: "#DBD8D9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M22.03 6.57h-.26a.36.36 0 0 1-.37-.37v-.13c0-.2.17-.36.37-.36h.26c.2 0 .36.16.36.36v.13c0 .2-.16.37-.36.37Z",
    fill: "#DBD7D8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M22.03 6.56h-.26a.36.36 0 0 1-.37-.36v-.13c0-.2.16-.36.37-.36h.26c.2 0 .37.16.37.36v.13c0 .2-.17.36-.37.36Z",
    fill: "#DAD6D7"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.03 6.56h-.27a.36.36 0 0 1-.36-.36v-.13c0-.2.16-.36.36-.36h.27c.2 0 .36.16.36.36v.13c0 .2-.16.36-.36.36Z",
    fill: "#D9D5D6"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M22.03 6.55h-.27a.36.36 0 0 1-.36-.36v-.12c0-.2.17-.36.36-.36h.27c.2 0 .36.17.36.36v.12c0 .2-.16.36-.36.36Z",
    fill: "#D8D4D5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M22.03 6.54h-.27a.36.36 0 0 1-.35-.35v-.12c0-.2.16-.35.35-.35h.27c.2 0 .36.16.36.35v.12c0 .2-.16.35-.36.35Z",
    fill: "#D7D3D4"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M22.03 6.54h-.27a.36.36 0 0 1-.36-.36v-.1c0-.2.16-.36.36-.36h.27c.2 0 .36.16.36.35v.12c0 .19-.16.35-.36.35Z",
    fill: "#D6D2D3"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M22.03 6.53h-.27a.35.35 0 0 1-.36-.35v-.1c0-.2.16-.36.36-.36h.27c.2 0 .36.16.36.35v.11c0 .2-.16.35-.36.35Z",
    fill: "#D5D1D2"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M22.03 6.53h-.27a.35.35 0 0 1-.35-.35v-.1c0-.2.16-.36.35-.36h.27c.2 0 .36.16.36.35v.1c0 .2-.16.36-.36.36Z",
    fill: "#D4D0D1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M22.04 6.52h-.28a.35.35 0 0 1-.35-.35v-.1c0-.19.15-.35.35-.35h.27c.2 0 .36.16.36.35v.1c0 .2-.16.35-.36.35Z",
    fill: "#D3CFD0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M22.04 6.52h-.28a.35.35 0 0 1-.35-.35v-.1c0-.19.15-.34.35-.34h.27c.2 0 .35.15.35.34v.1c0 .19-.15.35-.34.35Z",
    fill: "#D3CECF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M22.03 6.51h-.27a.35.35 0 0 1-.35-.34v-.1c0-.19.15-.34.35-.34h.27c.2 0 .35.15.35.34v.1c0 .18-.15.34-.35.34Z",
    fill: "#D2CDCE"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M22.04 6.5h-.28a.34.34 0 0 1-.35-.34v-.09c0-.18.16-.34.35-.34h.28c.19 0 .34.16.34.34v.09c0 .19-.15.34-.34.34Z",
    fill: "#D1CCCD"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M22.04 6.5h-.29a.34.34 0 0 1-.34-.34v-.09c0-.18.15-.34.34-.34h.29c.19 0 .34.16.34.34v.09c0 .18-.15.34-.34.34Z",
    fill: "#D0CBCC"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M22.04 6.5h-.29a.34.34 0 0 1-.34-.35v-.07c0-.2.15-.34.34-.34h.29c.19 0 .34.15.34.34v.07c0 .19-.15.34-.34.34Z",
    fill: "#CFCACB"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M22.04 6.49h-.29a.34.34 0 0 1-.34-.34v-.07c0-.19.15-.34.34-.34h.29c.19 0 .34.15.34.34v.07c0 .18-.15.34-.34.34Z",
    fill: "#CEC9CA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M22.04 6.48h-.29a.34.34 0 0 1-.34-.34v-.07c0-.18.16-.33.34-.33h.29c.19 0 .34.15.34.33v.07c0 .19-.15.34-.34.34Z",
    fill: "#CDC8C9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M22.04 6.48h-.3a.34.34 0 0 1-.33-.34v-.06c0-.19.15-.34.34-.34h.3c.18 0 .33.15.33.34v.06c0 .18-.15.34-.34.34Z",
    fill: "#CCC7C8"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M22.04 6.47h-.3a.33.33 0 0 1-.33-.33v-.06c0-.18.15-.33.34-.33h.29c.19 0 .33.15.33.33v.06c0 .18-.14.33-.33.33Z",
    fill: "#CBC6C7"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M22.04 6.46h-.3a.33.33 0 0 1-.33-.33v-.05c0-.19.15-.33.34-.33h.29c.19 0 .33.15.33.33v.05c0 .18-.14.33-.33.33Z",
    fill: "#CBC5C6"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M22.04 6.46h-.3a.33.33 0 0 1-.33-.33v-.05c0-.18.15-.33.34-.33h.3c.18 0 .32.14.32.33v.05c0 .18-.14.33-.33.33Z",
    fill: "#CAC4C6"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M22.04 6.45h-.3a.33.33 0 0 1-.32-.33v-.04c0-.18.14-.33.33-.33h.3c.17 0 .32.15.32.33v.04c0 .19-.15.33-.33.33Z",
    fill: "#C9C3C5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M22.04 6.45h-.3a.33.33 0 0 1-.32-.33v-.04c0-.18.14-.33.32-.33h.3c.18 0 .33.15.33.33v.04c0 .18-.15.33-.33.33Z",
    fill: "#C8C2C4"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M22.04 6.44h-.3a.32.32 0 0 1-.32-.32v-.04c0-.18.14-.32.32-.32h.3c.18 0 .33.14.33.32v.04c0 .18-.15.32-.33.32Z",
    fill: "#C7C1C3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M22.04 6.43h-.3a.32.32 0 0 1-.32-.32v-.03c0-.18.14-.32.32-.32h.3c.18 0 .33.14.33.32v.03c0 .18-.15.32-.33.32Z",
    fill: "#C6C0C2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M22.05 6.43h-.3a.32.32 0 0 1-.33-.32v-.03c0-.18.14-.32.32-.32h.3c.18 0 .33.14.33.32v.03c0 .18-.15.32-.32.32Z",
    fill: "#C5BFC1"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M22.05 6.42h-.31a.32.32 0 0 1-.32-.32v-.02c0-.18.14-.32.32-.32h.3c.18 0 .33.15.33.32v.02c0 .18-.15.32-.32.32Z",
    fill: "#C4BEC0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M22.05 6.42h-.31a.32.32 0 0 1-.32-.32v-.02c0-.17.14-.32.32-.32h.3c.18 0 .33.14.33.32v.02c0 .18-.15.32-.32.32Z",
    fill: "#C3BDBF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M22.05 6.41h-.31a.32.32 0 0 1-.32-.31v-.02c0-.17.14-.32.32-.32h.3c.18 0 .32.15.32.32v.02c0 .17-.14.31-.31.31Z",
    fill: "#C3BCBE"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M22.05 6.4h-.31a.31.31 0 0 1-.32-.3v-.02c0-.17.14-.31.32-.31h.3c.18 0 .32.14.32.31v.01c0 .18-.14.31-.31.31Z",
    fill: "#C2BBBD"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M22.05 6.4h-.31a.31.31 0 1 1 0-.63h.3c.18 0 .32.14.32.31v.01c0 .17-.14.31-.31.31Z",
    fill: "#C1BABC"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M22.05 6.4h-.32a.31.31 0 1 1 0-.63h.32a.31.31 0 1 1 0 .63Z",
    fill: "#C0B9BB"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M22.05 6.39h-.32a.31.31 0 0 1-.3-.3c0-.18.13-.32.3-.32h.32c.17 0 .3.14.3.31 0 .17-.13.31-.3.31Z",
    fill: "#BFB8BA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M22.13 6.4h-.44a.31.31 0 0 1-.32-.3v-.08c0-.17.14-.3.32-.3h.44c.17 0 .32.13.32.3v.08c0 .17-.15.3-.32.3Z",
    fill: "#687BC1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M22.13 6.4h-.45a.31.31 0 0 1-.3-.3v-.08c0-.16.13-.3.3-.3h.45c.17 0 .31.14.31.3v.07a.3.3 0 0 1-.3.31Z",
    fill: "#697CC2"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M22.14 6.4h-.46a.3.3 0 0 1-.3-.3v-.08c0-.17.13-.3.3-.3h.46c.17 0 .3.14.3.3v.07a.3.3 0 0 1-.3.3Z",
    fill: "#697CC3"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M22.14 6.39h-.46a.3.3 0 0 1-.3-.3v-.07c0-.17.13-.3.3-.3h.46c.17 0 .3.13.3.3v.07a.3.3 0 0 1-.3.3Z",
    fill: "#6A7DC4"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M22.14 6.38h-.47a.3.3 0 0 1-.3-.3v-.06c0-.17.14-.3.3-.3h.47c.17 0 .3.14.3.3v.06a.3.3 0 0 1-.3.3Z",
    fill: "#6A7DC5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 6.37h-.48a.3.3 0 0 1-.3-.29v-.07c0-.16.14-.29.3-.29h.48c.16 0 .29.13.29.3v.06a.3.3 0 0 1-.3.3Z",
    fill: "#6B7EC6"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 6.37h-.48a.29.29 0 0 1-.3-.29v-.07c0-.15.14-.28.3-.28h.48c.16 0 .29.13.29.28v.07c0 .16-.13.29-.3.29Z",
    fill: "#6B7EC7"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 6.36h-.48a.29.29 0 0 1-.3-.29v-.06c0-.15.14-.28.3-.28h.48c.16 0 .29.12.29.28v.06c0 .16-.13.29-.29.29Z",
    fill: "#6C7FC8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 6.35h-.49a.28.28 0 0 1-.28-.28v-.06c0-.15.13-.28.28-.28h.5c.15 0 .27.13.27.28v.06c0 .16-.12.28-.28.28Z",
    fill: "#6C80C9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 6.34h-.5a.28.28 0 0 1-.27-.27v-.06c0-.15.13-.28.28-.28h.5c.15 0 .27.13.27.28v.06c0 .15-.12.27-.28.27Z",
    fill: "#6D80CA"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 6.34h-.5a.27.27 0 0 1-.28-.28V6c0-.15.12-.27.27-.27h.5c.16 0 .28.12.28.27v.06c0 .16-.12.28-.27.28Z",
    fill: "#6D81CB"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 6.33h-.5a.27.27 0 0 1-.28-.27V6c0-.14.12-.26.27-.26h.5c.16 0 .28.12.28.26v.06c0 .15-.12.27-.27.27Z",
    fill: "#6E81CC"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 6.32h-.51a.27.27 0 0 1-.27-.26V6c0-.14.12-.26.27-.26h.51c.15 0 .27.12.27.26v.06c0 .15-.12.26-.27.26Z",
    fill: "#6E82CD"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M22.16 6.32h-.52a.26.26 0 0 1-.26-.26V6c0-.14.12-.26.26-.26h.52c.15 0 .26.12.26.26v.06c0 .14-.11.26-.26.26Z",
    fill: "#6F82CE"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 6.3h-.53a.26.26 0 0 1-.26-.25V6c0-.14.12-.26.26-.26h.53c.14 0 .25.12.25.26v.05c0 .15-.11.26-.25.26Z",
    fill: "#6F83CF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 6.3h-.53a.25.25 0 0 1-.25-.25V6c0-.14.11-.26.25-.26h.53c.14 0 .25.12.25.26v.05c0 .14-.1.25-.25.25Z",
    fill: "#7083D0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 6.3h-.54a.25.25 0 0 1-.25-.25v-.06c0-.13.11-.25.25-.25h.54c.14 0 .25.12.25.25v.06c0 .14-.1.25-.25.25Z",
    fill: "#7084D1"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 6.29h-.55a.24.24 0 0 1-.24-.25V6c0-.13.1-.24.24-.24h.55c.13 0 .24.1.24.24v.05c0 .14-.1.25-.24.25Z",
    fill: "#7185D2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 6.28h-.55a.24.24 0 0 1-.24-.24V6c0-.13.1-.24.24-.24h.55c.13 0 .24.11.24.24v.05c0 .13-.1.24-.24.24Z",
    fill: "#7185D3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 6.27h-.55a.24.24 0 0 1-.24-.23v-.05c0-.13.1-.24.24-.24h.55c.13 0 .24.1.24.24v.05c0 .13-.1.23-.24.23Z",
    fill: "#7286D4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 6.27h-.56a.23.23 0 0 1-.23-.23v-.05c0-.13.1-.23.23-.23h.56c.13 0 .24.1.24.23v.05c0 .12-.1.23-.24.23Z",
    fill: "#7286D5"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 6.26h-.56a.23.23 0 0 1-.23-.23v-.05c0-.12.1-.23.23-.23h.56c.13 0 .24.1.24.23v.05c0 .13-.1.23-.24.23Z",
    fill: "#7387D6"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M22.19 6.25h-.57a.23.23 0 0 1-.23-.22v-.05c0-.12.1-.22.23-.22h.57c.12 0 .22.1.22.22v.05c0 .12-.1.22-.22.22Z",
    fill: "#7387D7"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M22.19 6.25h-.58a.22.22 0 0 1-.22-.23v-.04c0-.12.1-.22.22-.22h.58c.12 0 .22.1.22.22v.04c0 .13-.1.23-.22.23Z",
    fill: "#7488D8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 6.24h-.59a.22.22 0 0 1-.22-.22v-.04c0-.12.1-.22.22-.22h.59c.12 0 .21.1.21.22v.04c0 .12-.1.22-.21.22Z",
    fill: "#7489D9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 6.23h-.6a.21.21 0 0 1-.2-.2v-.05c0-.12.1-.21.2-.21h.6c.12 0 .21.1.21.2v.05c0 .12-.1.21-.21.21Z",
    fill: "#7589DA"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 6.23h-.6a.2.2 0 0 1-.2-.21v-.05c0-.11.09-.2.2-.2h.6c.12 0 .21.09.21.2v.05c0 .11-.1.2-.21.2Z",
    fill: "#758ADB"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 6.22h-.6a.2.2 0 0 1-.2-.2v-.05c0-.11.09-.2.2-.2h.6c.12 0 .2.09.2.2v.04c0 .12-.09.2-.2.2Z",
    fill: "#768ADC"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 6.21h-.6a.2.2 0 0 1-.2-.2v-.04c0-.11.09-.2.2-.2h.6c.12 0 .2.09.2.2V6c0 .11-.08.2-.2.2Z",
    fill: "#768BDC"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 6.2h-.6a.2.2 0 0 1-.2-.2v-.03c0-.1.09-.2.2-.2h.6c.12 0 .2.1.2.2v.04c0 .1-.08.2-.2.2Z",
    fill: "#778BDD"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M22.21 6.2h-.62a.2.2 0 0 1-.2-.2v-.03c0-.11.1-.2.2-.2h.62c.1 0 .2.09.2.2V6c0 .11-.1.2-.2.2Z",
    fill: "#778CDE"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M22.21 6.19h-.62a.2.2 0 0 1-.2-.19v-.03c0-.1.1-.2.2-.2h.62c.1 0 .19.1.19.2V6c0 .1-.08.19-.19.19Z",
    fill: "#788CDF"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M22.22 6.18h-.63A.18.18 0 0 1 21.4 6v-.04c0-.1.09-.18.19-.18h.63c.1 0 .18.08.18.18V6c0 .1-.08.18-.18.18Z",
    fill: "#788DE0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M22.22 6.18h-.64a.18.18 0 0 1-.18-.19v-.03c0-.1.08-.18.18-.18h.64c.1 0 .18.08.18.18V6c0 .1-.08.19-.18.19Z",
    fill: "#798EE1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M22.22 6.17h-.64a.18.18 0 0 1-.18-.18v-.03c0-.1.09-.18.18-.18h.64c.1 0 .18.09.18.18V6c0 .1-.08.18-.18.18Z",
    fill: "#798EE2"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M22.22 6.16h-.64A.17.17 0 0 1 21.4 6v-.03c0-.1.08-.18.18-.18h.64c.1 0 .18.08.18.18v.03c0 .1-.08.17-.18.17Z",
    fill: "#7A8FE3"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23 6.16h-.66a.17.17 0 0 1-.17-.17v-.03c0-.1.08-.17.17-.17h.66c.09 0 .17.07.17.17v.03c0 .09-.08.17-.17.17Z",
    fill: "#7A8FE4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23 6.15h-.66a.17.17 0 0 1-.17-.17v-.03c0-.09.08-.17.17-.17h.66c.09 0 .17.08.17.17v.03c0 .1-.08.17-.17.17Z",
    fill: "#7B90E5"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23 6.14h-.66a.16.16 0 0 1-.16-.16v-.03c0-.08.07-.16.16-.16h.66c.09 0 .16.08.16.16v.03c0 .09-.07.16-.16.16Z",
    fill: "#7B90E6"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23 6.14h-.67a.16.16 0 0 1-.16-.16v-.03c0-.09.08-.16.16-.16h.67c.09 0 .16.07.16.16v.03c0 .08-.07.16-.16.16Z",
    fill: "#7C91E7"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 6.13h-.68a.15.15 0 0 1-.15-.16v-.02c0-.09.06-.16.15-.16h.68c.08 0 .15.07.15.16v.02c0 .09-.07.16-.15.16Z",
    fill: "#7C92E8"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 6.12h-.68a.15.15 0 0 1-.15-.15v-.02c0-.09.07-.15.15-.15h.68c.08 0 .15.07.15.15v.02c0 .08-.07.15-.15.15Z",
    fill: "#7D92E9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 6.11h-.68a.15.15 0 0 1-.15-.14v-.03c0-.08.06-.14.15-.14h.68c.08 0 .15.06.15.14v.03c0 .08-.07.14-.15.14Z",
    fill: "#7D93EA"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 6.1h-.69a.14.14 0 0 1-.14-.13v-.03c0-.07.07-.14.14-.14h.7c.07 0 .14.07.14.14v.03c0 .07-.07.14-.15.14Z",
    fill: "#7E93EB"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 6.1h-.7a.14.14 0 0 1-.13-.14v-.02c0-.07.06-.14.14-.14h.7c.07 0 .13.06.13.14v.02c0 .08-.06.14-.14.14Z",
    fill: "#7E94EC"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 6.1h-.7a.13.13 0 0 1-.14-.14v-.02c0-.07.06-.14.14-.14h.7c.07 0 .13.07.13.14v.02c0 .07-.06.13-.13.13Z",
    fill: "#7F94ED"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 6.08h-.7a.13.13 0 0 1-.14-.13v-.01c0-.07.06-.14.13-.14h.71c.07 0 .13.06.13.14v.01c0 .08-.06.13-.13.13Z",
    fill: "#7F95EE"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 6.08h-.7a.13.13 0 0 1-.14-.13v-.02c0-.07.06-.12.13-.12h.71c.07 0 .13.05.13.12v.02c0 .07-.06.13-.13.13Z",
    fill: "#8095EF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 6.07h-.72a.12.12 0 0 1-.13-.12v-.02c0-.06.06-.12.13-.12h.72c.06 0 .12.06.12.12v.02c0 .07-.06.12-.12.12Z",
    fill: "#8096F0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 6.06h-.73a.12.12 0 0 1-.12-.11v-.02c0-.06.06-.12.12-.12h.73c.06 0 .12.06.12.12v.02c0 .06-.06.11-.12.11Z",
    fill: "#8197F1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 6.06h-.73a.11.11 0 0 1-.11-.12v-.01c0-.06.05-.12.11-.12h.73c.06 0 .11.06.11.12v.01c0 .07-.05.12-.11.12Z",
    fill: "#8197F2"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 6.05h-.73a.11.11 0 0 1-.11-.11v-.01c0-.06.05-.12.1-.12h.74c.06 0 .11.06.11.12 0 .07-.05.12-.1.12Z",
    fill: "#8298F3"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M22.27 6.04h-.75a.1.1 0 0 1-.1-.1v-.01c0-.06.04-.11.1-.11h.75c.05 0 .1.05.1.1v.02a.1.1 0 0 1-.1.1Z",
    fill: "#8298F4"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M22.27 6.04h-.75a.1.1 0 0 1-.1-.1v-.02c0-.05.04-.1.1-.1h.75c.05 0 .1.05.1.1v.01a.1.1 0 0 1-.1.1Z",
    fill: "#8399F5"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M22.27 6.03h-.75a.1.1 0 0 1-.1-.1c0-.06.04-.1.1-.1h.75c.06 0 .1.04.1.1a.1.1 0 0 1-.1.1Z",
    fill: "#8399F6"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M22.27 6.02h-.75a.1.1 0 0 1-.1-.1c0-.05.04-.1.1-.1h.75c.06 0 .1.05.1.1a.1.1 0 0 1-.1.1Z",
    fill: "#849AF7"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M25.37 6.8h-2.1a.53.53 0 0 1-.52-.53v-.12c0-.29.23-.52.53-.52h2.09c.3 0 .53.23.53.52v.12c0 .3-.24.53-.53.53Z",
    fill: "#FEFEFE"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M25.37 6.79h-2.1a.53.53 0 0 1-.52-.53v-.11c0-.29.24-.53.53-.53h2.09c.29 0 .53.24.53.53v.11c0 .3-.24.53-.53.53Z",
    fill: "#FDFDFD"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M25.37 6.79h-2.1a.53.53 0 0 1-.52-.53v-.11c0-.29.24-.52.53-.52h2.09c.29 0 .52.23.52.52v.11c0 .3-.23.53-.52.53Z",
    fill: "#FCFCFC"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M25.37 6.78h-2.1a.52.52 0 0 1-.52-.52v-.11c0-.29.23-.52.52-.52h2.1c.29 0 .52.23.52.52v.1c0 .3-.23.53-.52.53Z",
    fill: "#FBFBFB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M25.36 6.78h-2.09a.52.52 0 0 1-.52-.52v-.11c0-.28.24-.52.52-.52h2.1c.28 0 .51.24.51.52v.1c0 .3-.23.53-.52.53Z",
    fill: "#FBFAFA"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M25.36 6.77h-2.09a.51.51 0 0 1-.51-.52v-.1c0-.29.23-.52.51-.52h2.1c.28 0 .51.23.51.52v.1c0 .29-.23.52-.52.52Z",
    fill: "#FAF9F9"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.36 6.76h-2.09a.51.51 0 0 1-.51-.5v-.11c0-.28.23-.51.51-.51h2.1c.28 0 .5.23.5.5v.11c0 .28-.22.51-.5.51Z",
    fill: "#F9F8F8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M25.36 6.76h-2.09a.51.51 0 0 1-.51-.51v-.1c0-.28.23-.51.51-.51h2.1c.28 0 .5.22.5.5v.1c0 .29-.22.52-.5.52Z",
    fill: "#F8F7F7"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M25.36 6.75h-2.09a.5.5 0 0 1-.5-.5v-.1c0-.28.22-.5.5-.5h2.1c.28 0 .5.22.5.5v.1a.5.5 0 0 1-.5.5Z",
    fill: "#F7F6F6"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M25.36 6.75h-2.09a.5.5 0 0 1-.5-.5v-.1c0-.28.22-.5.5-.5h2.1c.27 0 .5.22.5.5v.1a.5.5 0 0 1-.5.5Z",
    fill: "#F6F5F5"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.36 6.74h-2.09a.5.5 0 0 1-.5-.5v-.1c0-.27.22-.5.5-.5h2.1c.27 0 .5.23.5.5v.1a.5.5 0 0 1-.5.5Z",
    fill: "#F5F4F4"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M25.36 6.73h-2.1a.5.5 0 0 1-.5-.5v-.09c0-.27.23-.5.5-.5h2.1c.28 0 .5.23.5.5v.1a.5.5 0 0 1-.5.5Z",
    fill: "#F4F3F3"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M25.36 6.73h-2.1a.5.5 0 0 1-.49-.5v-.09c0-.27.22-.5.5-.5h2.1c.27 0 .49.23.49.5v.1c0 .27-.22.49-.5.49Z",
    fill: "#F3F2F3"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M25.36 6.72h-2.1a.5.5 0 0 1-.49-.49v-.09a.5.5 0 0 1 .5-.49h2.1c.26 0 .48.22.48.49v.1a.5.5 0 0 1-.49.48Z",
    fill: "#F3F1F2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M25.36 6.72h-2.1a.49.49 0 0 1-.48-.49v-.09c0-.27.21-.49.48-.49h2.1c.27 0 .5.22.5.49v.1c0 .26-.23.48-.5.48Z",
    fill: "#F2F0F1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M25.36 6.71h-2.1a.49.49 0 0 1-.48-.48v-.1c0-.26.21-.48.48-.48h2.1c.27 0 .49.22.49.49v.09c0 .27-.22.48-.49.48Z",
    fill: "#F1EFF0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M25.36 6.7h-2.1a.48.48 0 0 1-.48-.47v-.1c0-.26.22-.47.48-.47h2.1c.27 0 .48.21.48.48v.09c0 .26-.21.47-.48.47Z",
    fill: "#F0EEEF"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M25.36 6.7h-2.1a.48.48 0 0 1-.48-.48v-.08c0-.26.22-.48.48-.48h2.1c.26 0 .48.22.48.48v.08c0 .27-.21.48-.48.48Z",
    fill: "#EFEDEE"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M25.36 6.7h-2.1a.47.47 0 0 1-.48-.48v-.08c0-.27.22-.48.48-.48h2.1c.26 0 .48.21.48.48v.08c0 .26-.22.47-.48.47Z",
    fill: "#EEECED"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M25.36 6.69h-2.1a.47.47 0 0 1-.48-.47v-.09c0-.26.22-.47.48-.47h2.1c.26 0 .47.21.47.47v.09c0 .26-.21.47-.47.47Z",
    fill: "#EDEBEC"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M25.36 6.68h-2.1a.47.47 0 0 1-.47-.46v-.08c0-.26.21-.47.47-.47h2.1c.26 0 .47.2.47.47v.08c0 .25-.21.46-.47.46Z",
    fill: "#ECEAEB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M25.36 6.68h-2.1a.46.46 0 0 1-.47-.47v-.08c0-.25.2-.46.47-.46h2.1c.26 0 .47.2.47.46v.08c0 .26-.21.47-.47.47Z",
    fill: "#EBE9EA"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M25.36 6.67h-2.1a.46.46 0 0 1-.47-.46v-.08c0-.25.21-.46.47-.46h2.1c.25 0 .46.2.46.46v.08c0 .26-.2.46-.46.46Z",
    fill: "#EBE8E9"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M25.36 6.66h-2.1a.46.46 0 0 1-.47-.45v-.08c0-.25.2-.46.46-.46h2.1c.26 0 .47.2.47.46v.08c0 .25-.2.45-.46.45Z",
    fill: "#EAE7E8"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25.36 6.66h-2.1a.45.45 0 0 1-.46-.45v-.08c0-.25.2-.45.45-.45h2.1c.26 0 .46.2.46.45v.08c0 .25-.2.45-.45.45Z",
    fill: "#E9E6E7"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M25.36 6.65h-2.1a.45.45 0 0 1-.46-.45v-.07c0-.25.2-.45.45-.45h2.1c.26 0 .46.2.46.45v.07c0 .25-.2.45-.45.45Z",
    fill: "#E8E5E6"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M25.36 6.65h-2.1a.45.45 0 0 1-.46-.45v-.08c0-.24.2-.44.45-.44h2.1c.25 0 .46.2.46.44v.08c0 .25-.2.45-.45.45Z",
    fill: "#E7E4E5"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M25.36 6.64h-2.11a.45.45 0 0 1-.45-.44v-.08c0-.24.2-.44.45-.44h2.1c.25 0 .45.2.45.44v.08c0 .24-.2.44-.44.44Z",
    fill: "#E6E3E4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.36 6.64h-2.11a.44.44 0 0 1-.44-.44v-.08c0-.24.2-.44.44-.44h2.1c.25 0 .45.2.45.44v.07c0 .25-.2.45-.44.45Z",
    fill: "#E5E2E3"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M25.36 6.63h-2.11a.44.44 0 0 1-.44-.44v-.07c0-.24.2-.43.44-.43h2.1c.25 0 .45.2.45.43v.07c0 .24-.2.44-.44.44Z",
    fill: "#E4E1E2"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M25.35 6.62h-2.1a.44.44 0 0 1-.44-.43v-.07c0-.24.2-.43.44-.43h2.1c.25 0 .44.19.44.43v.07c0 .24-.2.43-.44.43Z",
    fill: "#E3E0E1"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M25.35 6.62h-2.1a.43.43 0 0 1-.44-.43v-.07c0-.24.2-.43.43-.43h2.11c.24 0 .44.2.44.43v.07c0 .23-.2.43-.44.43Z",
    fill: "#E3DFE0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M25.35 6.61h-2.1a.43.43 0 0 1-.44-.42v-.07c0-.23.2-.43.44-.43h2.1c.24 0 .44.2.44.43v.07c0 .23-.2.42-.44.42Z",
    fill: "#E2DEDF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M25.35 6.6h-2.1a.43.43 0 0 1-.43-.42v-.06c0-.23.19-.43.42-.43h2.11c.24 0 .43.2.43.43v.06c0 .24-.19.43-.43.43Z",
    fill: "#E1DDDE"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M25.35 6.6h-2.1a.42.42 0 0 1-.43-.42v-.06c0-.24.19-.43.42-.43h2.11c.24 0 .43.2.43.43v.06c0 .23-.2.42-.43.42Z",
    fill: "#E0DCDD"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.35 6.6h-2.1a.42.42 0 0 1-.43-.42v-.06c0-.23.19-.42.42-.42h2.11c.24 0 .43.19.43.42v.06c0 .23-.2.42-.43.42Z",
    fill: "#DFDCDD"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M25.35 6.59h-2.1a.42.42 0 0 1-.43-.42v-.05c0-.23.2-.42.42-.42h2.11c.23 0 .42.19.42.42v.05c0 .23-.19.42-.42.42Z",
    fill: "#DEDBDC"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M25.35 6.58h-2.11a.41.41 0 0 1-.42-.41v-.06c0-.22.2-.4.42-.4h2.11c.23 0 .42.18.42.4v.06c0 .23-.19.41-.42.41Z",
    fill: "#DDDADB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M25.35 6.58h-2.11a.41.41 0 0 1-.41-.41V6.1c0-.22.18-.4.4-.4h2.12c.23 0 .41.18.41.4v.06c0 .22-.18.4-.4.4Z",
    fill: "#DCD9DA"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M25.35 6.57h-2.11a.4.4 0 0 1-.41-.4V6.1c0-.22.18-.4.4-.4h2.12a.4.4 0 0 1 .41.4v.06c0 .22-.18.4-.41.4Z",
    fill: "#DBD8D9"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M25.35 6.57h-2.11a.4.4 0 0 1-.4-.4V6.1c0-.22.17-.4.4-.4h2.11c.23 0 .4.18.4.4v.05a.4.4 0 0 1-.4.4Z",
    fill: "#DBD7D8"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M25.35 6.56h-2.11a.4.4 0 0 1-.4-.4v-.05c0-.22.17-.4.4-.4h2.11c.22 0 .4.18.4.4v.05a.4.4 0 0 1-.4.4Z",
    fill: "#DAD6D7"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.35 6.56h-2.11a.4.4 0 0 1-.4-.4V6.1c0-.22.18-.4.4-.4h2.11c.22 0 .4.18.4.4v.05a.4.4 0 0 1-.4.4Z",
    fill: "#D9D5D6"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M25.35 6.55h-2.12a.4.4 0 0 1-.4-.4v-.04c0-.22.18-.4.4-.4h2.12c.22 0 .4.18.4.4v.04a.4.4 0 0 1-.4.4Z",
    fill: "#D8D4D5"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M25.35 6.54h-2.12a.4.4 0 0 1-.4-.39v-.04c0-.22.18-.4.4-.4h2.12c.22 0 .4.18.4.4v.04a.4.4 0 0 1-.4.4Z",
    fill: "#D7D3D4"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M25.35 6.54h-2.12a.39.39 0 0 1-.39-.39v-.04c0-.22.18-.4.4-.4h2.1c.22 0 .4.18.4.4v.04c0 .21-.18.39-.4.39Z",
    fill: "#D6D2D3"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M25.35 6.53h-2.12a.39.39 0 0 1-.39-.38V6.1c0-.22.18-.39.4-.39h2.1c.22 0 .4.18.4.39v.04c0 .2-.18.38-.4.38Z",
    fill: "#D5D1D2"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M25.35 6.53h-2.12a.38.38 0 0 1-.38-.39V6.1c0-.2.17-.38.38-.38h2.12c.21 0 .39.17.39.38v.04c0 .21-.18.39-.39.39Z",
    fill: "#D4D0D1"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M25.35 6.52h-2.12a.38.38 0 0 1-.38-.38V6.1c0-.2.17-.38.38-.38h2.12c.21 0 .38.17.38.38v.04c0 .21-.17.38-.38.38Z",
    fill: "#D3CFD0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M25.35 6.52h-2.12a.38.38 0 0 1-.38-.38V6.1c0-.2.17-.37.38-.37h2.12c.2 0 .38.17.38.37v.04c0 .2-.17.38-.38.38Z",
    fill: "#D3CECF"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M25.35 6.51h-2.12a.37.37 0 0 1-.38-.37V6.1c0-.2.17-.37.38-.37h2.12c.2 0 .37.17.37.37v.04c0 .2-.17.37-.37.37Z",
    fill: "#D2CDCE"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M25.35 6.5h-2.12a.37.37 0 0 1-.38-.37V6.1c0-.2.17-.37.38-.37h2.12c.2 0 .37.17.37.37v.03c0 .2-.17.37-.37.37Z",
    fill: "#D1CCCD"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M25.35 6.5h-2.13a.37.37 0 0 1-.37-.37V6.1c0-.2.17-.37.37-.37h2.13c.2 0 .37.17.37.37v.03c0 .2-.17.37-.37.37Z",
    fill: "#D0CBCC"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M25.35 6.5h-2.13a.36.36 0 0 1-.36-.37V6.1c0-.2.16-.36.36-.36h2.13c.2 0 .36.16.36.36v.03c0 .2-.16.36-.36.36Z",
    fill: "#CFCACB"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M25.35 6.49h-2.13a.36.36 0 0 1-.36-.37V6.1c0-.2.16-.36.36-.36h2.13c.2 0 .36.16.36.36v.03c0 .2-.16.36-.36.36Z",
    fill: "#CEC9CA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M25.35 6.48h-2.12a.36.36 0 0 1-.36-.36V6.1c0-.2.15-.36.36-.36h2.12c.2 0 .36.16.36.36v.02c0 .2-.17.36-.36.36Z",
    fill: "#CDC8C9"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M25.34 6.48h-2.12a.36.36 0 0 1-.36-.36v-.03c0-.2.16-.35.36-.35h2.12c.2 0 .36.16.36.35v.03c0 .2-.16.36-.36.36Z",
    fill: "#CCC7C8"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M25.34 6.47h-2.12a.35.35 0 0 1-.35-.35V6.1c0-.2.15-.35.35-.35h2.12c.2 0 .36.15.36.35v.02c0 .2-.16.35-.36.35Z",
    fill: "#CBC6C7"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M25.34 6.46h-2.12a.35.35 0 0 1-.35-.35V6.1c0-.19.16-.34.35-.34h2.12c.2 0 .35.15.35.34v.02c0 .2-.15.35-.35.35Z",
    fill: "#CBC5C6"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M25.34 6.46h-2.12a.35.35 0 0 1-.35-.35V6.1c0-.19.16-.34.35-.34h2.12c.2 0 .35.15.35.34v.02c0 .2-.15.35-.35.35Z",
    fill: "#CAC4C6"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M25.34 6.45h-2.12a.34.34 0 0 1-.35-.34v-.02c0-.19.16-.34.35-.34h2.12c.2 0 .35.15.35.34v.02c0 .19-.16.34-.35.34Z",
    fill: "#C9C3C5"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M25.34 6.45h-2.12a.34.34 0 0 1-.34-.34v-.02c0-.18.15-.34.34-.34h2.12c.2 0 .34.16.34.34v.02c0 .18-.15.34-.34.34Z",
    fill: "#C8C2C4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M25.34 6.44h-2.12a.34.34 0 0 1-.34-.34V6.1c0-.19.15-.34.34-.34h2.12c.2 0 .34.16.34.34v.01c0 .2-.15.34-.34.34Z",
    fill: "#C7C1C3"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M25.34 6.43h-2.13a.33.33 0 0 1-.33-.33V6.1c0-.18.15-.33.33-.33h2.13c.19 0 .34.15.34.33v.01c0 .19-.15.33-.34.33Z",
    fill: "#C6C0C2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M25.34 6.43h-2.13a.33.33 0 0 1-.33-.33v-.01c0-.18.15-.33.33-.33h2.13c.18 0 .33.15.33.33v.01c0 .18-.15.33-.33.33Z",
    fill: "#C5BFC1"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M25.34 6.42h-2.13a.33.33 0 0 1-.33-.32v-.01c0-.18.15-.33.33-.33h2.13c.18 0 .33.15.33.33 0 .19-.15.33-.33.33Z",
    fill: "#C4BEC0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M25.34 6.42h-2.13a.32.32 0 1 1 0-.65h2.13c.18 0 .33.14.33.32s-.15.33-.33.33Z",
    fill: "#C3BDBF"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M25.34 6.41h-2.13a.32.32 0 0 1-.32-.32c0-.18.15-.33.32-.33h2.13c.18 0 .32.15.32.32v.01c0 .18-.14.32-.32.32Z",
    fill: "#C3BCBE"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M25.34 6.4h-2.13a.32.32 0 0 1-.32-.31c0-.18.14-.33.32-.33h2.13c.18 0 .32.15.32.32 0 .18-.14.32-.32.32Z",
    fill: "#C2BBBD"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M25.34 6.4H23.2a.31.31 0 0 1-.32-.31c0-.18.14-.32.32-.32h2.13a.31.31 0 1 1 0 .63Z",
    fill: "#C1BABC"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M25.34 6.4H23.2a.31.31 0 1 1 0-.62h2.13c.17 0 .31.13.31.3 0 .18-.14.31-.31.31Z",
    fill: "#C0B9BB"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.39H23.2a.31.31 0 0 1-.31-.3c0-.18.14-.32.3-.32h2.14c.17 0 .3.14.3.31 0 .17-.13.31-.3.31Z",
    fill: "#BFB8BA"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.4h-2.12a.35.35 0 0 1-.35-.34c0-.2.15-.35.35-.35h2.12c.19 0 .35.16.35.35 0 .2-.16.35-.35.35Z",
    fill: "#687BC1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.4H23.2a.34.34 0 0 1-.34-.34c0-.19.15-.34.34-.34h2.13c.19 0 .34.15.34.34 0 .19-.15.34-.34.34Z",
    fill: "#697CC2"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.4h-2.13a.34.34 0 0 1-.34-.34c0-.19.16-.34.34-.34h2.13a.34.34 0 1 1 0 .68Z",
    fill: "#697CC3"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.39H23.2a.33.33 0 1 1 0-.67h2.13a.33.33 0 1 1 0 .67Z",
    fill: "#6A7DC4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.38h-2.13a.33.33 0 1 1 0-.66h2.13a.33.33 0 1 1 0 .66Z",
    fill: "#6A7DC5"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.37h-2.13a.33.33 0 0 1-.33-.32c0-.18.15-.33.33-.33h2.13c.18 0 .33.15.33.33 0 .18-.15.32-.33.32Z",
    fill: "#6B7EC6"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.37H23.2a.32.32 0 0 1-.32-.32c0-.18.14-.32.32-.32h2.14c.18 0 .32.14.32.32 0 .17-.14.32-.32.32Z",
    fill: "#6B7EC7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.36H23.2a.32.32 0 0 1-.32-.32c0-.17.15-.31.32-.31h2.14c.18 0 .32.14.32.31 0 .18-.14.32-.32.32Z",
    fill: "#6C7FC8"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.35H23.2a.31.31 0 1 1 0-.62h2.14a.31.31 0 1 1 0 .62Z",
    fill: "#6C80C9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 6.34H23.2a.3.3 0 1 1 0-.61h2.14c.17 0 .31.14.31.3a.3.3 0 0 1-.3.31Z",
    fill: "#6D80CA"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.34h-2.16a.3.3 0 0 1-.3-.3c0-.17.14-.31.3-.31h2.16c.16 0 .3.14.3.3a.3.3 0 0 1-.3.3Z",
    fill: "#6D81CB"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.33h-2.16a.3.3 0 0 1-.3-.3c0-.16.14-.3.3-.3h2.16c.16 0 .3.14.3.3a.3.3 0 0 1-.3.3Z",
    fill: "#6E81CC"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.32h-2.16a.3.3 0 0 1-.3-.29c0-.16.14-.3.3-.3h2.16c.16 0 .29.14.29.3a.3.3 0 0 1-.3.3Z",
    fill: "#6E82CD"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.32h-2.16a.29.29 0 1 1 0-.58h2.16a.29.29 0 1 1 0 .58Z",
    fill: "#6F82CE"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.3h-2.17a.28.28 0 1 1 0-.57h2.17c.16.01.28.14.28.3 0 .15-.12.28-.28.28Z",
    fill: "#6F83CF"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.3h-2.17a.28.28 0 1 1 0-.56h2.17c.15 0 .28.13.28.28 0 .16-.13.28-.28.28Z",
    fill: "#7083D0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.3h-2.17a.28.28 0 0 1-.28-.28c0-.15.13-.28.28-.28h2.17c.15 0 .28.13.28.28 0 .15-.13.28-.28.28Z",
    fill: "#7084D1"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.29h-2.17a.27.27 0 0 1-.28-.27c0-.15.13-.27.28-.27h2.17c.15 0 .27.12.27.27 0 .15-.12.27-.27.27Z",
    fill: "#7185D2"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.28h-2.17a.27.27 0 0 1-.27-.26c0-.15.12-.27.27-.27h2.17c.15 0 .27.12.27.26 0 .15-.12.27-.27.27Z",
    fill: "#7185D3"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.27h-2.18a.26.26 0 1 1 0-.52h2.18a.26.26 0 1 1 0 .52Z",
    fill: "#7286D4"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 6.27h-2.18a.25.25 0 1 1 0-.51h2.18c.15 0 .26.11.26.25s-.11.26-.26.26Z",
    fill: "#7286D5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.26h-2.19a.25.25 0 0 1-.25-.25c0-.14.11-.26.25-.26h2.19c.14 0 .25.12.25.26s-.11.25-.25.25Z",
    fill: "#7387D6"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.25h-2.2a.25.25 0 0 1-.24-.24c0-.14.1-.25.25-.25h2.19c.13 0 .25.1.25.24 0 .14-.12.25-.25.25Z",
    fill: "#7387D7"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.25h-2.2a.24.24 0 0 1-.24-.25c0-.13.1-.24.24-.24h2.2c.13 0 .24.1.24.24 0 .14-.11.25-.24.25Z",
    fill: "#7488D8"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.24h-2.2a.24.24 0 1 1 0-.48h2.2c.13 0 .24.1.24.24 0 .13-.1.24-.24.24Z",
    fill: "#7489D9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.23h-2.2a.23.23 0 1 1 0-.47h2.2c.13 0 .23.1.23.24 0 .13-.1.23-.23.23Z",
    fill: "#7589DA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.23h-2.2a.23.23 0 1 1 0-.46h2.2c.13 0 .23.1.23.22 0 .13-.1.24-.23.24Z",
    fill: "#758ADB"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.22h-2.2a.23.23 0 0 1-.23-.23c0-.12.1-.23.23-.23h2.2a.23.23 0 1 1 0 .45Z",
    fill: "#768ADC"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.21h-2.21a.22.22 0 0 1-.22-.22c0-.12.1-.22.22-.22h2.21c.12 0 .22.1.22.22s-.1.22-.22.22Z",
    fill: "#768BDC"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.2h-2.21a.21.21 0 0 1-.22-.2v-.01c0-.12.1-.22.22-.22h2.21c.12 0 .22.1.22.22s-.1.22-.22.22Z",
    fill: "#778BDD"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.2h-2.21a.2.2 0 1 1 0-.42h2.21c.12 0 .21.09.21.2 0 .12-.09.22-.2.22Z",
    fill: "#778CDE"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.19h-2.21a.2.2 0 1 1 0-.41h2.21c.12 0 .21.09.21.2 0 .12-.1.21-.2.21Z",
    fill: "#788CDF"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 6.18h-2.22a.2.2 0 0 1-.2-.2c0-.11.1-.2.2-.2h2.22c.12 0 .2.09.2.2a.2.2 0 0 1-.2.2Z",
    fill: "#788DE0"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.18h-2.23a.2.2 0 0 1-.2-.2c0-.11.1-.2.2-.2h2.23c.1 0 .2.09.2.2a.2.2 0 0 1-.2.2Z",
    fill: "#798EE1"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.17h-2.23a.2.2 0 1 1 0-.39h2.23c.1 0 .19.09.19.2 0 .1-.09.19-.2.19Z",
    fill: "#798EE2"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.16h-2.23a.19.19 0 1 1 0-.38h2.23c.1 0 .19.09.19.2 0 .1-.09.18-.19.18Z",
    fill: "#7A8FE3"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.16h-2.24a.18.18 0 1 1 0-.37h2.24c.1 0 .18.08.18.18 0 .1-.08.19-.18.19Z",
    fill: "#7A8FE4"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.15h-2.24a.18.18 0 0 1-.18-.18c0-.1.08-.18.18-.18h2.24c.1 0 .18.08.18.18 0 .1-.08.18-.18.18Z",
    fill: "#7B90E5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.14h-2.24a.17.17 0 0 1-.17-.17c0-.1.07-.18.17-.18h2.24c.1 0 .18.08.18.18 0 .1-.09.17-.18.17Z",
    fill: "#7B90E6"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.14h-2.25a.17.17 0 0 1-.16-.17c0-.1.07-.18.16-.18h2.25a.17.17 0 1 1 0 .34Z",
    fill: "#7C91E7"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.13h-2.25a.16.16 0 1 1 0-.33h2.25c.1 0 .17.07.17.16 0 .1-.08.17-.17.17Z",
    fill: "#7C92E8"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 6.12h-2.25a.16.16 0 1 1 0-.33h2.25c.1 0 .16.08.16.16v.01c0 .09-.07.16-.16.16Z",
    fill: "#7D92E9"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.11h-2.26a.15.15 0 0 1-.15-.15c0-.1.07-.16.15-.16h2.26c.08 0 .15.07.15.15 0 .1-.07.16-.15.16Z",
    fill: "#7D93EA"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.1h-2.26a.15.15 0 0 1-.15-.14c0-.1.07-.16.15-.16h2.26c.08 0 .14.07.14.15 0 .09-.06.16-.14.16Z",
    fill: "#7E93EB"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.1h-2.26a.15.15 0 0 1-.15-.15c0-.08.06-.15.15-.15h2.26c.08 0 .14.07.14.15 0 .08-.06.15-.14.15Z",
    fill: "#7E94EC"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.1H23.1a.14.14 0 1 1 0-.29h2.27c.08 0 .14.06.14.13v.01c0 .08-.06.14-.14.14Z",
    fill: "#7F94ED"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.08H23.1a.14.14 0 1 1 0-.28h2.27c.08 0 .14.07.14.14 0 .08-.07.14-.14.14Z",
    fill: "#7F95EE"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.08h-2.27a.13.13 0 0 1-.13-.13v-.01c0-.07.05-.13.13-.13h2.27c.07 0 .13.06.13.13 0 .08-.06.14-.13.14Z",
    fill: "#8095EF"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.07H23.1a.13.13 0 0 1-.13-.12v-.01c0-.07.05-.13.13-.13h2.27c.07 0 .13.06.13.13s-.06.13-.13.13Z",
    fill: "#8096F0"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.06h-2.27a.12.12 0 0 1-.13-.12c0-.07.06-.13.13-.13h2.27c.07 0 .12.06.12.13s-.05.12-.12.12Z",
    fill: "#8197F1"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.06H23.1a.12.12 0 1 1 0-.24h2.28c.07 0 .12.05.12.11 0 .07-.05.13-.12.13Z",
    fill: "#8197F2"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.05H23.1a.11.11 0 0 1-.12-.11v-.01c0-.06.06-.12.12-.12h2.28c.07 0 .12.06.12.12 0 .07-.05.12-.12.12Z",
    fill: "#8298F3"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M25.38 6.04H23.1a.1.1 0 0 1-.11-.1v-.01c0-.06.05-.11.1-.11h2.3c.05 0 .1.05.1.1v.02c0 .05-.05.1-.1.1Z",
    fill: "#8298F4"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M25.39 6.04h-2.3a.1.1 0 0 1-.1-.1v-.02c0-.05.05-.1.1-.1h2.3c.05 0 .1.05.1.1v.01a.1.1 0 0 1-.1.1Z",
    fill: "#8399F5"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M25.39 6.03h-2.3a.1.1 0 0 1-.1-.1c0-.06.05-.1.1-.1h2.3c.05 0 .1.04.1.1 0 .05-.05.1-.1.1Z",
    fill: "#8399F6"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M25.39 6.02h-2.3a.1.1 0 1 1 0-.2h2.3c.05 0 .09.05.09.1a.1.1 0 0 1-.1.1Z",
    fill: "#849AF7"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M44.53 10.12c.18-.2.5-.08.5.18l-.13 33.72c0 2.43-.42 20.97-3.84 20.97V14.01l3.47-3.9Z",
    fill: "#C2C2CE"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M44.51 10.1c.18-.19.5-.07.5.2l-.13 33.72c0 2.43-.42 20.97-3.84 20.97V14.01l3.47-3.9Z",
    fill: "#C3C3CF"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M44.48 10.1c.17-.2.5-.08.5.18l-.13 33.74C44.85 46.45 44.43 65 41 65V14.01l3.47-3.92Z",
    fill: "#C4C4D0"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M44.46 10.08c.17-.19.5-.07.49.2l-.13 33.74c0 2.43-.42 20.97-3.84 20.97V14.01l3.48-3.93Z",
    fill: "#C5C5D0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M44.43 10.07c.17-.19.5-.07.5.2l-.14 33.75c0 2.43-.41 20.97-3.84 20.97V14.01l3.48-3.94Z",
    fill: "#C6C6D1"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4 10.06c.17-.19.5-.07.5.19l-.14 33.77c0 2.43-.42 20.97-3.84 20.97V14.01l3.48-3.95Z",
    fill: "#C7C7D2"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M44.38 10.05c.17-.19.49-.07.48.19l-.12 33.78c0 2.43-.42 20.97-3.85 20.97V14.01l3.49-3.96Z",
    fill: "#C8C8D3"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M44.35 10.04c.18-.19.49-.07.49.19l-.13 33.8c0 2.42-.42 20.96-3.84 20.96V14.01l3.48-3.97Z",
    fill: "#C9C9D3"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M44.32 10.03a.28.28 0 0 1 .49.19l-.13 33.8c0 2.43-.42 20.97-3.84 20.97V14.01l3.48-3.98Z",
    fill: "#CACAD4"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 10.02a.28.28 0 0 1 .48.19l-.13 33.81c0 2.43-.42 20.97-3.84 20.97V14.01l3.49-4Z",
    fill: "#CBCBD5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M44.27 10a.28.28 0 0 1 .48.2l-.13 33.82c0 2.43-.42 20.97-3.84 20.97V14.01l3.49-4Z",
    fill: "#CCCCD6"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M44.24 10a.28.28 0 0 1 .48.18l-.13 33.84c0 2.43-.41 20.97-3.84 20.97V14.01l3.5-4.01Z",
    fill: "#CDCDD7"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M44.22 9.99a.27.27 0 0 1 .48.18l-.13 33.85c0 2.43-.42 20.97-3.84 20.97V14.01l3.49-4.02Z",
    fill: "#CECED7"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 9.98c.16-.19.47-.07.47.18l-.13 33.86c0 2.43-.42 20.97-3.84 20.97V14.01l3.5-4.03Z",
    fill: "#CFCFD8"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M44.17 9.96a.27.27 0 0 1 .47.19l-.13 33.87c0 2.43-.42 20.97-3.84 20.97V14.01l3.5-4.05Z",
    fill: "#D0D0D9"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M44.14 9.95a.27.27 0 0 1 .47.19l-.13 33.88c0 2.43-.41 20.97-3.84 20.97V14.01l3.5-4.06Z",
    fill: "#D1D1DA"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M44.11 9.94c.17-.18.48-.06.47.19l-.13 33.9c0 2.42-.41 20.96-3.84 20.96V14.01l3.5-4.07Z",
    fill: "#D2D2DB"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M44.09 9.93a.27.27 0 0 1 .47.19l-.13 33.9C44.43 46.45 44 65 40.59 65V14.01l3.5-4.08Z",
    fill: "#D2D2DB"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M44.06 9.92a.27.27 0 0 1 .47.18l-.13 33.92c0 2.43-.42 20.97-3.84 20.97V14.01l3.5-4.09Z",
    fill: "#D3D3DC"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M44.04 9.91a.27.27 0 0 1 .46.18l-.13 33.93c0 2.43-.42 20.97-3.84 20.97V14.01l3.5-4.1Z",
    fill: "#D4D4DD"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M44.01 9.9a.27.27 0 0 1 .46.18l-.13 33.94c0 2.43-.42 20.97-3.84 20.97V14.01l3.51-4.1Z",
    fill: "#D5D5DE"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M43.98 9.89a.27.27 0 0 1 .46.18l-.13 33.95c0 2.43-.41 20.97-3.84 20.97V14.01l3.51-4.12Z",
    fill: "#D6D6DE"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M43.96 9.88a.27.27 0 0 1 .46.18l-.13 33.96c0 2.43-.42 20.97-3.84 20.97V14.01l3.5-4.13Z",
    fill: "#D7D7DF"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M43.93 9.87c.17-.17.46-.06.46.18l-.13 33.97c0 2.43-.42 20.97-3.84 20.97V14.01l3.51-4.14Z",
    fill: "#D8D8E0"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9 9.86a.27.27 0 0 1 .46.18l-.13 33.98c0 2.43-.42 20.97-3.84 20.97V14.01l3.51-4.15Z",
    fill: "#D9D9E1"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M43.88 9.85a.26.26 0 0 1 .45.18l-.13 34c0 2.42-.42 20.96-3.84 20.96V14.01l3.52-4.16Z",
    fill: "#DADAE2"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M43.85 9.84c.17-.17.46-.06.45.18l-.13 34c0 2.43-.41 20.97-3.84 20.97V14.01l3.52-4.17Z",
    fill: "#DBDBE2"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M43.83 9.83a.26.26 0 0 1 .45.18l-.13 34.01c0 2.43-.42 20.97-3.84 20.97V14.01l3.52-4.18Z",
    fill: "#DCDCE3"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 9.81a.26.26 0 0 1 .45.18l-.13 34.03c0 2.43-.42 20.97-3.84 20.97V14.01l3.52-4.2Z",
    fill: "#DDDDE4"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M43.77 9.8c.16-.16.45-.05.45.18l-.13 34.04c0 2.43-.42 20.97-3.84 20.97V14.01l3.52-4.2Z",
    fill: "#DEDEE5"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 9.8a.26.26 0 0 1 .44.17l-.13 34.05c0 2.43-.42 20.97-3.84 20.97V14.01l3.53-4.22Z",
    fill: "#DFDFE5"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 9.78a.26.26 0 0 1 .45.18l-.13 34.06c0 2.43-.42 20.97-3.84 20.97V14.01l3.52-4.23Z",
    fill: "#E0E0E6"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7 9.77a.26.26 0 0 1 .43.18L44 44.02C44 46.45 43.6 65 40.16 65V14.01l3.53-4.24Z",
    fill: "#E1E1E7"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M39.82 64.97 7.59 63.5a24.37 24.37 0 0 0 6.5-16.56v-35.2c0-.27.12-.52.32-.68a3.87 3.87 0 0 1 2.2-.91c2-.1 2.66 1.81 4.63 1.88 2.04.07 2.34-1.96 4.62-2.09 2.21-.13 2.62 1.76 4.83 1.67 2.44-.1 2.92-2.41 5.15-2.3 1.93.1 2.4 1.9 4.3 1.99 1.33.06 2.5-.77 3.4-1.66.17-.18.49-.05.48.2l-.13 34.1c0 2.44-.29 21.03-4.07 21.03Z",
    fill: "#EAECFC"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "m3 52.6 34.56 1.18c.5.02.89.42.9.9.01 2.64.25 10.24 2.47 10.32L7.59 63.52S3.9 63.12 3 52.61Z",
    fill: "#D0D0DA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "m3 52.6 33.89 1.17c.24.01 1.12.24 1.12.48 0 1.32.02 10.66 2.48 10.75l-32.9-1.47S3.9 63.12 3 52.6Z",
    fill: "#D1D1DA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "m3 52.6 34.57 1.21s-.21 11.1 2.47 11.19L7.59 63.53S3.9 63.12 3 52.6Z",
    fill: "#D1D1D9"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m35.72 21-16.97.4c-.83 0-1.5-.84-1.47-1.67v-.34c.03-.83.72-1.51 1.54-1.53l16.85-.52c.84-.02 1.55.86 1.6 1.78v.12c0 .85-.7 1.77-1.55 1.76Z",
    fill: "#3794C7"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "m35.71 21-16.97.39c-.82 0-1.48-.83-1.46-1.66v-.34c.03-.83.72-1.51 1.54-1.53l16.84-.52c.85-.02 1.55.86 1.6 1.77v.13c0 .85-.7 1.76-1.55 1.76Z",
    fill: "#3895C7"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "m35.7 21-16.96.38c-.82 0-1.48-.82-1.46-1.65v-.34c.03-.83.72-1.51 1.54-1.53l16.83-.52c.85-.02 1.55.85 1.6 1.76v.14c0 .84-.7 1.76-1.54 1.75Z",
    fill: "#3996C8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "m35.7 20.99-16.96.39c-.82 0-1.48-.82-1.46-1.65v-.34c.03-.83.71-1.51 1.54-1.53l16.83-.52c.84-.02 1.54.85 1.58 1.76l.01.14c.01.84-.7 1.75-1.54 1.75Z",
    fill: "#3A97C8"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "m35.7 20.98-16.96.4c-.82 0-1.48-.82-1.46-1.65v-.34c.03-.83.71-1.51 1.53-1.53l16.83-.52c.84-.02 1.54.85 1.58 1.76l.01.14c.01.84-.69 1.75-1.54 1.74Z",
    fill: "#3B98C9"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "m35.69 20.98-16.95.39c-.82 0-1.48-.82-1.46-1.65v-.33c.03-.83.72-1.51 1.54-1.53l16.82-.52c.84-.02 1.54.84 1.58 1.75v.15c.01.84-.69 1.74-1.53 1.74Z",
    fill: "#3C99C9"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "m35.68 20.97-16.94.4c-.82 0-1.48-.82-1.46-1.65v-.33c.03-.83.71-1.51 1.53-1.53l16.81-.52c.84-.02 1.55.84 1.58 1.74l.01.16c.01.84-.68 1.74-1.53 1.73Z",
    fill: "#3D9ACA"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "m35.67 20.97-16.93.39c-.82 0-1.48-.81-1.46-1.64v-.33c.03-.83.71-1.51 1.53-1.53l16.81-.52c.84-.02 1.54.83 1.58 1.74l.01.16c0 .84-.7 1.73-1.54 1.73Z",
    fill: "#3E9BCA"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m35.66 20.96-16.92.4c-.82 0-1.48-.81-1.46-1.64v-.33c.03-.83.71-1.51 1.53-1.53l16.8-.52c.84-.02 1.54.83 1.58 1.73v.17c.01.84-.68 1.73-1.53 1.72Z",
    fill: "#3F9CCB"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "m35.66 20.96-16.92.39c-.82 0-1.48-.8-1.46-1.63v-.33c.03-.83.71-1.51 1.53-1.53l16.8-.52c.83-.02 1.53.83 1.57 1.73v.17c.01.84-.68 1.72-1.52 1.72Z",
    fill: "#409DCB"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "m35.65 20.95-16.92.4c-.82 0-1.47-.8-1.45-1.63v-.34c.03-.82.71-1.5 1.53-1.52l16.79-.52c.83-.02 1.53.82 1.57 1.72v.18c.01.84-.68 1.72-1.52 1.71Z",
    fill: "#419ECC"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "m35.64 20.95-16.9.39c-.83 0-1.48-.8-1.46-1.63v-.33c.03-.82.71-1.5 1.52-1.52l16.79-.53c.83-.01 1.53.82 1.57 1.72v.18c.02.85-.68 1.72-1.52 1.72Z",
    fill: "#429FCC"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "m35.63 20.94-16.9.4c-.82-.01-1.47-.8-1.45-1.63v-.33c.03-.82.71-1.5 1.52-1.52l16.78-.53c.84-.01 1.54.82 1.57 1.71v.2c.02.84-.68 1.7-1.52 1.7Z",
    fill: "#43A0CD"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "m35.63 20.94-16.9.39c-.82 0-1.47-.8-1.45-1.62v-.33c.03-.82.7-1.5 1.52-1.52l16.77-.52c.83-.02 1.53.8 1.57 1.7v.2c.02.84-.67 1.7-1.51 1.7Z",
    fill: "#44A1CD"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "m35.62 20.93-16.9.4c-.8-.01-1.46-.8-1.44-1.62v-.33c.03-.82.7-1.5 1.52-1.52l16.76-.52c.84-.02 1.54.8 1.57 1.7l.01.2c0 .84-.68 1.7-1.52 1.7Z",
    fill: "#45A2CE"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "m35.61 20.93-16.88.39c-.82 0-1.47-.79-1.45-1.61v-.33c.03-.82.7-1.5 1.52-1.52l16.76-.52c.83-.02 1.53.8 1.56 1.69l.01.2c0 .85-.68 1.7-1.52 1.7Z",
    fill: "#46A3CE"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "m35.6 20.92-16.87.4c-.82-.01-1.47-.8-1.45-1.61v-.33c.03-.82.7-1.5 1.51-1.52l16.76-.52c.83-.02 1.52.8 1.56 1.68v.22c.02.84-.67 1.69-1.5 1.68Z",
    fill: "#47A4CE"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "m35.6 20.92-16.87.39c-.82 0-1.47-.78-1.44-1.6v-.33c.02-.82.7-1.5 1.5-1.52l16.76-.52c.83-.02 1.52.8 1.55 1.68l.01.22c.01.84-.68 1.68-1.51 1.68Z",
    fill: "#48A5CF"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "m35.59 20.92-16.87.38c-.81 0-1.46-.78-1.44-1.6v-.32c.03-.82.7-1.5 1.51-1.52l16.74-.52c.83-.02 1.52.8 1.56 1.67v.23c.02.84-.67 1.68-1.5 1.68Z",
    fill: "#49A6CF"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "m35.58 20.91-16.86.39c-.81 0-1.46-.78-1.43-1.6v-.32c.02-.81.7-1.5 1.5-1.52l16.74-.52c.83-.02 1.52.79 1.55 1.67l.02.23c0 .84-.68 1.67-1.52 1.67Z",
    fill: "#4AA7D0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "m35.57 20.9-16.85.4c-.81 0-1.46-.78-1.44-1.6v-.32c.03-.82.7-1.5 1.5-1.52l16.74-.52c.83-.02 1.52.78 1.55 1.66l.02.24c0 .84-.68 1.67-1.52 1.67Z",
    fill: "#4BA8D0"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "m35.56 20.9-16.84.39c-.81 0-1.46-.77-1.44-1.59v-.32c.03-.82.7-1.5 1.51-1.52l16.72-.52c.83-.02 1.52.78 1.55 1.65l.02.25c0 .83-.68 1.66-1.52 1.66Z",
    fill: "#4CA9D1"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "m35.56 20.9-16.84.38c-.81 0-1.46-.76-1.44-1.58v-.32c.03-.82.7-1.5 1.5-1.52l16.72-.52c.83-.02 1.52.78 1.55 1.65l.02.25c0 .83-.68 1.66-1.51 1.66Z",
    fill: "#4DAAD1"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "m35.55 20.89-16.83.39c-.82 0-1.46-.77-1.44-1.58v-.32c.03-.82.7-1.5 1.5-1.52l16.72-.52c.82-.02 1.51.77 1.54 1.64l.02.26c0 .83-.68 1.65-1.51 1.65Z",
    fill: "#4EABD2"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "m35.54 20.89-16.82.38c-.81 0-1.46-.76-1.43-1.57v-.32c.02-.81.7-1.5 1.5-1.52l16.7-.52c.83-.02 1.52.77 1.54 1.64l.02.26c0 .83-.68 1.65-1.5 1.65Z",
    fill: "#4FACD2"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "m35.53 20.88-16.82.39c-.8 0-1.45-.76-1.43-1.58v-.31c.03-.82.7-1.5 1.5-1.52l16.7-.52c.83-.02 1.51.76 1.54 1.63l.02.27c0 .83-.67 1.64-1.5 1.64Z",
    fill: "#50ADD3"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "m35.53 20.88-16.82.38c-.8 0-1.45-.75-1.42-1.57v-.31c.02-.82.7-1.5 1.5-1.52l16.69-.52c.82-.02 1.5.76 1.54 1.62l.01.28c.01.83-.67 1.64-1.5 1.64Z",
    fill: "#51AED3"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "m35.52 20.87-16.8.39c-.82 0-1.46-.75-1.44-1.57v-.31c.03-.82.7-1.5 1.5-1.52l16.69-.52c.82-.02 1.5.75 1.53 1.62l.02.28c0 .83-.67 1.63-1.5 1.63Z",
    fill: "#52AFD4"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "m35.51 20.86-16.8.4c-.8 0-1.45-.76-1.42-1.57v-.31c.02-.82.69-1.5 1.5-1.52l16.67-.52c.83-.02 1.51.75 1.54 1.62l.01.28c0 .83-.67 1.63-1.5 1.62Z",
    fill: "#53B0D4"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "m35.5 20.86-16.8.39c-.8 0-1.44-.75-1.42-1.56v-.31c.03-.81.7-1.5 1.5-1.52l16.67-.52c.82-.02 1.5.75 1.53 1.6l.02.3c.01.83-.67 1.62-1.5 1.62Z",
    fill: "#54B1D5"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "m35.5 20.86-16.79.38c-.8 0-1.45-.74-1.42-1.55v-.32c.02-.8.69-1.5 1.5-1.51l16.66-.52c.82-.02 1.5.74 1.53 1.6l.02.3c0 .83-.67 1.62-1.5 1.62Z",
    fill: "#54B1D5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "m35.49 20.85-16.78.39c-.8 0-1.45-.74-1.43-1.55v-.32c.03-.8.7-1.5 1.5-1.51l16.65-.52c.83-.02 1.5.74 1.53 1.6l.02.3c.01.83-.67 1.61-1.5 1.61Z",
    fill: "#55B2D5"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "m35.48 20.84-16.77.4c-.8 0-1.44-.74-1.42-1.56v-.3c.02-.82.69-1.5 1.49-1.52l16.65-.52c.82-.01 1.5.74 1.53 1.6l.02.3c0 .83-.67 1.6-1.5 1.6Z",
    fill: "#56B3D6"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "m35.47 20.84-16.77.39c-.8 0-1.44-.74-1.41-1.55v-.3c.02-.81.69-1.5 1.49-1.52l16.65-.52c.82-.01 1.5.73 1.52 1.59l.02.31c0 .83-.67 1.6-1.5 1.6Z",
    fill: "#57B4D6"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "m35.47 20.83-16.77.4c-.8 0-1.43-.74-1.41-1.55v-.3c.02-.81.69-1.5 1.48-1.52l16.65-.52c.81-.01 1.5.73 1.52 1.58l.02.32c0 .83-.67 1.6-1.5 1.6Z",
    fill: "#58B5D7"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "m35.46 20.83-16.76.39c-.8 0-1.44-.73-1.41-1.54v-.31c.02-.8.69-1.5 1.48-1.51l16.64-.52c.82-.02 1.5.72 1.52 1.57l.02.33c0 .83-.67 1.6-1.5 1.59Z",
    fill: "#59B6D7"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "m35.45 20.82-16.75.39c-.8 0-1.44-.73-1.42-1.53v-.31c.02-.8.7-1.5 1.48-1.51l16.64-.52c.81-.02 1.5.72 1.51 1.57l.02.33c.02.83-.66 1.59-1.48 1.58Z",
    fill: "#5AB7D8"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "m35.44 20.82-16.74.39c-.8 0-1.44-.72-1.41-1.53v-.3c.02-.82.68-1.5 1.48-1.52l16.62-.52c.82-.01 1.5.72 1.52 1.57l.02.33c.01.83-.66 1.58-1.49 1.58Z",
    fill: "#5BB8D8"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "m35.43 20.82-16.73.38c-.8 0-1.44-.72-1.42-1.52v-.31c.02-.8.69-1.5 1.48-1.5l16.62-.53c.82-.01 1.5.71 1.52 1.56l.02.34c0 .83-.66 1.58-1.49 1.58Z",
    fill: "#5CB9D9"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "m35.43 20.81-16.73.39c-.8 0-1.43-.72-1.41-1.53v-.3c.02-.8.68-1.5 1.47-1.5l16.62-.53c.8-.01 1.49.71 1.5 1.55l.03.35c.01.83-.66 1.57-1.48 1.57Z",
    fill: "#5DBAD9"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "m35.42 20.8-16.73.4c-.8-.01-1.43-.72-1.4-1.53v-.3c.02-.8.68-1.5 1.47-1.51l16.6-.52c.82-.02 1.5.7 1.52 1.55l.02.35c.01.82-.66 1.57-1.48 1.57Z",
    fill: "#5EBBDA"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "m35.41 20.8-16.72.39c-.8 0-1.42-.71-1.4-1.52v-.3c.02-.8.68-1.5 1.47-1.5l16.6-.53c.82-.01 1.5.7 1.5 1.54l.03.36c.01.82-.66 1.56-1.48 1.56Z",
    fill: "#5FBCDA"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "m35.4 20.8-16.7.38c-.8 0-1.44-.7-1.41-1.51v-.3c.02-.8.68-1.5 1.47-1.5l16.6-.53c.8-.01 1.48.7 1.5 1.54l.02.36c.01.82-.66 1.56-1.47 1.56Z",
    fill: "#60BDDB"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "m35.4 20.8-16.7.38c-.8 0-1.43-.7-1.41-1.51v-.3c.02-.8.68-1.5 1.47-1.5l16.59-.53c.8-.01 1.48.7 1.5 1.53l.02.37c.01.82-.65 1.55-1.47 1.55Z",
    fill: "#61BEDB"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "m35.4 20.79-16.7.38c-.8 0-1.43-.7-1.41-1.5v-.3c.02-.8.68-1.5 1.47-1.5l16.58-.53c.81-.01 1.49.69 1.5 1.52l.03.38c0 .82-.66 1.55-1.48 1.55Z",
    fill: "#62BFDB"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "m35.38 20.78-16.69.39c-.8 0-1.42-.7-1.4-1.5v-.3c.02-.8.68-1.5 1.47-1.51l16.57-.52c.81-.02 1.49.68 1.5 1.52l.03.38c0 .82-.66 1.54-1.48 1.54Z",
    fill: "#63C0DC"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "m35.38 20.78-16.7.38c-.78 0-1.41-.7-1.39-1.5v-.3c.02-.8.68-1.48 1.47-1.5l16.57-.52c.8-.01 1.48.68 1.5 1.51l.02.4c0 .81-.66 1.53-1.47 1.53Z",
    fill: "#64C1DC"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "m35.37 20.77-16.68.39c-.8 0-1.42-.7-1.4-1.5v-.3c.02-.8.68-1.48 1.47-1.5l16.56-.52a1.5 1.5 0 0 1 1.5 1.5l.02.4c0 .82-.66 1.53-1.47 1.53Z",
    fill: "#65C2DD"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "m35.36 20.77-16.67.38c-.8 0-1.42-.69-1.4-1.49v-.3c.02-.8.68-1.48 1.46-1.5l16.56-.51a1.5 1.5 0 0 1 1.5 1.5l.02.4a1.5 1.5 0 0 1-1.47 1.52Z",
    fill: "#66C3DD"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "m35.35 20.76-16.66.39c-.8 0-1.42-.69-1.4-1.5v-.28c.02-.8.68-1.5 1.46-1.5l16.56-.52a1.5 1.5 0 0 1 1.49 1.49l.02.4a1.5 1.5 0 0 1-1.47 1.52Z",
    fill: "#67C4DE"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "m35.35 20.76-16.67.38c-.78 0-1.41-.68-1.39-1.48v-.3c.02-.8.68-1.48 1.46-1.5l16.55-.52a1.5 1.5 0 0 1 1.48 1.49l.03.4a1.5 1.5 0 0 1-1.46 1.53Z",
    fill: "#68C5DE"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "m35.34 20.75-16.66.39c-.79 0-1.41-.68-1.39-1.48v-.3c.02-.8.68-1.48 1.46-1.5l16.54-.51c.8-.02 1.47.65 1.49 1.48l.02.41a1.5 1.5 0 0 1-1.46 1.51Z",
    fill: "#69C6DF"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "m35.33 20.75-16.65.38c-.79 0-1.41-.68-1.39-1.48v-.29c.02-.8.67-1.48 1.46-1.5l16.53-.51c.8-.02 1.47.65 1.48 1.47l.03.42c.01.82-.65 1.5-1.46 1.5Z",
    fill: "#6AC7DF"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "m35.32 20.74-16.64.39c-.79 0-1.41-.68-1.39-1.48v-.29c.02-.8.67-1.48 1.46-1.5l16.53-.51c.8-.02 1.47.65 1.48 1.46l.02.43c.01.82-.65 1.5-1.46 1.5Z",
    fill: "#6BC8E0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "m35.32 20.74-16.64.38c-.79 0-1.41-.67-1.39-1.47v-.29c.02-.8.67-1.48 1.45-1.5l16.53-.51c.8-.02 1.47.64 1.48 1.46l.02.43c.01.82-.64 1.5-1.45 1.5Z",
    fill: "#6CC9E0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "m35.3 20.73-16.62.39c-.79 0-1.41-.67-1.39-1.47v-.29c.02-.8.67-1.48 1.45-1.5l16.52-.52c.8-.01 1.47.65 1.48 1.46l.02.44c.01.82-.64 1.5-1.45 1.5Z",
    fill: "#6DCAE1"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "m35.3 20.73-16.62.38a1.4 1.4 0 0 1-1.39-1.46v-.29c.02-.8.67-1.48 1.45-1.5l16.52-.51c.8-.02 1.46.63 1.47 1.45l.03.44c0 .82-.65 1.49-1.46 1.49Z",
    fill: "#6ECBE1"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "m35.3 20.72-16.63.39a1.4 1.4 0 0 1-1.38-1.46v-.29c.02-.8.67-1.48 1.45-1.5l16.5-.51c.8-.02 1.47.63 1.48 1.44l.03.45c0 .82-.65 1.48-1.46 1.48Z",
    fill: "#6FCCE2"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "m35.29 20.72-16.62.38a1.4 1.4 0 0 1-1.38-1.45v-.29c.02-.8.67-1.48 1.45-1.5l16.5-.51c.8-.02 1.46.63 1.47 1.44l.03.45c0 .81-.65 1.48-1.45 1.48Z",
    fill: "#70CDE2"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "m35.29 20.72-16.62.38c-.78 0-1.4-.74-1.38-1.54v-.14c.02-.8.67-1.54 1.45-1.56l16.5-.51c.8-.02 1.46.63 1.47 1.44l.03.45c0 .81-.65 1.48-1.45 1.48Z",
    fill: "url(#d)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "m25.36 24.48-7.44.13c-.37 0-.65-.37-.64-.73v-.15a.7.7 0 0 1 .68-.67l7.39-.19c.37 0 .68.38.7.79v.05c0 .37-.32.77-.7.77Z",
    fill: "#3794C7"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "m25.36 24.48-7.44.13c-.37 0-.65-.37-.64-.73v-.15a.7.7 0 0 1 .67-.67l7.4-.19c.36 0 .67.38.68.79v.05c.01.37-.3.77-.67.77Z",
    fill: "#3895C7"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "m25.35 24.48-7.43.13c-.37 0-.65-.37-.64-.73v-.15a.7.7 0 0 1 .68-.67l7.38-.19c.37 0 .68.38.7.78v.06c0 .37-.31.77-.69.77Z",
    fill: "#3996C8"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "m25.35 24.47-7.43.13c-.37 0-.65-.36-.64-.73v-.14a.7.7 0 0 1 .68-.67l7.38-.19c.37 0 .68.38.7.78v.06c0 .37-.32.77-.69.76Z",
    fill: "#3A97C8"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "m25.35 24.47-7.44.13c-.36 0-.64-.36-.63-.72v-.15a.7.7 0 0 1 .67-.67l7.38-.18c.37 0 .68.37.7.77v.07c0 .36-.31.76-.68.75Z",
    fill: "#3B98C9"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "m25.34 24.47-7.43.13c-.36 0-.64-.36-.63-.73v-.14a.7.7 0 0 1 .67-.67l7.38-.19c.36 0 .67.38.69.78v.06c0 .37-.3.76-.68.76Z",
    fill: "#3C99C9"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "m25.34 24.47-7.43.13c-.36 0-.64-.36-.63-.73v-.14a.7.7 0 0 1 .67-.67l7.38-.19c.36 0 .67.38.69.77v.07c0 .37-.3.76-.68.76Z",
    fill: "#3D9ACA"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "m25.34 24.47-7.43.13c-.36 0-.64-.36-.63-.73v-.14a.7.7 0 0 1 .67-.67l7.37-.18c.37 0 .68.37.69.76v.08c0 .36-.3.75-.67.75Z",
    fill: "#3E9BCA"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "m25.33 24.46-7.42.13c-.36 0-.64-.36-.63-.72v-.14a.7.7 0 0 1 .67-.67l7.37-.19c.37 0 .67.37.69.77v.07c0 .37-.3.76-.68.75Z",
    fill: "#3F9CCB"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "m25.33 24.46-7.42.13c-.36 0-.64-.36-.63-.72v-.14a.7.7 0 0 1 .67-.67l7.36-.19c.37 0 .68.37.7.77v.07c0 .37-.3.75-.68.75Z",
    fill: "#409DCB"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "m25.33 24.46-7.42.13c-.36 0-.64-.36-.63-.72v-.15a.7.7 0 0 1 .67-.66l7.36-.19c.37 0 .67.37.69.76v.08c0 .37-.3.75-.67.75Z",
    fill: "#419ECC"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "m25.32 24.46-7.41.13c-.36 0-.64-.36-.63-.72v-.14a.7.7 0 0 1 .67-.67l7.36-.19c.37 0 .67.37.68.76v.08c.01.37-.3.75-.67.75Z",
    fill: "#429FCC"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "m25.32 24.46-7.4.13c-.37 0-.65-.36-.64-.72v-.14a.7.7 0 0 1 .67-.67l7.36-.19c.37 0 .67.36.68.76v.08c0 .37-.3.75-.67.75Z",
    fill: "#43A0CD"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "m25.32 24.45-7.4.13c-.37 0-.65-.35-.64-.71v-.14a.7.7 0 0 1 .67-.67l7.35-.19c.37 0 .67.36.69.75v.1c0 .36-.3.74-.67.73Z",
    fill: "#44A1CD"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "m25.31 24.45-7.4.13c-.36 0-.64-.35-.63-.71v-.14a.7.7 0 0 1 .67-.67l7.35-.18c.37 0 .67.35.68.75v.09c0 .36-.3.73-.67.73Z",
    fill: "#45A2CE"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "m25.31 24.45-7.4.13c-.36 0-.64-.35-.63-.71v-.14a.7.7 0 0 1 .67-.67l7.35-.18c.36 0 .67.35.68.74v.1c0 .36-.3.73-.67.73Z",
    fill: "#46A3CE"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 24.45-7.4.13c-.35 0-.63-.35-.62-.71v-.15c.01-.35.31-.65.67-.66l7.35-.19c.36 0 .66.36.67.75l.01.1c0 .36-.3.73-.67.73Z",
    fill: "#47A4CE"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 24.44-7.4.13c-.35 0-.63-.34-.62-.7v-.15c.01-.35.3-.65.66-.66l7.35-.19c.36 0 .67.36.68.74v.1c0 .37-.3.74-.67.73Z",
    fill: "#48A5CF"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 24.44-7.4.13c-.35 0-.63-.35-.62-.7v-.15c.01-.35.31-.65.67-.66l7.34-.19c.36 0 .66.35.67.74l.01.1c0 .37-.3.74-.67.73Z",
    fill: "#49A6CF"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 24.44-7.4.13c-.35 0-.63-.34-.62-.7v-.14c.01-.36.31-.66.67-.67l7.34-.18c.36 0 .66.34.67.73v.1c0 .37-.3.73-.66.73Z",
    fill: "#4AA7D0"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 24.44-7.4.13c-.35 0-.63-.34-.62-.7v-.14c.01-.36.3-.66.66-.67l7.34-.18c.36 0 .67.34.68.73v.1c0 .37-.3.73-.67.73Z",
    fill: "#4BA8D0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 24.44-7.4.13c-.35 0-.63-.35-.62-.7v-.15c.01-.35.3-.65.66-.66l7.34-.19c.36 0 .66.35.67.73v.11c.01.37-.3.73-.66.73Z",
    fill: "#4CA9D1"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "m25.29 24.43-7.39.13c-.35 0-.63-.34-.62-.7v-.14c.01-.35.31-.65.66-.66l7.34-.19c.36 0 .66.35.67.73v.11c0 .37-.3.73-.66.72Z",
    fill: "#4DAAD1"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "m25.29 24.43-7.39.13c-.35 0-.63-.34-.62-.7v-.14a.7.7 0 0 1 .66-.66l7.33-.19c.37 0 .67.34.67.73l.01.11c0 .37-.3.72-.66.72Z",
    fill: "#4EABD2"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "m25.28 24.43-7.38.13c-.35 0-.63-.34-.62-.7v-.14a.7.7 0 0 1 .66-.66l7.33-.19c.36 0 .66.34.67.73l.01.11c0 .37-.3.72-.67.72Z",
    fill: "#4FACD2"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "m25.28 24.43-7.38.13c-.35 0-.63-.34-.62-.7v-.14c.01-.35.3-.65.66-.66l7.33-.18c.36 0 .66.33.67.71v.12c0 .37-.3.72-.66.72Z",
    fill: "#50ADD3"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "m25.28 24.43-7.38.13c-.35 0-.63-.34-.62-.7v-.14c.02-.35.31-.65.67-.66l7.31-.18c.37 0 .67.33.67.71l.01.12c0 .37-.3.72-.66.72Z",
    fill: "#51AED3"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "m25.27 24.42-7.37.13c-.35 0-.63-.33-.62-.69v-.14c.01-.35.3-.65.66-.66l7.32-.18c.36 0 .66.33.67.71v.12c0 .37-.3.72-.66.71Z",
    fill: "#52AFD4"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "m25.27 24.42-7.37.13c-.35 0-.63-.33-.62-.69v-.14c.01-.35.3-.65.66-.66l7.31-.18c.36 0 .66.33.67.7l.01.13c0 .37-.3.71-.66.71Z",
    fill: "#53B0D4"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "m25.27 24.42-7.37.13c-.35 0-.63-.33-.62-.7v-.13c.01-.35.3-.65.66-.66l7.31-.19c.36 0 .66.33.67.71v.13c0 .37-.3.71-.65.7Z",
    fill: "#54B1D5"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "m25.26 24.42-7.36.13c-.35 0-.63-.34-.62-.7v-.13c.01-.35.3-.65.66-.66l7.3-.18c.37 0 .67.33.67.7l.01.13c0 .37-.3.7-.66.7Z",
    fill: "#54B1D5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "m25.26 24.41-7.36.13c-.35 0-.63-.33-.62-.68v-.14c.01-.35.3-.65.66-.66l7.3-.19c.37 0 .66.33.67.7v.14c0 .37-.29.7-.65.7Z",
    fill: "#55B2D5"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "m25.25 24.41-7.35.13c-.35 0-.63-.33-.62-.68v-.14c.01-.35.3-.65.66-.66l7.3-.19c.36 0 .66.33.67.7v.14c0 .37-.3.7-.66.7Z",
    fill: "#56B3D6"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "m25.25 24.41-7.35.13c-.35 0-.63-.33-.62-.68v-.14c.01-.35.3-.65.66-.66l7.3-.18c.36 0 .65.32.66.7v.13c.01.37-.29.7-.65.7Z",
    fill: "#57B4D6"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "m25.25 24.4-7.35.14c-.36 0-.63-.33-.62-.68v-.14c.01-.35.3-.65.66-.66l7.3-.19c.35 0 .65.33.66.7v.14c0 .37-.29.7-.65.7Z",
    fill: "#58B5D7"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "m25.25 24.4-7.35.14c-.35 0-.63-.33-.62-.68v-.14c.01-.35.3-.65.66-.66l7.3-.18c.35 0 .65.32.65.69l.01.14c0 .36-.3.7-.65.7Z",
    fill: "#59B6D7"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "m25.24 24.4-7.34.13c-.35 0-.63-.32-.62-.68v-.13c.01-.35.3-.65.66-.66l7.29-.18c.36 0 .65.31.66.69v.14c0 .36-.29.7-.65.7Z",
    fill: "#5AB7D8"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "m25.24 24.4-7.34.13c-.35 0-.63-.32-.62-.68v-.13c.01-.35.3-.65.65-.66l7.3-.18c.35 0 .65.31.65.68l.01.15c0 .36-.29.7-.65.7Z",
    fill: "#5BB8D8"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "m25.23 24.4-7.33.13c-.35 0-.63-.32-.62-.68v-.13c.01-.35.3-.65.65-.66l7.29-.18c.36 0 .65.31.66.68v.15c.01.36-.29.7-.65.69Z",
    fill: "#5CB9D9"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "m25.23 24.4-7.33.13c-.35 0-.63-.32-.62-.68v-.13c.01-.35.3-.65.66-.66l7.28-.19c.36 0 .65.32.66.69l.01.15c0 .36-.3.7-.66.69Z",
    fill: "#5DBAD9"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "m25.23 24.4-7.34.12c-.35 0-.62-.31-.61-.67v-.13c.01-.35.3-.65.65-.66l7.28-.19c.36 0 .66.32.66.68l.01.16c0 .36-.3.69-.65.68Z",
    fill: "#5EBBDA"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "m25.22 24.4-7.33.12c-.35 0-.62-.31-.61-.67v-.13c.01-.35.3-.65.65-.65l7.28-.2c.36 0 .65.32.66.69v.15c0 .36-.29.69-.65.68Z",
    fill: "#5FBCDA"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "m25.22 24.4-7.33.12c-.35 0-.62-.31-.61-.67v-.13c.01-.35.3-.65.65-.66l7.28-.18c.35 0 .65.3.65.67l.01.16c0 .36-.3.68-.65.68Z",
    fill: "#60BDDB"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "m25.22 24.39-7.33.13a.64.64 0 0 1-.6-.67v-.13c0-.35.3-.65.64-.66l7.28-.18c.35 0 .65.3.65.67l.01.16c0 .36-.3.68-.65.68Z",
    fill: "#61BEDB"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "m25.21 24.39-7.32.12a.63.63 0 0 1-.61-.66v-.13c.01-.35.3-.65.65-.66l7.27-.18c.36 0 .65.3.66.67v.16c0 .36-.29.68-.65.68Z",
    fill: "#62BFDB"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "m25.21 24.38-7.32.13a.64.64 0 0 1-.61-.66v-.13c.01-.35.3-.65.65-.66l7.27-.18c.35 0 .65.3.65.66l.01.17c0 .36-.3.68-.65.67Z",
    fill: "#63C0DC"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 24.38-7.31.13a.63.63 0 0 1-.61-.66v-.13c.01-.35.3-.65.65-.66l7.26-.18c.36 0 .65.3.66.66v.17c0 .36-.28.68-.64.67Z",
    fill: "#64C1DC"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 24.38-7.31.13a.63.63 0 0 1-.61-.66v-.13c.01-.35.3-.65.65-.66l7.26-.18c.36 0 .65.3.65.66l.01.17c0 .36-.29.67-.65.67Z",
    fill: "#65C2DD"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 24.38-7.31.13a.63.63 0 0 1-.61-.66v-.13c.01-.35.3-.65.65-.65l7.26-.19c.35 0 .64.3.65.66v.18c.01.35-.28.66-.64.66Z",
    fill: "#66C3DD"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 24.38-7.3.12a.63.63 0 0 1-.62-.65v-.13c.01-.35.3-.65.65-.66l7.26-.18c.35 0 .64.3.64.66l.01.17c.01.36-.28.67-.64.67Z",
    fill: "#67C4DE"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 24.37-7.31.13a.63.63 0 0 1-.61-.65v-.13c.01-.35.3-.65.64-.66l7.26-.18c.35 0 .64.3.65.65v.18c.01.36-.28.67-.64.66Z",
    fill: "#68C5DE"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 24.37-7.31.13a.62.62 0 0 1-.6-.65v-.13c0-.35.3-.65.64-.66l7.25-.18c.35 0 .64.3.64.65l.02.18c0 .36-.3.66-.65.66Z",
    fill: "#69C6DF"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "m25.19 24.37-7.3.13a.62.62 0 0 1-.6-.66v-.12c0-.35.3-.65.64-.66l7.25-.18c.35 0 .64.29.64.65l.01.18c0 .36-.29.66-.64.66Z",
    fill: "#6AC7DF"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "m25.19 24.37-7.3.12a.62.62 0 0 1-.6-.65v-.12c0-.35.3-.65.63-.66l7.25-.18c.36 0 .65.29.65.65v.18c.01.36-.28.66-.63.66Z",
    fill: "#6BC8E0"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "m25.18 24.36-7.3.13a.62.62 0 0 1-.6-.65v-.12c.01-.35.3-.65.64-.66l7.25-.18c.35 0 .64.29.64.64l.01.2c0 .35-.28.65-.64.64Z",
    fill: "#6CC9E0"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "m25.18 24.36-7.3.13a.62.62 0 0 1-.6-.65v-.12c.01-.35.3-.65.64-.66l7.25-.18c.35 0 .64.28.64.64l.01.2c0 .35-.29.65-.64.64Z",
    fill: "#6DCAE1"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "m25.18 24.36-7.3.13a.62.62 0 0 1-.6-.65v-.12c.01-.35.3-.65.64-.66l7.24-.18c.36 0 .64.28.65.64l.01.2c0 .35-.3.64-.64.64Z",
    fill: "#6ECBE1"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "m25.17 24.36-7.29.13a.62.62 0 0 1-.6-.65v-.12c.01-.35.3-.65.64-.66l7.24-.18c.35 0 .64.28.64.63l.01.2c0 .36-.28.65-.64.65Z",
    fill: "#6FCCE2"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "m25.17 24.36-7.29.12a.62.62 0 0 1-.6-.64v-.12c.01-.35.3-.65.64-.66l7.23-.18c.35 0 .64.28.64.63l.02.2c0 .36-.29.65-.64.65Z",
    fill: "#70CDE2"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "m25.17 24.36-7.29.12c-.34 0-.61-.33-.6-.68v-.06c.01-.34.3-.67.64-.68l7.23-.18c.35 0 .64.28.64.63l.02.2c0 .36-.29.65-.64.65Z",
    fill: "url(#e)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "m31.12 24.4-3.59.04c-.36 0-.65-.37-.64-.74v-.15a.7.7 0 0 1 .68-.67l3.53-.1c.37 0 .68.39.7.79v.05c0 .38-.31.78-.68.77Z",
    fill: "#3794C7"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "m31.11 24.4-3.58.03c-.36 0-.65-.36-.64-.73v-.15a.7.7 0 0 1 .68-.66l3.53-.1c.37 0 .67.38.69.78v.05c0 .38-.3.77-.68.77Z",
    fill: "#3895C7"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.39-3.57.04c-.36 0-.65-.36-.64-.73v-.15a.7.7 0 0 1 .68-.66l3.52-.1c.37 0 .68.38.7.78v.06c0 .37-.3.76-.68.76Z",
    fill: "#3996C8"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.39-3.57.04c-.36 0-.65-.37-.64-.73v-.15a.7.7 0 0 1 .68-.66l3.52-.1c.37 0 .68.37.7.77v.06c0 .38-.31.77-.68.77Z",
    fill: "#3A97C8"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.39-3.57.04c-.36 0-.65-.36-.64-.73v-.15a.7.7 0 0 1 .68-.66l3.52-.1c.37 0 .68.37.69.77v.07c0 .37-.3.76-.68.76Z",
    fill: "#3B98C9"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.38-3.57.05c-.36 0-.65-.37-.64-.73v-.15a.7.7 0 0 1 .68-.66l3.51-.1c.37 0 .68.37.7.77v.06c0 .38-.3.77-.68.76Z",
    fill: "#3C99C9"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.38-3.57.04c-.36 0-.65-.36-.64-.72v-.15a.7.7 0 0 1 .68-.66l3.51-.1c.37 0 .68.37.7.76v.07c0 .37-.31.76-.68.76Z",
    fill: "#3D9ACA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.38-3.57.04c-.36 0-.65-.36-.64-.72v-.15a.7.7 0 0 1 .68-.66l3.5-.1c.38 0 .68.37.7.76v.08c0 .36-.3.75-.68.75Z",
    fill: "#3E9BCA"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "m31.1 24.38-3.57.04c-.36 0-.65-.36-.64-.72v-.15a.7.7 0 0 1 .68-.66l3.5-.1c.37 0 .68.36.7.76v.07c0 .37-.3.76-.68.76Z",
    fill: "#3F9CCB"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "m31.09 24.37-3.57.05c-.36 0-.64-.36-.63-.72v-.15a.7.7 0 0 1 .67-.66l3.5-.1c.38 0 .68.36.7.76v.07c0 .37-.3.76-.67.75Z",
    fill: "#409DCB"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "m31.08 24.37-3.55.04c-.36 0-.65-.35-.63-.71v-.15a.7.7 0 0 1 .67-.67l3.5-.1c.37 0 .67.37.69.76v.08c0 .37-.3.76-.68.75Z",
    fill: "#419ECC"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "m31.08 24.37-3.55.04c-.36 0-.65-.35-.63-.71v-.15a.7.7 0 0 1 .67-.66l3.5-.1c.37 0 .67.36.68.75v.09c0 .36-.3.74-.67.74Z",
    fill: "#429FCC"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "m31.08 24.37-3.56.04c-.36 0-.64-.35-.63-.71v-.15a.7.7 0 0 1 .67-.66l3.5-.1c.37 0 .67.36.69.75v.08c0 .37-.3.75-.67.75Z",
    fill: "#43A0CD"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "m31.07 24.37-3.55.04c-.35 0-.64-.35-.63-.71v-.15a.7.7 0 0 1 .67-.66l3.5-.1c.36 0 .67.36.68.75v.08c0 .37-.3.75-.67.75Z",
    fill: "#44A1CD"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "m31.07 24.36-3.54.05c-.36 0-.65-.35-.63-.71v-.15a.7.7 0 0 1 .67-.66l3.49-.1c.36 0 .67.36.68.75v.09c0 .36-.3.74-.67.73Z",
    fill: "#45A2CE"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "m31.07 24.36-3.54.04c-.36 0-.65-.34-.63-.7v-.15a.7.7 0 0 1 .67-.66l3.49-.1c.36 0 .67.35.68.74v.1c0 .36-.3.73-.67.73Z",
    fill: "#46A3CE"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "m31.06 24.36-3.54.04c-.36 0-.64-.35-.63-.7v-.15c.02-.36.31-.66.67-.66l3.49-.1c.37 0 .67.35.68.74v.1c0 .36-.3.73-.67.73Z",
    fill: "#47A4CE"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "m31.06 24.36-3.54.04c-.36 0-.64-.35-.63-.7v-.15c.02-.36.31-.66.67-.66l3.49-.1c.36 0 .66.35.67.74l.01.1c0 .36-.3.73-.67.73Z",
    fill: "#48A5CF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "m31.06 24.36-3.54.04c-.35 0-.64-.35-.62-.7v-.15c.01-.36.3-.66.66-.66l3.49-.1c.36 0 .66.35.67.74v.1c0 .36-.3.73-.66.73Z",
    fill: "#49A6CF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "m31.05 24.35-3.53.05c-.36 0-.64-.35-.63-.7v-.15c.02-.36.31-.66.67-.66l3.48-.1c.37 0 .67.35.68.73v.1c0 .37-.3.74-.67.73Z",
    fill: "#4AA7D0"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "m31.05 24.35-3.53.04c-.36 0-.64-.34-.63-.7v-.14c.02-.36.31-.66.67-.66l3.48-.1c.36 0 .66.35.67.73l.01.1c0 .37-.3.73-.67.73Z",
    fill: "#4BA8D0"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "m31.05 24.35-3.53.04c-.36 0-.64-.34-.63-.7v-.14c.02-.36.31-.66.67-.66l3.47-.1c.37 0 .67.34.68.73v.1c0 .37-.3.73-.66.73Z",
    fill: "#4CA9D1"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "m31.04 24.35-3.52.04c-.35 0-.64-.34-.62-.7v-.14c.01-.36.3-.66.66-.66l3.47-.1c.36 0 .67.34.68.72v.12c0 .36-.3.72-.67.72Z",
    fill: "#4DAAD1"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "m31.04 24.34-3.52.05c-.35 0-.64-.34-.62-.7v-.14a.7.7 0 0 1 .66-.67l3.47-.1c.36 0 .66.35.67.73v.12c0 .36-.3.72-.66.71Z",
    fill: "#4EABD2"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "m31.04 24.34-3.52.04c-.35 0-.63-.33-.62-.7v-.13a.7.7 0 0 1 .66-.66l3.47-.1c.36 0 .66.34.67.72v.12c0 .36-.3.72-.66.71Z",
    fill: "#4FACD2"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "m31.04 24.34-3.52.04c-.35 0-.63-.33-.62-.7v-.13c.01-.36.3-.66.66-.66l3.46-.1c.36 0 .66.34.67.72l.01.12c0 .36-.3.71-.66.7Z",
    fill: "#50ADD3"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "m31.03 24.34-3.51.04c-.36 0-.64-.33-.63-.7v-.13c.02-.36.31-.66.67-.66l3.46-.1c.36 0 .66.34.67.72v.12c0 .36-.3.71-.66.7Z",
    fill: "#51AED3"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "m31.03 24.34-3.51.04c-.36 0-.64-.33-.63-.7v-.13c.02-.36.31-.66.67-.66l3.45-.1c.36 0 .66.34.67.71l.01.13c0 .36-.3.7-.66.7Z",
    fill: "#52AFD4"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "m31.03 24.33-3.51.05c-.35 0-.63-.34-.62-.7v-.13c.01-.36.3-.66.66-.66l3.45-.1c.36 0 .66.33.67.71l.01.13c0 .36-.3.7-.66.7Z",
    fill: "#53B0D4"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "m31.02 24.33-3.5.04c-.36 0-.64-.33-.63-.68v-.14c.02-.36.31-.66.66-.66l3.45-.1c.36 0 .66.33.67.7v.14c.01.36-.29.7-.65.7Z",
    fill: "#54B1D5"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "m31.02 24.33-3.5.04c-.36 0-.64-.33-.63-.68v-.14c.02-.36.31-.66.66-.66l3.45-.1c.36 0 .66.33.67.7v.14c0 .36-.3.7-.65.7Z",
    fill: "#54B1D5"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "m31.02 24.33-3.5.04c-.36 0-.64-.33-.62-.69v-.13c.01-.36.3-.66.66-.66l3.44-.1c.36 0 .66.33.67.7v.14c0 .36-.3.7-.65.7Z",
    fill: "#55B2D5"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "m31.01 24.32-3.5.04c-.35 0-.63-.32-.61-.68v-.14c.01-.35.3-.65.66-.66l3.44-.1c.36 0 .66.33.67.7v.14c0 .37-.3.7-.66.7Z",
    fill: "#56B3D6"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "m31 24.32-3.49.04c-.35 0-.63-.32-.62-.68v-.13c.02-.36.31-.66.66-.66l3.44-.1c.36 0 .66.32.67.7v.14c0 .36-.29.7-.65.7Z",
    fill: "#57B4D6"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "m31 24.32-3.49.04c-.35 0-.62-.32-.61-.68v-.14c.01-.35.3-.65.66-.66l3.44-.1c.36 0 .65.33.66.7v.14c0 .37-.3.7-.65.7Z",
    fill: "#58B5D7"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "m31 24.32-3.49.04c-.35 0-.62-.32-.61-.68v-.13c.01-.36.3-.66.66-.66l3.43-.1c.36 0 .66.32.66.7l.01.13c0 .37-.3.7-.66.7Z",
    fill: "#59B6D7"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "m31 24.32-3.49.04c-.35 0-.63-.32-.61-.68v-.14c.01-.35.3-.65.65-.65l3.44-.1c.36 0 .65.32.66.69v.14c0 .37-.29.7-.65.7Z",
    fill: "#5AB7D8"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "m31 24.31-3.49.04c-.35 0-.62-.32-.61-.67v-.14c0-.35.3-.65.65-.65l3.43-.1c.36 0 .66.32.66.69l.01.14c0 .37-.3.7-.65.7Z",
    fill: "#5BB8D8"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "m31 24.31-3.49.04c-.35 0-.62-.32-.61-.67v-.14c0-.35.3-.65.65-.65l3.43-.1c.36 0 .65.31.66.68v.15c.01.37-.29.7-.65.7Z",
    fill: "#5CB9D9"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "m30.99 24.3-3.48.05c-.35 0-.63-.32-.61-.67v-.14c0-.35.3-.65.65-.66l3.43-.1c.35 0 .65.32.66.69v.15c0 .37-.3.7-.65.69Z",
    fill: "#5DBAD9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "m30.99 24.3-3.48.05c-.35 0-.63-.32-.61-.67v-.14c0-.35.3-.65.65-.65l3.42-.1c.36 0 .65.31.66.68l.01.15c0 .37-.3.7-.65.69Z",
    fill: "#5EBBDA"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "m30.98 24.3-3.47.05c-.35 0-.63-.32-.62-.67v-.13c.01-.36.3-.66.65-.66l3.43-.1c.35 0 .65.31.65.68l.01.15c0 .37-.3.69-.65.69Z",
    fill: "#5FBCDA"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "m30.98 24.3-3.47.04c-.35 0-.62-.3-.61-.66v-.14c0-.35.3-.65.65-.65l3.42-.1c.35 0 .65.3.65.67l.01.16c0 .37-.3.69-.65.68Z",
    fill: "#60BDDB"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "m30.98 24.3-3.47.04a.64.64 0 0 1-.61-.66v-.14c0-.35.3-.65.65-.65l3.41-.1c.36 0 .65.3.66.67v.16c.01.37-.28.68-.64.68Z",
    fill: "#61BEDB"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "m30.97 24.3-3.46.04a.63.63 0 0 1-.61-.67v-.13c0-.35.3-.65.65-.66l3.4-.1c.36 0 .66.31.66.68l.01.16c0 .37-.29.68-.65.68Z",
    fill: "#62BFDB"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "m30.97 24.3-3.46.04a.64.64 0 0 1-.61-.67v-.13c0-.35.3-.65.64-.66l3.41-.1c.36 0 .65.3.66.67v.17c.01.36-.28.68-.64.68Z",
    fill: "#63C0DC"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "m30.96 24.3-3.46.03a.63.63 0 0 1-.6-.66v-.13c0-.35.3-.65.64-.65l3.4-.1c.36 0 .65.3.66.66v.17c.02.36-.28.68-.64.67Z",
    fill: "#64C1DC"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "m30.96 24.3-3.45.03a.63.63 0 0 1-.61-.66v-.13c0-.35.3-.65.65-.65l3.4-.1c.35 0 .65.3.65.66l.01.18c0 .35-.29.67-.65.66Z",
    fill: "#65C2DD"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "m30.96 24.3-3.45.03a.63.63 0 0 1-.61-.66v-.13c0-.35.3-.65.65-.65l3.4-.1c.35 0 .64.3.65.66v.18c0 .35-.29.66-.64.66Z",
    fill: "#66C3DD"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "m30.96 24.29-3.45.04a.63.63 0 0 1-.61-.66v-.13c0-.35.3-.65.64-.65l3.4-.1c.35 0 .65.3.65.66v.17c.01.36-.28.67-.63.67Z",
    fill: "#67C4DE"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "m30.95 24.29-3.44.04a.63.63 0 0 1-.61-.66v-.13c0-.35.3-.65.64-.65l3.4-.1c.35 0 .64.3.65.65v.18c.01.36-.28.67-.64.67Z",
    fill: "#68C5DE"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "m30.95 24.28-3.45.04a.62.62 0 0 1-.6-.65v-.13c0-.35.3-.65.64-.65l3.4-.1c.35 0 .64.3.64.65l.01.18c0 .36-.29.67-.64.66Z",
    fill: "#69C6DF"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "m30.95 24.28-3.45.04a.62.62 0 0 1-.6-.65v-.13c0-.35.3-.65.64-.65l3.4-.1c.35 0 .64.29.64.65l.01.18c0 .36-.29.66-.64.66Z",
    fill: "#6AC7DF"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "m30.94 24.28-3.44.04a.62.62 0 0 1-.6-.65v-.13c0-.35.3-.65.64-.65l3.39-.1c.35 0 .64.29.64.65l.01.18c0 .36-.28.66-.64.66Z",
    fill: "#6BC8E0"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "m30.94 24.28-3.44.04a.62.62 0 0 1-.6-.65v-.13c0-.35.3-.65.64-.65l3.39-.1c.35 0 .64.29.64.64v.2c.01.35-.27.65-.63.65Z",
    fill: "#6CC9E0"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "m30.94 24.28-3.44.04a.62.62 0 0 1-.6-.65v-.13c0-.35.3-.65.64-.65l3.38-.1c.36 0 .65.28.65.64l.01.2c0 .35-.29.65-.64.65Z",
    fill: "#6DCAE1"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "m30.93 24.27-3.43.04a.62.62 0 0 1-.6-.64v-.13c0-.35.3-.65.64-.65l3.38-.1c.35 0 .64.28.64.64l.02.2c0 .35-.3.65-.65.64Z",
    fill: "#6ECBE1"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "m30.93 24.27-3.43.04a.62.62 0 0 1-.6-.64v-.13c0-.35.3-.65.64-.66l3.37-.1c.35 0 .65.29.65.64v.2c.01.36-.28.65-.63.65Z",
    fill: "#6FCCE2"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "m30.93 24.27-3.43.04a.62.62 0 0 1-.6-.64v-.13c0-.35.3-.65.64-.65l3.37-.1c.35 0 .64.28.64.63l.02.2c0 .36-.29.65-.64.65Z",
    fill: "#70CDE2"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "m30.93 24.27-3.43.04c-.34 0-.61-.33-.6-.68v-.06c0-.35.3-.68.64-.68l3.37-.1c.35 0 .64.28.64.63l.02.2c0 .36-.29.65-.64.65Z",
    fill: "url(#f)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.45 31.8-8.45.1c-.41 0-.74-.42-.72-.84v-.17a.8.8 0 0 1 .78-.75l8.39-.17c.42 0 .77.44.78.9v.06c0 .42-.35.87-.78.87Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.35 31.73-8.37.1c-.4 0-.72-.38-.7-.79v-.15c.02-.4.35-.75.75-.75l8.3-.17c.42 0 .75.38.76.81v.15c.01.41-.33.8-.74.8Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.24 31.66-8.28.1a.7.7 0 0 1-.68-.74v-.14c.02-.4.34-.73.73-.74l8.22-.16c.4 0 .73.32.73.72v.23c0 .4-.32.73-.72.73Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.24 31.66-8.28.1c-.39 0-.7-.38-.68-.78v-.07c.02-.4.35-.76.73-.77l8.22-.16c.4 0 .73.32.73.72l.01.23c0 .4-.33.73-.73.73Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 31.73-4.08.03c-.41 0-.74-.42-.72-.84v-.17a.8.8 0 0 1 .78-.75l4-.1c.43 0 .77.44.79.9v.06c0 .43-.36.88-.78.87Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.88 31.66-3.98.03c-.4 0-.72-.38-.7-.79v-.15c.02-.4.35-.75.75-.75l3.92-.09c.42 0 .75.38.76.81v.14c0 .42-.33.8-.75.8Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.77 31.59-3.89.03a.7.7 0 0 1-.68-.74v-.14c.02-.4.34-.74.73-.74l3.84-.09c.4 0 .72.32.72.72l.02.23c0 .4-.33.73-.74.73Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.77 31.59-3.89.03c-.39-.01-.7-.39-.68-.78v-.07c.02-.4.34-.76.73-.77l3.84-.09c.4 0 .72.32.72.72l.02.23c0 .4-.33.73-.74.73Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.86 39.02-4.07-.03c-.42-.02-.73-.44-.71-.85v-.17a.79.79 0 0 1 .79-.74l4.01-.04c.42 0 .76.45.77.91v.06c0 .42-.37.87-.8.86Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.75 38.95-3.98-.04c-.4-.01-.71-.39-.7-.8l.01-.15c.02-.4.37-.74.77-.74l3.92-.03c.41 0 .74.4.74.82v.15c0 .41-.35.8-.76.79Z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.64 38.87-3.89-.03a.7.7 0 0 1-.67-.74v-.15c.02-.4.36-.73.74-.72l3.84-.04c.4 0 .72.34.71.74l.01.23c0 .4-.34.72-.74.71Z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.64 38.87-3.89-.03c-.39-.01-.69-.4-.67-.79v-.07c.02-.4.36-.76.75-.75l3.83-.04c.4 0 .72.34.71.74l.01.23c0 .4-.34.72-.74.71Z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.64 31.67-4.07.02c-.42 0-.74-.42-.72-.83v-.17a.8.8 0 0 1 .77-.76l4.01-.1c.43 0 .77.45.79.9v.07c0 .42-.36.87-.78.87Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.53 31.6-3.98.02c-.4 0-.72-.38-.7-.78v-.16c.02-.4.35-.74.75-.74l3.92-.1c.41 0 .75.39.76.81v.15c0 .41-.34.8-.75.8Z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.42 31.52-3.89.03a.7.7 0 0 1-.68-.73v-.15c.02-.4.34-.73.73-.73l3.84-.1c.4 0 .72.33.72.73l.02.23c0 .4-.34.73-.74.72Z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.42 31.52-3.89.03c-.39 0-.7-.38-.68-.78v-.06c.02-.4.34-.77.73-.77l3.84-.1c.4 0 .72.33.72.73l.02.23c0 .4-.34.73-.74.72Z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.43 35.36-8.45-.07c-.42-.01-.73-.44-.7-.85v-.17a.8.8 0 0 1 .79-.74h8.4c.42 0 .75.46.76.91v.07c0 .42-.37.87-.8.85Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.33 35.29-8.37-.07c-.4-.01-.7-.4-.68-.8v-.16c.02-.4.37-.73.77-.73h8.3c.42 0 .74.4.74.83v.14c0 .42-.35.8-.76.79Z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.22 35.21-8.27-.06a.7.7 0 0 1-.67-.75v-.14c.03-.4.36-.73.75-.72h8.22c.4 0 .72.33.71.73l.01.23a.73.73 0 0 1-.75.71Z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.22 35.21-8.27-.06c-.4-.02-.69-.4-.67-.8v-.06c.03-.4.36-.76.75-.76h8.22c.4 0 .72.34.71.74v.23a.73.73 0 0 1-.74.71Z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 35.44-6.09-.03c-.41-.01-.73-.43-.71-.84v-.17a.8.8 0 0 1 .78-.75l6.04-.03c.42 0 .76.44.77.9v.06c0 .42-.36.87-.78.86Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.9 35.37-6-.04c-.4 0-.72-.38-.7-.79v-.15c.02-.4.37-.74.76-.74l5.95-.04c.41 0 .74.4.75.82v.14c0 .42-.35.8-.76.8Z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8 35.3-5.93-.04a.7.7 0 0 1-.67-.74v-.14c.02-.4.35-.73.74-.73l5.86-.04c.4 0 .72.33.72.73v.23c0 .4-.33.73-.73.72Z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8 35.3-5.92-.04c-.4-.01-.7-.39-.68-.78v-.07c.02-.4.36-.76.74-.76l5.87-.04c.4 0 .72.33.71.73l.01.23c0 .4-.34.73-.74.72Z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.46 46.18-8.46-.1c-.41-.02-.72-.44-.7-.85l.01-.18a.8.8 0 0 1 .79-.73l8.4.03c.42 0 .75.46.76.91v.06c-.02.43-.38.87-.8.86Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.35 46.1-8.37-.1c-.4-.01-.7-.4-.68-.8l.01-.15c.03-.4.37-.74.77-.73l8.3.03c.42 0 .74.4.74.82v.15c0 .42-.36.8-.77.78Z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.24 46.03-8.27-.1a.7.7 0 0 1-.66-.74v-.15c.03-.4.36-.72.75-.72l8.22.03c.4 0 .72.34.71.74v.23a.73.73 0 0 1-.75.7Z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.24 46.03-8.27-.1c-.4-.01-.69-.4-.66-.79v-.07c.03-.4.36-.75.75-.75l8.22.03c.4 0 .72.34.7.74l.01.23a.73.73 0 0 1-.75.7Z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 46.26-4.08-.07c-.4-.01-.72-.43-.7-.85l.01-.17a.8.8 0 0 1 .79-.74h4.01c.42.01.76.46.76.92v.06c0 .43-.37.87-.8.85Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.89 46.2-3.98-.08c-.4-.01-.71-.4-.69-.8l.01-.15c.03-.4.37-.74.77-.73h3.92c.41 0 .74.4.74.82v.15c0 .41-.36.8-.77.78Z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.78 46.12-3.89-.07a.7.7 0 0 1-.66-.75v-.14c.03-.4.37-.73.75-.72h3.84c.4 0 .72.34.7.74l.01.23a.73.73 0 0 1-.75.7Z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.78 46.12-3.89-.07c-.39-.01-.69-.4-.66-.8v-.06c.03-.4.36-.76.75-.75h3.84c.4 0 .71.34.7.74l.01.23a.73.73 0 0 1-.75.7Z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.64 46.31-4.07-.07c-.41-.02-.72-.44-.7-.85v-.17a.8.8 0 0 1 .8-.74h4c.43 0 .77.46.77.92v.06c-.01.42-.38.87-.8.85Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.54 46.24-3.99-.07c-.4-.02-.7-.4-.68-.8v-.16c.03-.4.38-.73.78-.73h3.92c.41 0 .74.4.74.83v.14c-.01.42-.36.8-.77.79Z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.43 46.16-3.9-.06a.7.7 0 0 1-.65-.75v-.14c.03-.4.36-.73.75-.72h3.84c.4 0 .71.33.7.74l.01.22a.73.73 0 0 1-.75.71Z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.43 46.16-3.9-.06c-.38-.02-.68-.4-.65-.8v-.07c.02-.4.36-.75.75-.75h3.83c.4 0 .72.34.71.74v.23a.73.73 0 0 1-.74.71Z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 49.76-8.45-.14c-.41-.02-.72-.44-.7-.85l.01-.18a.79.79 0 0 1 .8-.73l8.39.08c.42 0 .75.46.76.91v.07c-.02.42-.38.86-.8.84Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3 49.69-8.37-.14c-.4-.02-.7-.4-.68-.8l.01-.16c.03-.4.37-.73.77-.72l8.31.07c.41 0 .74.4.73.83v.14c0 .41-.36.8-.77.78Z",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 49.61-8.28-.13a.7.7 0 0 1-.66-.76v-.14c.03-.4.37-.72.75-.72l8.22.07c.4.01.72.35.7.75v.23c0 .4-.34.72-.74.7Z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2 49.61-8.28-.13c-.4-.02-.69-.4-.66-.8v-.07c.03-.4.37-.75.76-.74l8.21.07c.4 0 .72.34.7.74l.01.23a.72.72 0 0 1-.75.7Z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.96 49.99-6.09-.15c-.41-.02-.72-.44-.7-.86l.01-.17a.8.8 0 0 1 .8-.73l6.03.08c.42.01.76.46.76.92v.06c-.01.42-.38.87-.8.85Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.86 49.91-6-.14c-.4-.02-.71-.4-.68-.8v-.16c.03-.4.38-.74.78-.73l5.94.08c.41.01.74.4.73.83v.15c0 .41-.36.8-.77.77Z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.75 49.84-5.91-.14a.7.7 0 0 1-.66-.76v-.14c.03-.4.37-.73.75-.72l5.87.08c.4.01.71.35.7.75v.23a.73.73 0 0 1-.75.7Z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.75 49.84-5.91-.14c-.4-.02-.69-.4-.66-.8v-.07c.03-.4.37-.75.76-.75l5.86.09c.4 0 .71.34.7.74v.23a.73.73 0 0 1-.75.7Z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.14 38.95-6.1-.07c-.4-.02-.73-.44-.7-.85v-.17a.79.79 0 0 1 .79-.74h6.03c.42 0 .76.45.77.9v.07c0 .42-.37.87-.79.86Z",
    fill: "#C69158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.04 38.87-6.01-.06c-.4-.02-.71-.4-.69-.8v-.16c.03-.4.37-.73.77-.73h5.95c.4 0 .74.4.74.82v.15c0 .41-.35.8-.76.78Z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.93 38.8 18 38.73a.7.7 0 0 1-.67-.74v-.14c.03-.4.36-.73.75-.73h5.86c.4 0 .72.33.7.74l.02.22c0 .4-.34.73-.74.72Z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.93 38.8 18 38.73c-.39-.01-.69-.39-.67-.79v-.07c.03-.4.36-.75.75-.75h5.86c.4 0 .72.33.71.74l.01.22c0 .4-.34.73-.74.72Z",
    fill: "url(#P)"
  }))), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "m3 52.57 34.57 1.2S37.36 64.9 40.04 65L7.59 63.53S3.9 63.07 3 52.57Z",
    fill: "url(#Q)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "m54.4 34.6-15.11-.41a2.55 2.55 0 0 1-2.49-2.55v-8.1c0-1.23.98-2.25 2.23-2.3l15.5-.7A2.36 2.36 0 0 1 57 22.88v9.2a2.52 2.52 0 0 1-2.6 2.51Z",
    fill: "#515EBD"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "m54.4 34.59-15.13-.42a2.53 2.53 0 0 1-2.47-2.52v-8.12c0-1.23.98-2.24 2.22-2.3l15.5-.7c1.34-.06 2.46 1.01 2.46 2.34v9.22c0 1.4-1.16 2.54-2.58 2.5Z",
    fill: "#525FBE"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "m54.4 34.58-15.14-.42a2.52 2.52 0 0 1-2.46-2.51v-8.13a2.3 2.3 0 0 1 2.2-2.29l15.52-.7c1.33-.06 2.45 1 2.45 2.33v9.23a2.5 2.5 0 0 1-2.57 2.49Z",
    fill: "#5360BF"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "m54.4 34.56-15.16-.41a2.5 2.5 0 0 1-2.44-2.5v-8.14c0-1.22.96-2.22 2.18-2.28l15.53-.7c1.33-.05 2.43 1 2.43 2.32v9.25c0 1.39-1.15 2.5-2.54 2.46Z",
    fill: "#5461BF"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "m54.4 34.55-15.17-.41a2.49 2.49 0 0 1-2.43-2.48v-8.17c0-1.2.95-2.2 2.17-2.26l15.54-.7a2.3 2.3 0 0 1 2.42 2.3v9.27c0 1.38-1.15 2.49-2.54 2.45Z",
    fill: "#5562C0"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "m54.4 34.54-15.19-.42a2.47 2.47 0 0 1-2.41-2.46v-8.19c0-1.2.95-2.18 2.15-2.24l15.56-.7c1.3-.06 2.4.98 2.4 2.28v9.3a2.44 2.44 0 0 1-2.52 2.43Z",
    fill: "#5663C1"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "m54.39 34.53-15.2-.42a2.46 2.46 0 0 1-2.4-2.45v-8.2c0-1.2.95-2.17 2.15-2.23l15.57-.7c1.3-.05 2.38.98 2.38 2.27v9.3a2.43 2.43 0 0 1-2.5 2.43Z",
    fill: "#5764C2"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "m54.39 34.52-15.2-.42a2.44 2.44 0 0 1-2.4-2.43v-8.22c0-1.19.95-2.16 2.14-2.22l15.58-.7a2.26 2.26 0 0 1 2.36 2.25v9.33a2.41 2.41 0 0 1-2.48 2.4Z",
    fill: "#5865C3"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "m54.38 34.5-15.21-.41a2.43 2.43 0 0 1-2.37-2.42v-8.24a2.2 2.2 0 0 1 2.11-2.2l15.6-.7a2.24 2.24 0 0 1 2.35 2.24v9.34a2.4 2.4 0 0 1-2.48 2.4Z",
    fill: "#5965C4"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "m54.38 34.5-15.23-.43a2.41 2.41 0 0 1-2.35-2.4V23.4a2.2 2.2 0 0 1 2.1-2.18l15.6-.7a2.23 2.23 0 0 1 2.34 2.22v9.36a2.39 2.39 0 0 1-2.46 2.38Z",
    fill: "#5A66C4"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "m54.38 34.48-15.24-.42a2.4 2.4 0 0 1-2.34-2.39V23.4c0-1.16.92-2.12 2.08-2.17l15.62-.7a2.21 2.21 0 0 1 2.32 2.2v9.39c0 1.33-1.1 2.4-2.44 2.36Z",
    fill: "#5B67C5"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "m54.38 34.47-15.26-.42a2.38 2.38 0 0 1-2.32-2.37v-8.3c0-1.15.92-2.1 2.07-2.15l15.64-.7a2.2 2.2 0 0 1 2.3 2.19v9.4c0 1.32-1.1 2.38-2.43 2.35Z",
    fill: "#5C68C6"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "m54.38 34.46-15.27-.42a2.37 2.37 0 0 1-2.3-2.36v-8.31c0-1.15.9-2.09 2.05-2.14l15.64-.7a2.18 2.18 0 0 1 2.29 2.17v9.43a2.34 2.34 0 0 1-2.41 2.33Z",
    fill: "#5D69C7"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "m54.37 34.44-15.28-.42a2.35 2.35 0 0 1-2.3-2.34v-8.33c0-1.13.9-2.07 2.05-2.12l15.66-.7a2.17 2.17 0 0 1 2.27 2.15v9.45c0 1.3-1.08 2.35-2.4 2.31Z",
    fill: "#5E6AC8"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "m54.37 34.43-15.3-.42a2.34 2.34 0 0 1-2.27-2.33v-8.34c0-1.13.9-2.06 2.02-2.11l15.67-.7a2.15 2.15 0 0 1 2.26 2.14v9.46a2.3 2.3 0 0 1-2.38 2.3Z",
    fill: "#5F6BC9"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M54.37 34.42 39.07 34a2.32 2.32 0 0 1-2.27-2.31v-8.37a2.1 2.1 0 0 1 2-2.09l15.69-.7a2.14 2.14 0 0 1 2.24 2.12v9.48a2.29 2.29 0 0 1-2.36 2.29Z",
    fill: "#5F6CC9"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M54.37 34.4 39.05 34a2.3 2.3 0 0 1-2.25-2.3V23.3c0-1.11.88-2.03 2-2.08l15.69-.7c1.21-.06 2.22.9 2.22 2.1v9.5c0 1.29-1.06 2.31-2.34 2.28Z",
    fill: "#606DCA"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "m54.37 34.4-15.34-.43a2.3 2.3 0 0 1-2.23-2.28v-8.4c0-1.1.87-2 1.98-2.06l15.7-.7c1.21-.06 2.22.9 2.22 2.1v9.5c0 1.28-1.06 2.3-2.33 2.27Z",
    fill: "#616ECB"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "m54.36 34.38-15.34-.42a2.27 2.27 0 0 1-2.22-2.26v-8.42c0-1.1.87-2 1.97-2.05l15.72-.7a2.1 2.1 0 0 1 2.19 2.08v9.53a2.24 2.24 0 0 1-2.32 2.24Z",
    fill: "#626FCC"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M54.36 34.37 39 33.95a2.26 2.26 0 0 1-2.2-2.25v-8.44c0-1.08.86-1.98 1.95-2.03l15.73-.7a2.08 2.08 0 0 1 2.18 2.06v9.56a2.23 2.23 0 0 1-2.3 2.22Z",
    fill: "#6370CD"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "m54.36 34.36-15.37-.42a2.24 2.24 0 0 1-2.2-2.24v-8.45c0-1.08.86-1.97 1.95-2.02l15.74-.7a2.06 2.06 0 0 1 2.16 2.05v9.57a2.22 2.22 0 0 1-2.28 2.2Z",
    fill: "#6471CE"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "m54.36 34.35-15.39-.42a2.23 2.23 0 0 1-2.17-2.22v-8.48a2 2 0 0 1 1.92-2l15.76-.7a2.04 2.04 0 0 1 2.14 2.03v9.6a2.2 2.2 0 0 1-2.26 2.19Z",
    fill: "#6572CE"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "m54.36 34.33-15.4-.42a2.21 2.21 0 0 1-2.16-2.2v-8.5a2 2 0 0 1 1.91-1.98l15.77-.7a2.03 2.03 0 0 1 2.13 2.02v9.61c0 1.22-1.02 2.2-2.25 2.17Z",
    fill: "#6672CF"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "m54.36 34.32-15.42-.42a2.2 2.2 0 0 1-2.14-2.2v-8.5c0-1.05.84-1.92 1.9-1.97l15.78-.7a2.02 2.02 0 0 1 2.11 2v9.63c0 1.22-1.01 2.2-2.23 2.16Z",
    fill: "#6773D0"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "m54.35 34.31-15.42-.42a2.18 2.18 0 0 1-2.13-2.18V23.2c0-1.05.83-1.91 1.88-1.96l15.8-.7a2 2 0 0 1 2.1 1.98v9.65c-.01 1.21-1.01 2.18-2.23 2.15Z",
    fill: "#6874D1"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "m54.35 34.3-15.44-.43a2.17 2.17 0 0 1-2.11-2.16v-8.54c0-1.04.82-1.9 1.86-1.94l15.81-.71a1.98 1.98 0 0 1 2.08 1.98v9.66c0 1.2-1 2.17-2.2 2.14Z",
    fill: "#6975D2"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "m54.35 34.29-15.45-.43a2.15 2.15 0 0 1-2.1-2.14v-8.56c0-1.03.82-1.88 1.85-1.93l15.82-.71a1.97 1.97 0 0 1 2.06 1.96v9.69c0 1.2-.98 2.15-2.18 2.12Z",
    fill: "#6A76D3"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "m54.34 34.27-15.46-.42a2.14 2.14 0 0 1-2.08-2.13v-8.58c0-1.02.8-1.86 1.84-1.9l15.83-.72a1.96 1.96 0 0 1 2.05 1.95v9.7c0 1.19-.98 2.14-2.18 2.1Z",
    fill: "#6B77D3"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "m54.34 34.26-15.47-.42a2.12 2.12 0 0 1-2.07-2.12v-8.6c0-1.01.8-1.84 1.82-1.89l15.85-.71c1.1-.05 2.03.83 2.03 1.93v9.73a2.1 2.1 0 0 1-2.16 2.08Z",
    fill: "#6C78D4"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "m54.34 34.25-15.49-.42a2.1 2.1 0 0 1-2.05-2.1V23.1c0-1 .8-1.83 1.8-1.88l15.87-.71c1.1-.05 2.01.82 2.01 1.92v9.74c0 1.17-.97 2.1-2.14 2.07Z",
    fill: "#6D79D5"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "m54.34 34.25-15.49-.42a2.1 2.1 0 0 1-2.05-2.1V23.1c0-1 .8-1.83 1.8-1.88l15.87-.71c1.1-.05 2.01.82 2.01 1.92v9.74c0 1.17-.97 2.1-2.14 2.07Z",
    fill: "url(#R)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M40.52 24.83h-1.49c-.18 0-.32-.18-.32-.4v-1.18c0-.22.14-.4.32-.4l1.48-.07c.19 0 .35.17.35.4l.01 1.25c0 .22-.16.4-.35.4Z",
    fill: "#A1AEE6"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 24.83h-1.47c-.18 0-.32-.18-.32-.4v-1.19c0-.2.14-.39.32-.4l1.46-.06c.2 0 .36.17.36.4v1.24c.01.23-.15.41-.34.4Z",
    fill: "#A8B5E8"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 24.82h-1.47c-.18 0-.32-.18-.32-.4v-1.17c0-.21.14-.4.32-.4l1.46-.06c.19 0 .35.16.35.39l.01 1.24c0 .22-.16.4-.35.4Z",
    fill: "#AFBCEA"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M40.49 24.81h-1.46c-.18 0-.33-.18-.33-.39v-1.18c0-.2.15-.39.33-.4l1.45-.05c.19-.01.35.16.35.38v1.24c.01.22-.15.4-.34.4Z",
    fill: "#B6C3EC"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M40.48 24.8h-1.45c-.18 0-.32-.17-.32-.38v-1.18c0-.2.14-.39.32-.4l1.44-.05c.2-.01.35.16.35.38l.01 1.23c0 .23-.16.4-.35.4Z",
    fill: "#BDCAEE"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M40.47 24.8h-1.44c-.18 0-.33-.18-.33-.4v-1.16c0-.21.15-.39.32-.4l1.44-.06c.19 0 .35.17.35.39v1.23c0 .22-.15.4-.34.4Z",
    fill: "#C4D1F0"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "m40.46 24.8-1.44-.01c-.17 0-.32-.17-.32-.38v-1.17c0-.21.15-.39.32-.4l1.43-.05c.19-.01.34.16.35.38v1.22c0 .22-.15.4-.34.4Z",
    fill: "#CCD7F2"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M40.45 24.79h-1.43c-.17 0-.31-.18-.31-.4v-1.15c0-.21.14-.39.31-.4l1.42-.05c.2-.01.35.16.35.38v1.22c0 .22-.15.4-.34.4Z",
    fill: "#D3DEF4"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M40.44 24.78h-1.42c-.17 0-.32-.18-.32-.39v-1.15c0-.21.15-.39.32-.4l1.41-.05c.19-.01.34.16.34.38l.01 1.21c0 .22-.15.4-.34.4Z",
    fill: "#DAE5F6"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M40.43 24.77h-1.41c-.17 0-.31-.17-.31-.38v-1.16c0-.2.13-.38.3-.38l1.41-.06c.19-.01.34.16.35.38v1.2c0 .23-.15.4-.34.4Z",
    fill: "#E1ECF8"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M40.42 24.77h-1.4c-.18 0-.31-.18-.31-.39v-1.15c0-.2.13-.38.3-.38l1.4-.06c.2 0 .34.16.35.38v1.2c0 .22-.15.4-.34.4Z",
    fill: "#E8F3FA"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M40.42 24.76h-1.4c-.18 0-.31-.18-.31-.38v-1.15c0-.2.13-.38.3-.38l1.4-.06c.18 0 .33.16.33.38l.01 1.2c0 .21-.15.39-.33.39Z",
    fill: "#EFFAFC"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M40.42 24.76h-1.4c-.18 0-.31-.18-.31-.38v-1.15c0-.2.13-.38.3-.38l1.4-.06c.18 0 .33.16.33.38l.01 1.2c0 .21-.15.39-.33.39Z",
    fill: "#E4F2F4"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.27v-.25c-.01-.15.1-.28.25-.28l6.6-.16c.15 0 .28.12.29.27v.27c0 .16-.11.28-.27.28Z",
    fill: "#8792DD"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.27v-.25c-.01-.15.1-.28.25-.28l6.6-.16c.15 0 .28.12.29.27v.27c0 .16-.11.28-.27.28Z",
    fill: "#8893DD"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.28v-.24c-.01-.15.1-.28.25-.28l6.6-.16c.15 0 .28.12.28.27l.01.27c0 .16-.12.28-.27.28Z",
    fill: "#8994DE"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.28v-.24c-.01-.15.1-.28.25-.28l6.6-.16c.15 0 .28.12.28.27l.01.27c0 .16-.12.28-.27.28Z",
    fill: "#8A95DE"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.28v-.24c-.01-.15.1-.28.25-.28l6.6-.16c.15 0 .28.12.28.27l.01.27c0 .16-.12.28-.27.28Z",
    fill: "#8B96DE"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.28v-.24c-.01-.15.1-.28.25-.28l6.6-.16c.15 0 .28.12.28.27l.01.27c0 .16-.12.28-.27.28Z",
    fill: "#8C97DF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.14a.28.28 0 0 1-.27-.28v-.24c0-.15.1-.28.26-.28l6.59-.16c.15 0 .28.12.29.27v.27c0 .16-.12.28-.27.28Z",
    fill: "#8D98DF"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.6-.16c.14 0 .28.12.28.27v.27c.01.16-.1.28-.26.28Z",
    fill: "#8E99DF"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.24c0-.15.1-.28.26-.28l6.59-.16c.15 0 .28.12.29.27v.27c0 .16-.12.28-.27.28Z",
    fill: "#8F9AE0"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.24c0-.15.1-.28.26-.28l6.59-.16c.15 0 .28.12.29.27v.27c0 .16-.12.28-.27.28Z",
    fill: "#8F9BE0"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.59-.16c.15 0 .28.12.29.27v.27c.01.15-.11.28-.26.28Z",
    fill: "#909CE0"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.59-.16c.15 0 .28.12.29.27v.27c0 .15-.11.28-.26.28Z",
    fill: "#919DE1"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.25c0-.14.1-.27.26-.27l6.58-.17c.16 0 .29.12.3.28v.27c0 .15-.12.28-.27.28Z",
    fill: "#929EE1"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "m48.17 23.56-6.6.13a.28.28 0 0 1-.27-.27v-.25c0-.14.1-.27.26-.27l6.58-.17c.16 0 .29.12.3.27v.27c0 .16-.12.29-.27.29Z",
    fill: "#939FE1"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.56-6.59.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.59-.16c.15 0 .28.12.29.27v.27c0 .15-.11.28-.27.28Z",
    fill: "#94A0E1"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.56-6.59.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.59-.16c.15 0 .28.12.28.27l.01.26c0 .16-.12.29-.27.29Z",
    fill: "#95A1E2"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.56-6.58.13a.28.28 0 0 1-.28-.27v-.24c0-.15.1-.28.25-.28l6.59-.16c.15 0 .28.11.29.27v.26c0 .16-.11.29-.27.29Z",
    fill: "#96A2E2"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.56-6.59.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.58-.16c.16 0 .29.11.3.27v.26c0 .16-.12.29-.27.29Z",
    fill: "#97A3E2"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.59.14a.28.28 0 0 1-.27-.27v-.25c-.01-.15.1-.27.25-.27l6.58-.16c.16 0 .29.11.3.27v.26c0 .16-.12.29-.27.28Z",
    fill: "#98A4E3"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.59.14a.28.28 0 0 1-.27-.27v-.25c-.01-.15.1-.27.25-.27l6.58-.16c.15 0 .28.11.29.27v.26c.01.16-.1.28-.26.28Z",
    fill: "#99A5E3"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.59.14a.28.28 0 0 1-.27-.27v-.25c-.01-.15.1-.27.25-.27l6.58-.16c.15 0 .28.11.29.27v.26c.01.16-.1.28-.26.28Z",
    fill: "#9AA6E3"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.59.14a.28.28 0 0 1-.27-.27v-.25c-.01-.15.1-.27.25-.27l6.58-.16c.15 0 .28.11.29.27v.26c.01.16-.11.28-.26.28Z",
    fill: "#9BA7E4"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.59.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.58-.16c.15 0 .28.12.29.27v.27c.01.15-.11.27-.26.27Z",
    fill: "#9CA8E4"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.59.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.58-.16c.15 0 .28.12.29.27v.26c0 .16-.11.28-.26.28Z",
    fill: "#9DA9E4"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.58.14a.28.28 0 0 1-.28-.27v-.24c0-.15.1-.28.25-.28l6.58-.16c.16 0 .28.12.29.27v.26c.01.16-.11.28-.26.28Z",
    fill: "#9EAAE5"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.58.14a.28.28 0 0 1-.28-.27v-.24c0-.15.1-.28.25-.28l6.58-.16c.16 0 .28.12.29.27v.26c0 .16-.11.28-.26.28Z",
    fill: "#9FABE5"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "m48.16 23.55-6.58.14a.28.28 0 0 1-.28-.27v-.24c0-.15.1-.28.25-.28l6.58-.16c.16 0 .28.12.29.27v.26c0 .16-.11.28-.26.28Z",
    fill: "#A0ACE5"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.28.25-.28l6.58-.16c.15 0 .28.12.28.27l.01.26c0 .16-.12.28-.27.28Z",
    fill: "#A0ADE6"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.58-.16c.15 0 .28.11.28.27l.01.26c0 .16-.12.28-.27.28Z",
    fill: "#A1AEE6"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.57.13a.28.28 0 0 1-.28-.27v-.24c0-.14.1-.27.25-.27l6.58-.16c.15 0 .28.11.29.27v.26c0 .16-.11.28-.27.28Z",
    fill: "#A2AFE6"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.58-.16c.15 0 .28.11.28.27l.01.26c0 .16-.12.28-.27.28Z",
    fill: "#A3B0E7"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.23c-.01-.15.1-.28.25-.28l6.57-.16c.16 0 .28.12.3.27v.26c0 .16-.12.28-.27.28Z",
    fill: "#A4B1E7"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.23c-.01-.15.1-.28.25-.28l6.57-.16c.16 0 .28.12.29.27v.26c.01.16-.1.28-.26.28Z",
    fill: "#A5B2E7"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.57.13a.28.28 0 0 1-.28-.27v-.24c0-.14.1-.27.25-.27l6.58-.16c.15 0 .28.11.28.27l.01.26c0 .15-.12.28-.27.28Z",
    fill: "#A6B3E8"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.16c.16 0 .28.11.29.27v.26c0 .15-.11.28-.26.28Z",
    fill: "#A7B4E8"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.26c0 .15-.11.28-.26.28Z",
    fill: "#A8B5E8"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "m48.15 23.55-6.58.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.26c0 .15-.11.28-.26.28Z",
    fill: "#A9B6E9"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.55-6.57.13a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.26c0 .15-.11.28-.27.28Z",
    fill: "#AAB7E9"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.17c.15 0 .28.12.28.27l.01.27c0 .15-.11.28-.27.27Z",
    fill: "#ABB8E9"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.26l.01.26c0 .16-.12.28-.27.28Z",
    fill: "#ACB9EA"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.24-.27l6.58-.16c.14 0 .27.11.28.26v.26c.01.16-.1.28-.26.28Z",
    fill: "#ADBAEA"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.26v.26c.01.16-.1.28-.26.28Z",
    fill: "#AEBBEA"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c0-.14.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.25c0 .16-.12.28-.27.28Z",
    fill: "#AFBCEA"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c0-.14.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.25c0 .16-.12.28-.27.28Z",
    fill: "#B0BDEB"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.56-.16c.15 0 .28.11.29.26v.26c.01.16-.1.28-.26.28Z",
    fill: "#B1BEEB"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c0-.14.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.25c0 .16-.12.28-.27.28Z",
    fill: "#B1BFEB"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c0-.14.1-.27.25-.27l6.57-.16c.15 0 .28.11.28.27l.01.25c0 .16-.12.28-.27.28Z",
    fill: "#B2C0EC"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.15.1-.27.25-.27l6.56-.16c.15 0 .28.11.29.26v.26c0 .16-.11.28-.26.28Z",
    fill: "#B3C1EC"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.14a.28.28 0 0 1-.27-.27v-.24c-.01-.14.1-.27.25-.27l6.56-.16c.15 0 .28.12.29.27v.25c0 .16-.11.28-.26.28Z",
    fill: "#B4C2EC"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14 23.54-6.57.13a.28.28 0 0 1-.27-.26v-.24c-.01-.14.1-.27.25-.27l6.56-.16c.15 0 .28.12.28.27l.01.25c0 .16-.11.28-.26.28Z",
    fill: "#B5C3ED"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.26v-.24c-.01-.14.1-.27.25-.27l6.56-.16c.15 0 .28.12.28.27l.01.25c0 .16-.11.28-.27.28Z",
    fill: "#B6C4ED"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.26v-.24c-.01-.14.1-.27.25-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.16-.1.28-.26.28Z",
    fill: "#B7C5ED"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.26v-.24c-.01-.14.1-.27.25-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.16-.1.28-.26.28Z",
    fill: "#B8C6EE"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.26v-.24c-.01-.14.1-.27.25-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.16-.1.28-.26.28Z",
    fill: "#B9C6EE"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.27v-.23c-.01-.15.1-.27.25-.27l6.56-.16c.15 0 .28.11.28.26v.26c.01.16-.1.28-.26.28Z",
    fill: "#BAC7EE"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.27v-.23c-.01-.15.1-.27.24-.27l6.57-.16c.15 0 .27.11.28.26v.26c.01.15-.1.28-.26.28Z",
    fill: "#BBC8EF"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.29.27v.25c0 .15-.1.28-.26.28Z",
    fill: "#BCC9EF"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.02.15-.1.28-.25.28Z",
    fill: "#BDCAEF"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.54-6.56.13a.28.28 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.29.27v.25c0 .15-.11.28-.26.28Z",
    fill: "#BECBF0"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.53-6.56.14a.28.28 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.29.27v.25c0 .15-.11.28-.26.27Z",
    fill: "#BFCCF0"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.53-6.56.14a.28.28 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.02.15-.1.27-.25.27Z",
    fill: "#C0CDF0"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.53-6.56.14a.27.27 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.02.15-.1.27-.25.27Z",
    fill: "#C1CEF1"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.53-6.56.14a.27.27 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.25.27Z",
    fill: "#C1CFF1"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.53-6.56.14a.27.27 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.25.27Z",
    fill: "#C2D0F1"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.14a.27.27 0 0 1-.27-.27v-.23c-.01-.14.1-.26.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.26.27Z",
    fill: "#C3D1F2"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.14a.27.27 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.26.27Z",
    fill: "#C4D2F2"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "m48.13 23.53-6.56.14a.27.27 0 0 1-.27-.27v-.23c0-.14.1-.27.25-.27l6.55-.16c.15 0 .28.12.28.27l.01.25c0 .15-.12.27-.26.27Z",
    fill: "#C5D3F2"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.14a.27.27 0 0 1-.27-.27v-.23c-.01-.14.1-.27.24-.27l6.56-.16c.15 0 .27.12.28.27v.25c.01.15-.1.27-.26.27Z",
    fill: "#C6D4F2"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.14a.27.27 0 0 1-.27-.27v-.23c-.01-.15.1-.27.24-.27l6.56-.16c.15 0 .27.12.28.27v.25c0 .15-.1.27-.26.27Z",
    fill: "#C7D5F3"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.13a.27.27 0 0 1-.27-.26v-.23c-.01-.15.1-.27.24-.27l6.56-.16c.15 0 .27.12.28.27v.25c0 .15-.11.27-.26.27Z",
    fill: "#C8D6F3"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.56.13a.27.27 0 0 1-.26-.26v-.23c-.01-.15.1-.27.24-.27l6.55-.16c.15 0 .28.12.28.27v.25c.02.15-.1.27-.25.27Z",
    fill: "#C9D7F3"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.13a.27.27 0 0 1-.27-.26v-.23c-.01-.15.1-.27.24-.27l6.56-.16c.14 0 .27.12.28.27v.25c0 .15-.11.27-.26.27Z",
    fill: "#CAD8F4"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.13a.27.27 0 0 1-.27-.26v-.23c-.01-.15.1-.27.24-.27l6.56-.16c.14 0 .27.12.28.27v.24c0 .16-.11.28-.26.28Z",
    fill: "#CBD9F4"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.13a.27.27 0 0 1-.27-.26v-.23c-.01-.15.1-.27.24-.27l6.55-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.25.27Z",
    fill: "#CCDAF4"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.56.13a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.55-.16c.15 0 .27.12.28.27v.24c.01.16-.1.28-.25.28Z",
    fill: "#CDDBF5"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.13a.27.27 0 0 1-.27-.26v-.23c-.01-.15.1-.27.24-.27l6.55-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.25.27Z",
    fill: "#CEDCF5"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.55.13a.27.27 0 0 1-.27-.26v-.23c-.01-.15.1-.27.24-.27l6.55-.16c.15 0 .28.12.28.27v.25c.01.15-.1.27-.25.27Z",
    fill: "#CFDDF5"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.56.13a.27.27 0 0 1-.26-.26v-.23c-.01-.15.1-.27.24-.27l6.55-.16c.14 0 .27.12.28.27v.25c.01.15-.1.27-.25.27Z",
    fill: "#D0DEF6"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.53-6.56.13a.27.27 0 0 1-.26-.26v-.23c-.01-.15.1-.27.24-.27l6.55-.16c.14 0 .27.12.28.27v.25c.01.14-.1.27-.25.27Z",
    fill: "#D1DFF6"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.52-6.55.14a.27.27 0 0 1-.27-.27v-.22c0-.15.1-.27.24-.27l6.55-.16c.15 0 .28.11.28.27v.24c.01.15-.1.28-.25.27Z",
    fill: "#D2E0F6"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "m48.12 23.52-6.55.14a.27.27 0 0 1-.27-.27v-.22c0-.15.1-.27.24-.27l6.55-.16c.15 0 .28.11.28.27v.24c.01.15-.1.28-.25.27Z",
    fill: "#D2E1F7"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "m48.11 23.52-6.55.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.55-.16c.15 0 .27.12.28.27v.24c0 .15-.11.27-.26.27Z",
    fill: "#D3E2F7"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "m48.11 23.52-6.55.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.55-.16c.14 0 .27.12.28.27v.24c0 .15-.11.27-.26.27Z",
    fill: "#D4E3F7"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "m48.11 23.52-6.54.14a.27.27 0 0 1-.27-.27v-.22c0-.15.1-.27.24-.27l6.55-.16c.15 0 .27.12.28.27v.24c0 .15-.11.27-.26.27Z",
    fill: "#D5E4F8"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.55-.16c.14 0 .27.12.27.27v.24c.02.15-.1.27-.25.27Z",
    fill: "#D6E5F8"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.55-.16c.14 0 .27.11.27.27v.24c.01.15-.1.27-.25.27Z",
    fill: "#D7E6F8"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.54-.16c.15 0 .28.11.28.27v.24c.01.15-.1.27-.25.27Z",
    fill: "#D8E7F9"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.54-.16c.15 0 .28.11.28.27v.24c.01.15-.1.27-.25.27Z",
    fill: "#D9E8F9"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.14a.27.27 0 0 1-.26-.27v-.22c-.01-.15.1-.27.24-.27l6.54-.16c.15 0 .28.11.28.27v.24c.01.15-.1.27-.25.27Z",
    fill: "#DAE9F9"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.14a.27.27 0 0 1-.26-.27v-.22c-.01-.14.1-.27.24-.27l6.54-.16c.15 0 .28.11.28.27v.24c.01.15-.1.27-.25.27Z",
    fill: "#DBEAFA"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.14.1-.27.24-.27l6.54-.16c.15 0 .27.11.28.26v.25c0 .15-.1.27-.25.27Z",
    fill: "#DCEBFA"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.14.1-.27.24-.27l6.54-.16c.15 0 .27.11.28.26v.25c0 .15-.1.27-.26.27Z",
    fill: "#DDECFA"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.14.1-.27.24-.27l6.54-.16c.15 0 .27.11.28.26v.25c0 .15-.1.27-.26.27Z",
    fill: "#DEEDFB"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.54-.16c.15 0 .27.12.28.26v.25c0 .15-.11.27-.26.27Z",
    fill: "#DFEEFB"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .28.12.28.26v.25c.02.15-.1.27-.25.27Z",
    fill: "#E0EFFB"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .28.11.28.26v.25c.02.15-.1.27-.25.27Z",
    fill: "#E1F0FB"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.54-.16c.14 0 .27.11.27.26v.24c.01.16-.1.28-.25.28Z",
    fill: "#E2F1FC"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.54-.16c.14 0 .27.11.27.26v.24c.01.16-.1.28-.25.28Z",
    fill: "#E3F2FC"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .28.12.28.26v.25c.01.15-.1.27-.25.27Z",
    fill: "#E3F3FC"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.52-6.54.13a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .28.12.28.26v.25c.01.15-.1.27-.25.27Z",
    fill: "#E4F4FD"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.53.14a.27.27 0 0 1-.27-.27v-.21c0-.15.1-.27.24-.27l6.54-.16c.14 0 .27.11.27.26v.24c.01.16-.1.28-.25.27Z",
    fill: "#E5F5FD"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.14a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.12.28.26v.25c0 .14-.1.26-.25.26Z",
    fill: "#E6F6FD"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.14a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.12.28.26v.25c0 .14-.1.26-.25.26Z",
    fill: "#E7F7FE"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.14a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.12.28.26v.25c0 .14-.1.26-.25.26Z",
    fill: "#E8F8FE"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.14a.27.27 0 0 1-.26-.26v-.22c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.12.28.26v.25c0 .14-.1.26-.26.26Z",
    fill: "#E9F9FE"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.14a.27.27 0 0 1-.26-.27v-.21c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.11.28.26v.24c0 .15-.11.27-.26.27Z",
    fill: "#EAFAFF"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.13a.27.27 0 0 1-.26-.26v-.21c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.12.28.26v.24c0 .15-.11.27-.26.27Z",
    fill: "#EBFBFF"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1 23.51-6.54.13a.27.27 0 0 1-.26-.26v-.21c-.01-.15.1-.27.24-.27l6.53-.16c.15 0 .27.12.28.26v.24c0 .15-.11.27-.26.27Z",
    fill: "#E4F2F4"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "m42.23 24.58-.72-.01a.15.15 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.72-.02c.09 0 .15.07.15.15v.15c0 .09-.07.16-.15.16Z",
    fill: "#8792DD"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "m42.23 24.58-.72-.01a.15.15 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.72-.02c.09 0 .15.07.15.15v.15c0 .09-.07.16-.15.16Z",
    fill: "#8893DD"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "m42.23 24.58-.72-.01a.15.15 0 0 1-.15-.15v-.13c0-.08.06-.15.14-.15l.73-.02c.08 0 .15.07.15.15v.15c0 .08-.07.16-.15.16Z",
    fill: "#8994DE"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "m42.23 24.58-.72-.01a.15.15 0 0 1-.15-.15v-.13c0-.08.06-.15.14-.15l.73-.02c.08 0 .15.07.15.15v.15c0 .08-.07.16-.15.16Z",
    fill: "#8A95DE"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.15.15 0 0 1-.15-.15v-.13c0-.09.06-.15.14-.16h.73c.08-.01.15.06.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#8B96DE"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16h.72c.09-.01.16.06.16.14v.15c0 .08-.08.15-.16.15Z",
    fill: "#8C97DF"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.72-.02c.09 0 .16.07.16.15v.15c0 .08-.08.15-.16.15Z",
    fill: "#8D98DF"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.72-.02c.09 0 .16.07.16.15v.15c0 .08-.08.15-.16.15Z",
    fill: "#8E99DF"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8F9AE0"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8F9BE0"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#909CE0"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#919DE1"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.72-.02c.09 0 .16.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#929EE1"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M42.23 24.57h-.72a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16h.72c.09-.01.16.06.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#939FE1"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#94A0E1"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#95A1E2"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#96A2E2"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#97A3E2"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#98A4E3"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#99A5E3"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16h.72c.08-.01.15.05.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#9AA6E3"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.16h.72c.08-.01.15.05.15.14v.15c0 .08-.08.15-.16.15Z",
    fill: "#9BA7E4"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 24.57h-.71a.14.14 0 0 1-.15-.15v-.13c0-.08.07-.15.15-.15l.71-.02c.09 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#9CA8E4"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.15-.16h.71c.09-.01.15.05.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#9DA9E4"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.15-.16h.71c.09-.01.15.05.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#9EAAE5"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.15-.16h.71c.09-.01.15.05.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#9FABE5"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.15-.15l.71-.02c.09 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#A0ACE5"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.72-.01a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#A0ADE6"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.15-.15l.71-.02c.09 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#A1AEE6"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.14v-.13c0-.08.07-.15.15-.15l.71-.01c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A2AFE6"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.14v-.13c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A3B0E7"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.14v-.13c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A4B1E7"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.14-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#A5B2E7"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.72-.01a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#A6B3E8"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.72-.01a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.72-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#A7B4E8"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.15.15 0 0 1-.15-.15v-.12c0-.09.07-.15.14-.15l.72-.02c.08 0 .15.07.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#A8B5E8"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.15.15 0 0 1-.15-.15v-.12c0-.09.07-.15.14-.15l.72-.02c.08 0 .15.07.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#A9B6E9"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.15.15 0 0 1-.15-.15v-.12c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#AAB7E9"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 24.57-.71-.01a.15.15 0 0 1-.15-.15v-.12c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#ABB8E9"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "m42.21 24.57-.7-.01a.14.14 0 0 1-.15-.15v-.12c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#ACB9EA"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "m42.21 24.57-.7-.01a.14.14 0 0 1-.15-.15v-.12c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.15.14v.15c0 .08-.07.15-.16.15Z",
    fill: "#ADBAEA"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "m42.21 24.57-.7-.01a.14.14 0 0 1-.15-.15v-.12c0-.08.07-.15.14-.15l.72-.01c.08 0 .15.06.14.14v.14c0 .09-.06.16-.15.16Z",
    fill: "#AEBBEA"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.14-.15l.72-.02c.08 0 .15.07.14.15v.14c0 .09-.06.15-.15.15Z",
    fill: "#AFBCEA"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.7-.02c.1 0 .16.07.16.15v.14c0 .09-.07.15-.16.15Z",
    fill: "#B0BDEB"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.7-.02c.1 0 .16.07.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#B1BEEB"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.7-.02c.09 0 .16.07.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#B1BFEB"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.14-.15l.71-.02c.09 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B2C0EC"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.15-.15v-.12c0-.09.07-.15.14-.15l.71-.02c.09 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B3C1EC"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.15-.15v-.12c0-.09.06-.15.14-.15l.71-.02c.09 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B4C2EC"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.15-.15v-.12c0-.09.06-.15.14-.15l.71-.02c.09 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B5C3ED"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.15-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.09 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B6C4ED"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M42.21 24.56h-.7a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.14.14-.15h.7c.09-.01.16.05.16.14v.14c0 .08-.08.15-.16.15Z",
    fill: "#B7C5ED"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.14.14-.15h.71c.08-.01.15.05.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#B8C6EE"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B9C6EE"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BAC7EE"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BBC8EF"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BCC9EF"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BDCAEF"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#BECBF0"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.71-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#BFCCF0"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.56h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.7-.02c.09 0 .16.07.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#C0CDF0"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.09-.01.16.05.16.14v.14c0 .08-.07.15-.16.15Z",
    fill: "#C1CEF1"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.09-.01.16.05.16.14v.14c0 .08-.07.15-.16.15Z",
    fill: "#C1CFF1"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.09-.01.16.05.16.14v.14c0 .08-.07.15-.16.15Z",
    fill: "#C2D0F1"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.08-.01.15.05.15.14v.14c0 .08-.06.15-.15.15Z",
    fill: "#C3D1F2"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.08-.01.15.05.15.14v.14c0 .08-.06.15-.15.15Z",
    fill: "#C4D2F2"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.09-.01.15.05.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C5D3F2"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.08-.01.15.05.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C6D4F2"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15h.7c.08-.01.15.05.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C7D5F3"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01c-.07 0-.13-.07-.14-.14v-.12c0-.08.06-.15.14-.15l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#C8D6F3"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01c-.07 0-.13-.07-.14-.15v-.12c0-.08.06-.14.14-.15h.7c.08-.01.15.05.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C9D7F3"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7c-.08 0-.14-.07-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#CAD8F4"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7c-.08 0-.14-.07-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#CBD9F4"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7c-.07 0-.13-.07-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#CCDAF4"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.7-.02c.09 0 .16.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#CDDBF5"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#CEDCF5"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#CFDDF5"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.7-.01c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D0DEF6"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.7-.01c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D1DFF6"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2 24.56-.7-.01a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.7-.01c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D2E0F6"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#D2E1F7"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.7-.02c.08 0 .15.07.15.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#D3E2F7"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.7-.02c.08 0 .15.07.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#D4E3F7"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .09-.06.15-.15.15Z",
    fill: "#D5E4F8"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l.7-.01c.08 0 .14.06.14.14v.14c0 .08-.06.14-.15.14Z",
    fill: "#D6E5F8"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l.7-.01c.08 0 .14.06.14.14v.13c0 .09-.06.15-.15.15Z",
    fill: "#D7E6F8"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l.7-.01c.08 0 .14.06.14.14v.13c0 .08-.06.15-.15.15Z",
    fill: "#D8E7F9"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l.7-.01c.08 0 .14.06.14.14v.13c0 .08-.06.15-.15.15Z",
    fill: "#D9E8F9"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l.7-.01c.08 0 .14.06.14.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#DAE9F9"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l.7-.01c.08 0 .14.06.14.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#DBEAFA"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DCEBFA"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DDECFA"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DEEDFB"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DFEEFB"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E0EFFB"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2 24.55h-.7a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E1F0FB"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M42.19 24.55h-.69a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E2F1FC"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M42.19 24.55h-.69a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.07 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E3F2FC"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M42.19 24.55h-.69a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.7-.02c.07 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E3F3FC"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.14.14-.15h.69c.08-.01.15.05.15.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#E4F4FD"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .15.07.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E5F5FD"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .15.07.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E6F6FD"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.7-.01a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.14.15Z",
    fill: "#E7F7FE"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.7-.01a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.14.15Z",
    fill: "#E8F8FE"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01c-.07 0-.13-.06-.14-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .15.07.14.15v.13c0 .08-.06.15-.14.15Z",
    fill: "#E9F9FE"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01c-.07 0-.13-.06-.14-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.14.15Z",
    fill: "#EAFAFF"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01c-.07 0-.13-.06-.14-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.14.15Z",
    fill: "#EBFBFF"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "m42.19 24.55-.69-.01c-.07 0-.13-.06-.14-.14v-.12c0-.08.06-.14.14-.14l.69-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.14.15Z",
    fill: "#E4F2F4"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.09 0 .16.06.16.15v.15c0 .08-.08.15-.16.15Z",
    fill: "#8792DD"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.09 0 .16.06.16.15v.15c0 .08-.08.15-.16.15Z",
    fill: "#8893DD"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8994DE"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8A95DE"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8B96DE"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8C97DF"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#8D98DF"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.14.14 0 0 1-.14-.15v-.13c0-.08.07-.15.14-.15l.87-.02c.09 0 .16.07.16.15v.15c0 .08-.08.15-.16.15Z",
    fill: "#8E99DF"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M43.76 24.57h-.87a.14.14 0 0 1-.14-.15v-.13c0-.08.07-.15.14-.15l.87-.02c.09 0 .16.06.16.15v.15c-.01.08-.08.15-.16.15Z",
    fill: "#8F9AE0"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#8F9BE0"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#909CE0"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#919DE1"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#929EE1"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#939FE1"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#94A0E1"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#95A1E2"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.87-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#96A2E2"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.86-.02c.09 0 .16.06.16.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#97A3E2"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16l.86-.01c.09 0 .16.06.16.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#98A4E3"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16l.86-.01c.09 0 .16.06.16.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#99A5E3"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16l.86-.01c.09 0 .16.06.16.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#9AA6E3"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.16l.86-.01c.09 0 .16.06.16.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#9BA7E4"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.86-.02c.09 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#9CA8E4"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.86-.02c.09 0 .16.06.16.15v.14c0 .09-.08.16-.16.16Z",
    fill: "#9DA9E4"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.86-.02c.09 0 .16.06.16.15v.14c0 .09-.08.16-.16.16Z",
    fill: "#9EAAE5"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.86-.02c.09 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#9FABE5"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.57h-.86a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l.86-.02c.09 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#A0ACE5"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.86-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A0ADE6"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A1AEE6"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A2AFE6"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A3B0E7"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A4B1E7"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A5B2E7"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A6B3E8"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.15.15 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#A7B4E8"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.15.15 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#A8B5E8"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.15.15 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#A9B6E9"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#AAB7E9"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#ABB8E9"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 24.56h-.86a.14.14 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#ACB9EA"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.16.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#ADBAEA"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.15.15v.14c0 .08-.06.15-.15.15Z",
    fill: "#AEBBEA"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.15.15v.14c0 .08-.06.15-.15.15Z",
    fill: "#AFBCEA"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.15.15v.14c0 .08-.06.15-.15.15Z",
    fill: "#B0BDEB"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B1BEEB"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .16.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B1BFEB"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.09.07-.15.14-.15l.86-.02c.08 0 .15.06.15.15v.14c0 .08-.08.15-.16.15Z",
    fill: "#B2C0EC"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B3C1EC"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B4C2EC"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.09.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B5C3ED"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B6C4ED"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B7C5ED"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B8C6EE"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B9C6EE"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BAC7EE"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.56h-.85a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BBC8EF"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.55h-.85a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.15.16Z",
    fill: "#BCC9EF"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.55h-.85a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.15.16Z",
    fill: "#BDCAEF"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M43.74 24.55h-.85a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.15.16Z",
    fill: "#BECBF0"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.16.16Z",
    fill: "#BFCCF0"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.16.16Z",
    fill: "#C0CDF0"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.16.16Z",
    fill: "#C1CEF1"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.16.16Z",
    fill: "#C1CFF1"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.16.16Z",
    fill: "#C2D0F1"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.09 0 .15.06.15.15v.13c0 .09-.06.16-.15.16Z",
    fill: "#C3D1F2"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.13-.15l.85-.01c.08 0 .15.06.15.14v.14c0 .09-.06.16-.15.15Z",
    fill: "#C4D2F2"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.13-.15l.85-.01c.08 0 .15.06.15.14v.14c0 .09-.06.15-.15.15Z",
    fill: "#C5D3F2"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.13-.15l.85-.01c.08 0 .15.06.15.14v.14c0 .09-.07.15-.15.15Z",
    fill: "#C6D4F2"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.13-.15l.85-.01c.09 0 .15.06.15.14v.14c0 .09-.07.15-.15.15Z",
    fill: "#C7D5F3"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84c-.08 0-.14-.07-.14-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.09 0 .15.06.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#C8D6F3"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84c-.08 0-.14-.07-.14-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#C9D7F3"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84c-.08 0-.14-.06-.14-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CAD8F4"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84c-.08 0-.14-.06-.14-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CBD9F4"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84c-.08 0-.14-.06-.14-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CCDAF4"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CDDBF5"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CEDCF5"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.14.14-.14l.85-.02c.08 0 .15.06.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CFDDF5"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.84a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l.84-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D0DEF6"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D1DFF6"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D2E0F6"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D2E1F7"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D3E2F7"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D4E3F7"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M43.73 24.55h-.85a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D5E4F8"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .15.07.15.15v.13c0 .08-.07.15-.16.15Z",
    fill: "#D6E5F8"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.15.15Z",
    fill: "#D7E6F8"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.15.15Z",
    fill: "#D8E7F9"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.15.15Z",
    fill: "#D9E8F9"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.06.15-.15.15Z",
    fill: "#DAE9F9"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DBEAFA"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.84-.02c.09 0 .15.07.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DCEBFA"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DDECFA"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.85-.02c.08 0 .14.07.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DEEDFB"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l.84-.02c.09 0 .15.07.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#DFEEFB"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.84-.02c.09 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E0EFFB"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.84-.02c.09 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E1F0FB"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.84-.02c.09 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E2F1FC"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E3F2FC"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E3F3FC"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.55h-.84a.14.14 0 0 1-.13-.15v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#E4F4FD"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l.84-.02c.08 0 .15.07.15.15v.13c0 .08-.07.14-.15.14Z",
    fill: "#E5F5FD"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l.84-.02c.08 0 .15.07.15.15v.13c0 .08-.07.14-.15.14Z",
    fill: "#E6F6FD"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l.84-.02c.08 0 .15.07.15.15v.13c0 .08-.07.14-.15.14Z",
    fill: "#E7F7FE"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .14.06.14.15v.13c0 .08-.06.15-.14.14Z",
    fill: "#E8F8FE"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84c-.07 0-.13-.06-.13-.14v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .14.06.14.15v.13c0 .08-.06.14-.14.14Z",
    fill: "#E9F9FE"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84c-.07 0-.13-.06-.13-.14v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .14.06.14.15v.13c0 .08-.06.14-.14.14Z",
    fill: "#EAFAFF"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84c-.07 0-.13-.06-.13-.14v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .14.06.14.15v.13c0 .08-.06.14-.14.14Z",
    fill: "#EBFBFF"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M43.72 24.54h-.84c-.07 0-.13-.06-.13-.14v-.12c0-.08.06-.14.13-.14l.84-.02c.08 0 .14.06.14.15v.13c0 .08-.06.14-.14.14Z",
    fill: "#E4F2F4"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.09 0 .16.06.16.15v.14c0 .09-.07.16-.16.16Z",
    fill: "#8792DD"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.09 0 .16.07.16.15v.15c0 .09-.07.16-.16.16Z",
    fill: "#8893DD"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.08 0 .16.07.16.15v.15c0 .09-.08.16-.16.16Z",
    fill: "#8994DE"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.08 0 .16.07.16.15v.15c0 .09-.08.16-.16.16Z",
    fill: "#8A95DE"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.08 0 .16.07.16.15v.15c0 .09-.08.16-.16.16Z",
    fill: "#8B96DE"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.09 0 .16.07.16.15v.15c0 .09-.08.16-.16.16Z",
    fill: "#8C97DF"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.09 0 .16.06.16.15v.14c0 .09-.08.16-.16.16Z",
    fill: "#8D98DF"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#8E99DF"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#8F9AE0"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#8F9BE0"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .16.06.16.15v.14c0 .09-.08.16-.16.16Z",
    fill: "#909CE0"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.08 0 .16.07.16.15v.15c-.01.09-.08.16-.16.16Z",
    fill: "#919DE1"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.08 0 .16.07.16.15v.15c-.01.09-.08.16-.16.16Z",
    fill: "#929EE1"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.03c.08 0 .16.07.16.15v.15c-.01.09-.08.16-.16.16Z",
    fill: "#939FE1"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .16.06.16.15v.14c-.01.09-.08.16-.16.16Z",
    fill: "#94A0E1"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#95A1E2"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#96A2E2"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .09-.07.16-.15.16Z",
    fill: "#97A3E2"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M46.12 24.57h-1.65a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .08-.07.16-.15.16Z",
    fill: "#98A4E3"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.57h-1.64a.14.14 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .08-.07.16-.16.16Z",
    fill: "#99A5E3"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.09.06-.15.14-.16l1.65-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#9AA6E3"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.09.06-.15.14-.16l1.65-.02c.08 0 .15.07.15.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#9BA7E4"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#9CA8E4"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#9DA9E4"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.65-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#9EAAE5"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#9FABE5"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A0ACE5"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A0ADE6"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A1AEE6"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A2AFE6"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#A3B0E7"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M46.11 24.56h-1.64a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.14v.15c0 .08-.07.15-.15.15Z",
    fill: "#A4B1E7"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A5B2E7"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A6B3E8"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A7B4E8"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A8B5E8"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#A9B6E9"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#AAB7E9"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.14v-.13c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#ABB8E9"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#ACB9EA"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#ADBAEA"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#AEBBEA"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#AFBCEA"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B0BDEB"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#B1BEEB"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.15.15v.14c0 .08-.07.15-.16.15Z",
    fill: "#B1BFEB"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.14.15v.14c0 .08-.06.15-.15.15Z",
    fill: "#B2C0EC"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B3C1EC"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .15.06.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B4C2EC"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.09.06-.15.14-.15l1.64-.02c.08 0 .14.06.14.14v.14c0 .09-.07.16-.15.16Z",
    fill: "#B5C3ED"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.09 0 .15.06.15.14v.14c0 .09-.07.16-.15.16Z",
    fill: "#B6C4ED"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .14.06.14.14v.14c0 .09-.07.16-.15.16Z",
    fill: "#B7C5ED"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.64-.02c.08 0 .14.06.14.14v.14c0 .09-.07.16-.15.16Z",
    fill: "#B8C6EE"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.63-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#B9C6EE"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.63-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BAC7EE"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.63-.02c.09 0 .15.06.15.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#BBC8EF"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.63-.02c.09 0 .15.06.15.15v.13c0 .09-.07.16-.15.16Z",
    fill: "#BCC9EF"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .09-.07.16-.15.16Z",
    fill: "#BDCAEF"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.56h-1.63a.14.14 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .09-.07.15-.15.16Z",
    fill: "#BECBF0"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .09-.07.15-.15.15Z",
    fill: "#BFCCF0"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .09-.07.15-.15.15Z",
    fill: "#C0CDF0"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C1CEF1"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C1CFF1"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.64-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C2D0F1"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.64-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C3D1F2"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.64-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C4D2F2"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.64-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C5D3F2"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#C6D4F2"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.13c0-.08.06-.14.14-.15l1.63-.02c.08 0 .14.07.14.15v.14c0 .08-.06.15-.14.15Z",
    fill: "#C7D5F3"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.06.15-.15.15Z",
    fill: "#C8D6F3"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#C9D7F3"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CAD8F4"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CBD9F4"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CCDAF4"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.14-.15l1.63-.02c.08 0 .14.06.14.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#CDDBF5"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#CEDCF5"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#CFDDF5"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D0DEF6"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 24.55h-1.63a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D1DFF6"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D2E0F6"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D2E1F7"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D3E2F7"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D4E3F7"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D5E4F8"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D6E5F8"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D7E6F8"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.14v-.12c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.15v.13c0 .08-.07.15-.15.15Z",
    fill: "#D8E7F9"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#D9E8F9"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09 24.55h-1.63a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l1.63-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#DAE9F9"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.61a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.16.15Z",
    fill: "#DBEAFA"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.61a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.16.15Z",
    fill: "#DCEBFA"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.61a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l1.62-.02c.08 0 .14.06.14.14v.14c0 .08-.06.15-.15.15Z",
    fill: "#DDECFA"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.61a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l1.62-.02c.08 0 .14.06.14.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#DEEDFB"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.61a.14.14 0 0 1-.14-.15v-.11c0-.08.06-.15.14-.15l1.62-.02c.08 0 .14.06.14.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#DFEEFB"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.62a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#E0EFFB"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.62a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.15-.15.15Z",
    fill: "#E1F0FB"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.55h-1.62a.14.14 0 0 1-.13-.15v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.14c0 .08-.07.14-.15.15Z",
    fill: "#E2F1FC"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.61a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.14.13-.14l1.62-.02c.09 0 .15.06.15.14v.13c0 .09-.07.15-.15.15Z",
    fill: "#E3F2FC"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.61a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.14.13-.14l1.62-.02c.08 0 .15.06.15.14v.13c0 .09-.07.15-.15.15Z",
    fill: "#E3F3FC"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.61a.14.14 0 0 1-.14-.14v-.12c0-.08.06-.14.13-.14l1.62-.02c.08 0 .15.06.15.14v.13c0 .09-.07.15-.15.15Z",
    fill: "#E4F4FD"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.13c0 .09-.07.15-.15.15Z",
    fill: "#E5F5FD"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.13c0 .09-.07.15-.15.15Z",
    fill: "#E6F6FD"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.13c0 .09-.07.15-.15.15Z",
    fill: "#E7F7FE"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#E8F8FE"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62a.14.14 0 0 1-.13-.14v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#E9F9FE"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.61a.14.14 0 0 1-.14-.14v-.11c0-.08.06-.15.13-.15l1.62-.02c.08 0 .15.06.15.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#EAFAFF"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62c-.07 0-.13-.06-.13-.14v-.12c0-.08.06-.14.13-.14l1.62-.02c.08 0 .15.06.15.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#EBFBFF"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M46.08 24.54h-1.62c-.07 0-.13-.06-.13-.14v-.12c0-.08.06-.14.13-.14l1.62-.02c.08 0 .15.06.15.14v.13c0 .08-.07.15-.15.15Z",
    fill: "#E4F2F4"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "m45.85 32.37-6.48-.1a.6.6 0 0 1-.57-.6v-.54c.01-.32.27-.57.58-.57l6.48.04c.33 0 .6.28.6.61v.59c0 .33-.28.59-.6.57Z",
    fill: "#3794C7"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "m45.84 32.36-6.48-.1a.6.6 0 0 1-.56-.6v-.53c.01-.32.26-.57.58-.57l6.47.05c.33 0 .6.28.6.6l-.02.58c0 .33-.27.59-.6.57Z",
    fill: "#3C99C9"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "m45.82 32.35-6.46-.1a.6.6 0 0 1-.56-.6v-.52c.01-.32.26-.57.57-.57l6.47.05c.32 0 .59.27.59.6l-.01.57c0 .33-.27.59-.6.57Z",
    fill: "#419ECC"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "m45.8 32.34-6.44-.1a.6.6 0 0 1-.56-.6v-.51c.01-.32.26-.57.57-.57l6.45.04a.6.6 0 0 1 .59.6v.57c-.01.33-.28.59-.6.57Z",
    fill: "#47A4CE"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "m45.8 32.33-6.45-.1a.6.6 0 0 1-.55-.6v-.5c0-.32.26-.57.57-.57l6.43.04a.6.6 0 0 1 .59.6l-.01.56c0 .33-.27.58-.59.57Z",
    fill: "#4CA9D1"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "m45.78 32.32-6.43-.1a.6.6 0 0 1-.55-.6v-.5c0-.3.26-.56.56-.56l6.43.05a.6.6 0 0 1 .58.6v.55c0 .32-.27.57-.6.56Z",
    fill: "#51AED3"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "m45.76 32.31-6.41-.1a.59.59 0 0 1-.55-.6v-.49c0-.3.26-.56.56-.56l6.41.05a.6.6 0 0 1 .58.6v.54c0 .32-.27.57-.59.56Z",
    fill: "#56B3D6"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "m45.74 32.3-6.4-.1a.59.59 0 0 1-.54-.6v-.48c0-.31.25-.56.56-.56l6.4.05a.6.6 0 0 1 .57.6v.53c0 .32-.27.57-.59.56Z",
    fill: "#5BB8D8"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "m45.73 32.29-6.39-.1a.59.59 0 0 1-.54-.6v-.47c0-.31.25-.57.55-.56l6.39.04a.6.6 0 0 1 .57.6v.53c0 .32-.26.57-.58.56Z",
    fill: "#60BDDB"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "m45.71 32.28-6.37-.1a.58.58 0 0 1-.54-.59v-.47c.01-.31.25-.56.55-.56l6.38.04c.31 0 .57.28.57.6l-.01.52c0 .32-.26.57-.58.56Z",
    fill: "#66C3DD"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "m45.7 32.27-6.36-.1a.58.58 0 0 1-.54-.59v-.46c.01-.31.25-.56.55-.56l6.36.05c.31 0 .57.27.57.59l-.01.52c0 .31-.26.56-.57.55Z",
    fill: "#6BC8E0"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "m45.68 32.26-6.34-.1a.58.58 0 0 1-.54-.59v-.46c.01-.3.25-.55.55-.55l6.35.04c.3 0 .56.27.56.6v.5c0 .32-.26.57-.58.56Z",
    fill: "#70CDE2"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "m45.68 32.26-6.34-.1a.58.58 0 0 1-.54-.59v-.46c.01-.3.25-.55.55-.55l6.35.04c.3 0 .56.27.56.6v.5c0 .32-.26.57-.58.56Z",
    fill: "url(#S)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.09 0 .16.08.16.16v.15c0 .09-.08.16-.16.15Z",
    fill: "#69CBE0"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.15.15-.15h1.57c.09 0 .16.08.16.17v.15c0 .08-.08.15-.16.14Z",
    fill: "#6ACBE0"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.16-.15.15Z",
    fill: "#6BCCE0"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.16-.15.15Z",
    fill: "#6CCCE1"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.16-.15.15Z",
    fill: "#6DCCE1"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.16-.15.15Z",
    fill: "#6ECDE1"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.15.15Z",
    fill: "#6FCDE1"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.15.15Z",
    fill: "#70CEE2"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.15.15Z",
    fill: "#71CEE2"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.15.15Z",
    fill: "#72CEE2"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.13c0-.09.07-.16.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.16.15Z",
    fill: "#73CFE2"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.13c0-.09.07-.15.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.16.15Z",
    fill: "#74CFE3"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.15.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .09-.07.15-.16.15Z",
    fill: "#75CFE3"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.14c0-.08.07-.15.15-.15l1.57.01c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#76D0E3"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.14c0-.08.07-.15.15-.15l1.57.01c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#77D0E3"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.14c0-.08.07-.15.15-.15l1.57.01c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#78D1E4"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.57-.02a.16.16 0 0 1-.15-.16v-.14c0-.08.07-.15.15-.15l1.57.01c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#79D1E4"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.14c0-.08.07-.15.15-.15l1.56.01c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#7AD1E4"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.14c0-.08.07-.15.15-.15l1.56.01c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#7BD2E4"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.14c0-.08.07-.15.15-.15l1.56.01c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#7CD2E5"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5 31.66-1.58-.02a.16.16 0 0 1-.14-.16v-.13c0-.09.07-.15.15-.15h1.56c.09 0 .16.08.16.16v.15c0 .09-.07.15-.16.15Z",
    fill: "#7DD2E5"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.56-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.15.15-.15h1.57c.08 0 .15.08.15.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#7ED3E5"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.56-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.15.15-.15h1.56c.09 0 .16.08.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#7FD3E5"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.56-.02a.16.16 0 0 1-.15-.16v-.13c0-.09.07-.15.15-.15h1.56c.09 0 .16.08.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#80D3E5"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.56-.03a.16.16 0 0 1-.15-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.09 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#81D4E6"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#82D4E6"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#83D5E6"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#84D5E6"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#85D5E7"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#86D6E7"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#87D6E7"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.56-.03a.16.16 0 0 1-.15-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.14c-.01.1-.08.16-.16.16Z",
    fill: "#88D6E7"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.16.16 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.16Z",
    fill: "#89D7E8"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.15.15 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.16.16v.14c-.01.09-.08.16-.16.16Z",
    fill: "#8AD7E8"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.66-1.57-.03a.15.15 0 0 1-.14-.15v-.14c0-.08.07-.15.15-.15l1.56.01c.08 0 .16.07.15.16v.14c0 .09-.07.16-.15.16Z",
    fill: "#8BD8E8"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.65-1.57-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15h1.56c.08 0 .16.08.15.17v.14c0 .09-.07.16-.15.15Z",
    fill: "#8CD8E8"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.65-1.57-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15h1.56c.08 0 .15.08.15.17v.14c0 .09-.07.16-.15.15Z",
    fill: "#8DD8E9"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.65-1.57-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15h1.56c.08 0 .15.08.15.17v.14c0 .09-.07.16-.15.15Z",
    fill: "#8ED9E9"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.65-1.57-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#8FD9E9"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "m41.49 31.65-1.57-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#90D9E9"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.16.15Z",
    fill: "#91DAEA"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.16.15Z",
    fill: "#92DAEA"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.56c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.14Z",
    fill: "#93DBEA"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.56c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.14Z",
    fill: "#94DBEA"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.56c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.14Z",
    fill: "#95DBEA"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.16.15Z",
    fill: "#96DCEB"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .09-.07.16-.16.15Z",
    fill: "#97DCEB"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.56c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.14Z",
    fill: "#98DCEB"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.09 0 .16.07.16.16v.15c0 .08-.08.15-.16.14Z",
    fill: "#99DDEB"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#9ADDEC"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#9BDDEC"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#9CDEEC"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#9DDEEC"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#9EDFED"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#9FDFED"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A0DFED"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.15.15Z",
    fill: "#A1E0ED"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A2E0EE"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A3E0EE"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A4E1EE"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A5E1EE"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A6E2EF"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A7E2EF"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A8E2EF"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#A9E3EF"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#AAE3F0"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.02a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.14-.14h1.56c.08 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#ABE3F0"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.14-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.15.15Z",
    fill: "#ACE4F0"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.15-.15l1.55.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.15.15Z",
    fill: "#ADE4F0"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "m41.48 31.65-1.56-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.15-.15l1.55.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.15.15Z",
    fill: "#AEE4F0"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.14-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#AFE5F1"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.14-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#B0E5F1"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.14-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#B1E6F1"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l1.56.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#B2E6F1"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.15.15-.15l1.55.01c.08 0 .15.07.15.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#B3E6F2"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.14.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .08-.08.15-.16.15Z",
    fill: "#B4E7F2"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.55-.03c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.14.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .08-.08.15-.16.15Z",
    fill: "#B5E7F2"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.65-1.54-.03c-.08 0-.15-.07-.15-.15v-.13c0-.08.07-.14.15-.14h1.55c.08 0 .15.07.15.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#B6E7F2"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.15-.15l1.55.01c.08 0 .14.07.14.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#B7E8F3"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.15-.15l1.55.01c.08 0 .14.07.14.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#B8E8F3"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.15-.15l1.55.01c.08 0 .14.07.14.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#B9E9F3"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.09 0 .15.07.15.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#BAE9F3"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.09 0 .15.07.15.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#BBE9F4"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.09 0 .15.07.15.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#BCEAF4"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.09 0 .15.07.15.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#BDEAF4"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.06-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.16-.15.15Z",
    fill: "#BEEAF4"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.16-.15.15Z",
    fill: "#BFEBF5"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.16-.15.15Z",
    fill: "#C0EBF5"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.07-.14-.15v-.13c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.16-.15.15Z",
    fill: "#C1EBF5"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.14-.15h1.55c.08 0 .15.08.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#C2ECF5"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.14-.15h1.55c.08 0 .15.08.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#C3ECF5"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.14-.15h1.55c.08 0 .15.08.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#C4EDF6"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.14-.15h1.55c.08 0 .15.08.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#C5EDF6"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.08-.14-.16v-.12c0-.08.06-.15.14-.15h1.55c.08 0 .15.08.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#C6EDF6"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02c-.08 0-.14-.08-.14-.16v-.12c0-.08.06-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.15.15Z",
    fill: "#C7EEF6"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.15.15Z",
    fill: "#C8EEF7"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.15.15Z",
    fill: "#C9EEF7"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.15.15Z",
    fill: "#CAEFF7"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.15.15Z",
    fill: "#CBEFF7"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "m41.47 31.64-1.55-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.15.15Z",
    fill: "#CCF0F8"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.15l1.55.01c.08 0 .15.07.15.16v.13c0 .09-.07.15-.16.15Z",
    fill: "#CDF0F8"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.14h1.55c.08 0 .15.07.15.16v.14c0 .08-.07.14-.16.14Z",
    fill: "#CEF0F8"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.14h1.55c.08 0 .15.07.15.16v.14c0 .08-.08.14-.16.14Z",
    fill: "#CFF1F8"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.14h1.55c.08 0 .15.07.15.16v.13c0 .08-.08.15-.16.15Z",
    fill: "#D0F1F9"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.14h1.55c.08 0 .15.07.15.16v.13c0 .08-.08.15-.16.15Z",
    fill: "#D1F1F9"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.14h1.55c.08 0 .14.07.14.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D2F2F9"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.14h1.55c.08 0 .14.07.14.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D3F2F9"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.14-.14h1.55c.08 0 .14.07.14.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D4F3FA"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D5F3FA"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.02a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D6F3FA"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.54.01c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D7F4FA"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.54.01c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D8F4FA"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l1.54.01c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#D9F4FB"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#DAF5FB"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#DBF5FB"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#DCF5FB"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#DDF6FC"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#DEF6FC"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#DFF7FC"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#E0F7FC"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.64-1.54-.03a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.14h1.54c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.15Z",
    fill: "#E1F7FD"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.63-1.54-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.14Z",
    fill: "#E2F8FD"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "m41.46 31.63-1.54-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .15.07.15.16v.13c0 .08-.07.15-.15.14Z",
    fill: "#E3F8FD"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.16v.13c0 .08-.06.15-.15.14Z",
    fill: "#E4F8FD"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.16v.13c0 .08-.06.15-.15.14Z",
    fill: "#E5F9FE"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.06.15-.15.14Z",
    fill: "#E6F9FE"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.06.15-.15.14Z",
    fill: "#E7FAFE"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.06.15-.15.14Z",
    fill: "#E8FAFE"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.06.15-.15.14Z",
    fill: "#E9FAFF"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.06.15-.15.14Z",
    fill: "#EAFBFF"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#EBFBFF"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "m41.45 31.63-1.53-.02a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l1.54.01c.08 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#EFFAFC"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.16.15-.15l2.82.03c.08 0 .15.08.15.16v.15c0 .1-.07.16-.16.16Z",
    fill: "#69CBE0"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.15v-.14c0-.08.06-.15.15-.15l2.82.04c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#6ACBE0"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.15v-.14c0-.08.06-.15.15-.15l2.82.04c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#6BCCE0"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.82.04c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#6CCCE1"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.81-.06a.16.16 0 0 1-.15-.16v-.13c0-.08.07-.15.15-.15l2.82.04c.09 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#6DCCE1"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.81-.06a.16.16 0 0 1-.15-.16v-.13c0-.08.07-.15.15-.15l2.82.04c.09 0 .15.07.15.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#6ECDE1"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#6FCDE1"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#70CEE2"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#71CEE2"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.07.15-.16.15Z",
    fill: "#72CEE2"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#73CFE2"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#74CFE3"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.82-.06a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#75CFE3"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.72-2.81-.06a.16.16 0 0 1-.15-.15v-.14c0-.08.07-.15.15-.15l2.81.04c.09 0 .16.07.16.16v.15c0 .08-.08.15-.16.15Z",
    fill: "#76D0E3"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#77D0E3"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.09 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#78D1E4"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#79D1E4"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#7AD1E4"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#7BD2E4"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.81.04c.08 0 .15.07.15.16v.14c0 .09-.07.16-.15.15Z",
    fill: "#7CD2E5"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.08.06-.15.15-.15l2.81.04c.08 0 .15.07.15.16v.15c0 .08-.07.15-.15.14Z",
    fill: "#7DD2E5"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.15-.16v-.13c0-.08.07-.15.15-.15l2.82.04c.08 0 .15.07.15.16v.15c0 .08-.07.15-.15.14Z",
    fill: "#7ED3E5"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.08.06-.15.15-.15l2.81.04c.08 0 .15.07.15.16v.15c0 .08-.07.15-.16.14Z",
    fill: "#7FD3E5"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.08.06-.15.15-.15l2.8.04c.1 0 .16.07.16.16v.15c0 .08-.07.15-.16.14Z",
    fill: "#80D3E5"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .09-.07.16-.16.15Z",
    fill: "#81D4E6"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.16.16 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .09-.07.16-.16.15Z",
    fill: "#82D4E6"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.81.04c.08 0 .16.07.16.15v.15c0 .09-.08.16-.16.15Z",
    fill: "#83D5E6"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.81.04c.08 0 .16.07.15.15v.15c0 .09-.07.16-.15.15Z",
    fill: "#84D5E6"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.81.04c.08 0 .16.07.15.15v.15c0 .09-.07.16-.15.15Z",
    fill: "#85D5E7"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .09-.07.15-.16.15Z",
    fill: "#86D6E7"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .09-.07.15-.16.15Z",
    fill: "#87D6E7"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .09-.07.15-.16.15Z",
    fill: "#88D6E7"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .09-.07.15-.16.15Z",
    fill: "#89D7E8"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .09-.07.15-.16.15Z",
    fill: "#8AD7E8"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.71-2.82-.05a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .09-.07.15-.16.15Z",
    fill: "#8BD8E8"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.7-2.82-.04a.15.15 0 0 1-.14-.16v-.13c0-.09.07-.15.15-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .09-.07.15-.16.15Z",
    fill: "#8CD8E8"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.09 0 .16.07.16.15v.15c0 .09-.07.15-.16.15Z",
    fill: "#8DD8E9"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.09.06-.15.15-.15l2.8.04c.09 0 .16.07.16.15v.15c0 .09-.07.15-.16.15Z",
    fill: "#8ED9E9"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.08.06-.15.15-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#8FD9E9"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.08.06-.15.15-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#90D9E9"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.08.06-.15.15-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#91DAEA"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.7-2.82-.04a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#92DAEA"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.7-2.82-.04a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#93DBEA"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 31.7-2.82-.04a.15.15 0 0 1-.14-.16v-.13c0-.08.07-.15.15-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .09-.08.15-.16.15Z",
    fill: "#94DBEA"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.08.06-.15.15-.15l2.8.04c.09 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#95DBEA"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.04a.15.15 0 0 1-.15-.16v-.13c0-.08.06-.15.15-.15l2.8.04c.09 0 .15.07.15.16v.14c0 .09-.07.15-.15.15Z",
    fill: "#96DCEB"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.05a.15.15 0 0 1-.15-.15v-.13c0-.09.06-.15.15-.15l2.8.04c.09 0 .15.07.15.15v.15c0 .09-.07.15-.15.15Z",
    fill: "#97DCEB"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.05a.15.15 0 0 1-.15-.15v-.13c0-.09.06-.15.14-.15l2.81.04c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#98DCEB"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.05a.15.15 0 0 1-.15-.15v-.13c0-.09.06-.15.14-.15l2.81.04c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#99DDEB"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.05a.15.15 0 0 1-.15-.15v-.13c0-.09.06-.15.14-.15l2.81.04c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#9ADDEC"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "m45.19 31.7-2.8-.05a.15.15 0 0 1-.15-.15v-.13c0-.09.07-.15.15-.15l2.8.04c.08 0 .15.07.15.15v.15c0 .08-.07.15-.15.15Z",
    fill: "#9BDDEC"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.16.16 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#9CDEEC"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.16.16 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#9DDEEC"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.16.16 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#9EDFED"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.16.16 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#9FDFED"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.16.16 0 0 1-.14-.15v-.13c0-.09.06-.15.14-.15l2.8.04c.1 0 .16.07.16.15v.15c0 .08-.07.15-.16.15Z",
    fill: "#A0DFED"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .08-.07.15-.16.15Z",
    fill: "#A1E0ED"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A2E0EE"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A3E0EE"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.1 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A4E1EE"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A5E1EE"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A6E2EF"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A7E2EF"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A8E2EF"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .08-.07.15-.16.14Z",
    fill: "#A9E3EF"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.16.16v.14c0 .08-.08.15-.16.14Z",
    fill: "#AAE3F0"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.15v-.13c0-.08.06-.15.14-.15l2.8.04c.09 0 .16.07.15.16v.14c0 .08-.07.15-.15.14Z",
    fill: "#ABE3F0"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.09 0 .16.07.15.15v.14c0 .09-.07.16-.15.15Z",
    fill: "#ACE4F0"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.09 0 .16.07.15.15v.14c0 .09-.07.16-.15.15Z",
    fill: "#ADE4F0"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.08.16-.16.15Z",
    fill: "#AEE4F0"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.08.16-.16.15Z",
    fill: "#AFE5F1"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.08.16-.16.15Z",
    fill: "#B0E5F1"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.08.15-.16.15Z",
    fill: "#B1E6F1"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .15.07.15.15v.14c-.01.09-.08.15-.16.15Z",
    fill: "#B2E6F1"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.09 0 .15.07.15.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#B3E6F2"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.06-.15.14-.15l2.8.04c.09 0 .15.07.15.16v.14c0 .08-.07.14-.15.14Z",
    fill: "#B4E7F2"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.06-.15.14-.15l2.8.04c.09 0 .15.07.15.16v.14c0 .08-.07.14-.15.14Z",
    fill: "#B5E7F2"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.06-.15.14-.15l2.8.04c.09 0 .15.07.15.16v.14c0 .08-.07.14-.15.14Z",
    fill: "#B6E7F2"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#B7E8F3"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#B8E8F3"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#B9E9F3"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#BAE9F3"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.05c-.07 0-.13-.08-.13-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.07.15-.16.15Z",
    fill: "#BBE9F4"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.05c-.07 0-.13-.08-.13-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.07.15-.16.15Z",
    fill: "#BCEAF4"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.05c-.07 0-.13-.08-.13-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.07.15-.16.15Z",
    fill: "#BDEAF4"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.05c-.07 0-.13-.08-.13-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.07.15-.16.15Z",
    fill: "#BEEAF4"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.05c-.07 0-.13-.08-.13-.16v-.12c0-.09.06-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.07.15-.16.15Z",
    fill: "#BFEBF5"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.15-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#C0EBF5"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "m45.18 31.7-2.8-.05c-.08 0-.14-.08-.14-.16v-.12c0-.08.07-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#C1EBF5"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.03c.08 0 .14.08.14.16v.14c0 .09-.06.15-.15.15Z",
    fill: "#C2ECF5"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.06.15-.15.15Z",
    fill: "#C3ECF5"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.06.15-.15.15Z",
    fill: "#C4EDF6"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.08 0 .14.07.14.15v.14c0 .09-.07.15-.15.15Z",
    fill: "#C5EDF6"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.08 0 .14.07.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#C6EDF6"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.12c0-.08.06-.15.14-.15l2.8.04c.08 0 .14.07.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#C7EEF6"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.12c0-.08.06-.15.14-.15l2.8.04c.08 0 .14.07.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#C8EEF7"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06c-.08 0-.14-.07-.14-.15v-.12c0-.08.07-.15.14-.15l2.8.04c.08 0 .15.07.15.15v.14c0 .08-.08.15-.16.15Z",
    fill: "#C9EEF7"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.12c0-.08.06-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#CAEFF7"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.12c0-.08.06-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#CBEFF7"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.12c0-.08.06-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.15Z",
    fill: "#CCF0F8"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#CDF0F8"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#CEF0F8"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#CFF1F8"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D0F1F9"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.14-.07-.14-.15v-.13c0-.08.07-.14.15-.14l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D1F1F9"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.14-.07-.14-.15v-.13c0-.08.07-.14.15-.14l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D2F2F9"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D3F2F9"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.8-.06c-.07 0-.13-.07-.13-.15v-.13c0-.08.06-.14.14-.14l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D4F3FA"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D5F3FA"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D6F3FA"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D7F4FA"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.13c0-.08.07-.14.14-.14l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.15-.15.14Z",
    fill: "#D8F4FA"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.7-2.78-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.15-.16.14Z",
    fill: "#D9F4FB"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.7-2.78-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.15-.16.14Z",
    fill: "#DAF5FB"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.7-2.78-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l2.79.04c.08 0 .15.07.15.15v.14c0 .08-.07.14-.16.14Z",
    fill: "#DBF5FB"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#DCF5FB"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#DDF6FC"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#DEF6FC"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#DFF7FC"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "m45.17 31.7-2.79-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.07-.15.14-.15l2.8.04c.07 0 .14.07.14.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#E0F7FC"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.7-2.78-.06a.15.15 0 0 1-.14-.15v-.12c0-.08.06-.15.14-.15l2.79.04c.08 0 .14.07.14.15v.14c0 .08-.07.14-.15.14Z",
    fill: "#E1F7FD"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.79.04c.08 0 .14.07.14.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#E2F8FD"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.79.04c.08 0 .14.07.14.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#E3F8FD"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.79.04c.08 0 .14.07.14.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#E4F8FD"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.14.14-.14l2.79.04c.08 0 .15.07.15.15v.13c-.01.09-.08.15-.16.15Z",
    fill: "#E5F9FE"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.14.14-.14l2.79.04c.08 0 .15.07.15.15v.13c-.01.09-.08.15-.16.15Z",
    fill: "#E6F9FE"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.07-.14.14-.14l2.79.04c.08 0 .15.07.15.15v.13c-.01.09-.08.15-.16.15Z",
    fill: "#E7FAFE"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.78.04c.09 0 .15.07.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#E8FAFE"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.78.04c.09 0 .15.07.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#E9FAFF"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.78.04c.08 0 .15.07.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#EAFBFF"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.78.04c.08 0 .15.07.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#EBFBFF"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "m45.16 31.69-2.78-.05a.15.15 0 0 1-.14-.16v-.12c0-.08.06-.14.14-.14l2.78.04c.08 0 .15.07.15.15v.13c0 .09-.07.15-.15.15Z",
    fill: "#EFFAFC"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M55.05 31.65c-.04.78-.77 1.4-1.62 1.36-.83-.03-1.47-.68-1.42-1.45.05-.77.75-1.38 1.58-1.36.85.02 1.5.66 1.46 1.45Z",
    fill: "#AF5F8B"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M55.05 31.65c-.05.78-.77 1.4-1.62 1.36-.83-.03-1.47-.68-1.42-1.45.04-.76.75-1.37 1.58-1.36.84.02 1.5.66 1.45 1.45Z",
    fill: "#B0608C"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M55.04 31.65c-.04.78-.77 1.4-1.61 1.36-.83-.03-1.47-.68-1.42-1.45.04-.76.75-1.37 1.58-1.36.84.02 1.5.66 1.45 1.45Z",
    fill: "#B1608C"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M55.04 31.64c-.05.79-.77 1.4-1.61 1.37-.84-.03-1.47-.68-1.42-1.45.04-.76.75-1.37 1.58-1.36.84.02 1.5.66 1.45 1.44Z",
    fill: "#B2618D"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M55.03 31.64c-.04.79-.76 1.4-1.6 1.37-.83-.03-1.47-.68-1.42-1.45.05-.77.75-1.38 1.58-1.36.83.02 1.49.66 1.44 1.44Z",
    fill: "#B3618E"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M55.03 31.64c-.04.79-.77 1.4-1.6 1.37-.84-.03-1.47-.68-1.42-1.45.05-.76.75-1.37 1.57-1.36.84.02 1.5.66 1.45 1.44Z",
    fill: "#B4628F"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M55.02 31.64c-.04.79-.76 1.4-1.6 1.37-.83-.03-1.46-.68-1.41-1.45.04-.76.74-1.37 1.57-1.36.84.02 1.49.66 1.44 1.44Z",
    fill: "#B5638F"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M55.02 31.64c-.04.78-.76 1.4-1.6 1.37-.83-.03-1.46-.68-1.41-1.45.05-.77.74-1.37 1.57-1.36.83.02 1.48.66 1.44 1.44Z",
    fill: "#B66390"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M55.02 31.64c-.05.78-.76 1.4-1.6 1.36-.83-.03-1.46-.67-1.41-1.44.04-.77.74-1.37 1.56-1.36.84.02 1.49.66 1.45 1.44Z",
    fill: "#B76491"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M55.01 31.64c-.04.78-.76 1.4-1.6 1.36-.82-.03-1.45-.67-1.4-1.44.05-.77.74-1.37 1.57-1.36.83.02 1.47.66 1.43 1.44Z",
    fill: "#B86492"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M55.01 31.64c-.04.78-.76 1.4-1.6 1.36-.82-.03-1.45-.68-1.4-1.44.04-.77.74-1.37 1.56-1.36.83.02 1.48.66 1.44 1.44Z",
    fill: "#B96592"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31.64c-.04.78-.75 1.4-1.59 1.36-.82-.03-1.45-.67-1.4-1.44.05-.76.74-1.37 1.56-1.36.83.02 1.48.66 1.44 1.44Z",
    fill: "#BA6693"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31.64c-.04.78-.76 1.39-1.59 1.36-.82-.03-1.45-.68-1.4-1.44.05-.77.74-1.37 1.56-1.36.83.01 1.47.66 1.43 1.44Z",
    fill: "#BB6694"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31.64c-.05.78-.76 1.39-1.6 1.36-.81-.03-1.44-.68-1.4-1.45.05-.76.75-1.36 1.56-1.35.84.01 1.48.66 1.44 1.44Z",
    fill: "#BC6794"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31.64c-.05.78-.76 1.39-1.6 1.36-.81-.03-1.44-.68-1.4-1.45.05-.76.75-1.36 1.56-1.35.83.01 1.47.66 1.43 1.44Z",
    fill: "#BD6895"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M54.99 31.64c-.04.78-.76 1.39-1.59 1.36-.81-.03-1.44-.68-1.4-1.44.05-.77.75-1.37 1.56-1.36.83.01 1.47.66 1.43 1.44Z",
    fill: "#BE6896"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M54.99 31.63c-.05.78-.76 1.4-1.59 1.36-.81-.03-1.44-.67-1.39-1.44.05-.76.74-1.37 1.55-1.35.83.01 1.47.66 1.43 1.43Z",
    fill: "#BF6997"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M54.98 31.63c-.04.78-.75 1.4-1.58 1.36-.82-.03-1.44-.67-1.39-1.44.05-.76.74-1.36 1.55-1.35.82.01 1.46.66 1.42 1.43Z",
    fill: "#C06997"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M54.98 31.63c-.04.78-.75 1.4-1.58 1.36-.81-.03-1.43-.67-1.39-1.44.05-.76.73-1.36 1.55-1.35.82.01 1.46.65 1.42 1.43Z",
    fill: "#C16A98"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M54.97 31.63c-.04.78-.75 1.39-1.57 1.36-.82-.03-1.44-.67-1.4-1.44a1.5 1.5 0 0 1 1.55-1.35c.83.01 1.46.65 1.42 1.43Z",
    fill: "#C26B99"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M54.97 31.63c-.04.78-.75 1.39-1.58 1.36-.8-.03-1.43-.68-1.38-1.44a1.5 1.5 0 0 1 1.54-1.35c.82.01 1.46.65 1.42 1.43Z",
    fill: "#C36B9A"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M54.97 31.63c-.04.78-.75 1.39-1.58 1.36-.8-.03-1.43-.68-1.38-1.44a1.5 1.5 0 0 1 1.54-1.35c.82.01 1.46.65 1.42 1.43Z",
    fill: "#C46C9A"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M54.96 31.63c-.04.78-.75 1.38-1.57 1.35-.8-.03-1.43-.67-1.38-1.43a1.5 1.5 0 0 1 1.54-1.35c.82.01 1.45.65 1.41 1.43Z",
    fill: "#C56C9B"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M54.96 31.63c-.04.77-.75 1.38-1.57 1.35a1.39 1.39 0 0 1-1.38-1.43c.05-.76.73-1.36 1.54-1.35.81.01 1.45.65 1.4 1.43Z",
    fill: "#C66D9C"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M54.95 31.63c-.04.77-.74 1.38-1.56 1.35-.8-.03-1.43-.67-1.38-1.43.05-.76.73-1.37 1.54-1.35.81.01 1.45.65 1.4 1.43Z",
    fill: "#C76E9C"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M54.95 31.63c-.04.77-.74 1.38-1.56 1.35-.81-.03-1.43-.67-1.38-1.43.05-.76.73-1.36 1.53-1.35.82.01 1.45.65 1.41 1.43Z",
    fill: "#C86E9D"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M54.95 31.63c-.04.77-.75 1.38-1.57 1.35-.8-.03-1.42-.67-1.37-1.43.05-.76.73-1.36 1.53-1.35.82.01 1.45.65 1.4 1.43Z",
    fill: "#C86F9E"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M54.94 31.63c-.04.77-.74 1.38-1.56 1.35a1.38 1.38 0 0 1-1.37-1.43c.04-.76.72-1.36 1.53-1.35.81.01 1.44.65 1.4 1.43Z",
    fill: "#C96F9F"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M54.94 31.63a1.48 1.48 0 0 1-1.56 1.35 1.38 1.38 0 0 1-1.37-1.43c.05-.76.73-1.36 1.53-1.35.8.01 1.44.65 1.4 1.43Z",
    fill: "#CA709F"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M54.93 31.62a1.48 1.48 0 0 1-1.55 1.35A1.38 1.38 0 0 1 52 31.54c.05-.75.73-1.35 1.53-1.34.8.01 1.44.65 1.4 1.42Z",
    fill: "#CB71A0"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M54.93 31.62a1.48 1.48 0 0 1-1.55 1.35 1.37 1.37 0 0 1-1.37-1.43c.05-.75.73-1.35 1.53-1.34.8.01 1.43.65 1.4 1.42Z",
    fill: "#CC71A1"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M54.93 31.62a1.48 1.48 0 0 1-1.56 1.35 1.38 1.38 0 0 1-1.36-1.42c.04-.76.72-1.36 1.52-1.35.81.01 1.44.65 1.4 1.42Z",
    fill: "#CD72A1"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M54.92 31.62a1.47 1.47 0 0 1-1.55 1.35c-.8-.03-1.4-.67-1.36-1.43.05-.75.72-1.35 1.52-1.34.8.01 1.43.65 1.4 1.42Z",
    fill: "#CE72A2"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M54.92 31.62a1.47 1.47 0 0 1-1.55 1.35c-.8-.03-1.4-.67-1.36-1.43.05-.75.72-1.35 1.52-1.34.8.01 1.43.65 1.39 1.42Z",
    fill: "#CF73A3"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91 31.62a1.47 1.47 0 0 1-1.54 1.35c-.8-.03-1.4-.67-1.36-1.43.05-.75.72-1.35 1.52-1.34.8.01 1.43.65 1.38 1.42Z",
    fill: "#D074A4"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M54.91 31.62a1.47 1.47 0 0 1-1.54 1.34c-.8-.02-1.4-.66-1.36-1.42.04-.76.72-1.36 1.51-1.34.8.01 1.43.65 1.39 1.42Z",
    fill: "#D174A4"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 31.62a1.47 1.47 0 0 1-1.54 1.34c-.8-.02-1.4-.66-1.35-1.42.04-.76.72-1.35 1.5-1.34.82.01 1.44.65 1.4 1.42Z",
    fill: "#D275A5"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 31.62a1.47 1.47 0 0 1-1.54 1.34c-.8-.02-1.4-.66-1.35-1.42.04-.75.72-1.35 1.5-1.34.81.01 1.43.65 1.4 1.42Z",
    fill: "#D375A6"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 31.62a1.47 1.47 0 0 1-1.54 1.34c-.8-.03-1.4-.66-1.35-1.42.04-.75.72-1.35 1.5-1.34.8.01 1.43.65 1.39 1.42Z",
    fill: "#D476A7"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 31.62a1.46 1.46 0 0 1-1.54 1.34c-.8-.03-1.4-.67-1.35-1.42.04-.76.72-1.36 1.5-1.34.8.01 1.43.65 1.38 1.42Z",
    fill: "#D577A7"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M54.89 31.62a1.46 1.46 0 0 1-1.53 1.34c-.8-.03-1.4-.67-1.35-1.42.04-.76.71-1.35 1.5-1.34.8.01 1.42.65 1.38 1.42Z",
    fill: "#D677A8"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M54.88 31.62a1.46 1.46 0 0 1-1.52 1.34A1.36 1.36 0 0 1 52 31.54c.04-.75.71-1.35 1.5-1.34.8.01 1.42.65 1.37 1.42Z",
    fill: "#D778A9"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M54.88 31.61a1.46 1.46 0 0 1-1.53 1.35 1.36 1.36 0 0 1-1.34-1.42c.04-.76.71-1.35 1.5-1.34.8.01 1.41.65 1.37 1.41Z",
    fill: "#D879A9"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M54.88 31.61a1.46 1.46 0 0 1-1.53 1.34 1.36 1.36 0 0 1-1.34-1.42c.04-.75.71-1.35 1.5-1.33.8.01 1.4.64 1.37 1.41Z",
    fill: "#D979AA"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M54.87 31.61a1.46 1.46 0 0 1-1.52 1.34 1.36 1.36 0 0 1-1.34-1.41c.04-.75.71-1.35 1.5-1.34.79.01 1.4.64 1.36 1.41Z",
    fill: "#DA7AAB"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M54.87 31.61a1.45 1.45 0 0 1-1.52 1.34A1.36 1.36 0 0 1 52 31.53c.04-.75.71-1.34 1.5-1.33.79.01 1.4.64 1.36 1.41Z",
    fill: "#DB7AAC"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M54.86 31.61a1.45 1.45 0 0 1-1.51 1.34A1.35 1.35 0 0 1 52 31.53c.04-.75.7-1.34 1.5-1.33.78.01 1.4.64 1.35 1.41Z",
    fill: "#DC7BAC"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M54.86 31.61a1.45 1.45 0 0 1-1.51 1.34A1.35 1.35 0 0 1 52 31.53c.05-.75.71-1.35 1.5-1.33.78.01 1.4.64 1.35 1.41Z",
    fill: "#DD7CAD"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M54.86 31.6a1.45 1.45 0 0 1-1.52 1.35 1.35 1.35 0 0 1-1.33-1.42c.04-.75.7-1.34 1.49-1.33.79.01 1.4.64 1.36 1.4Z",
    fill: "#DE7CAE"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M54.85 31.6a1.45 1.45 0 0 1-1.5 1.35A1.35 1.35 0 0 1 52 31.53c.04-.75.7-1.34 1.49-1.33.78.01 1.4.64 1.35 1.4Z",
    fill: "#DF7DAF"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M54.85 31.6a1.45 1.45 0 0 1-1.51 1.35A1.35 1.35 0 0 1 52 31.53c.04-.75.7-1.34 1.48-1.33.8.01 1.4.64 1.36 1.4Z",
    fill: "#E07DAF"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M54.85 31.6a1.44 1.44 0 0 1-1.51 1.34 1.34 1.34 0 0 1-1.33-1.41c.05-.75.7-1.34 1.48-1.33.79.01 1.4.64 1.36 1.4Z",
    fill: "#E17EB0"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M54.85 31.6a1.44 1.44 0 0 1-1.51 1.34 1.34 1.34 0 0 1-1.33-1.41c.05-.75.7-1.34 1.48-1.33.79.01 1.4.64 1.36 1.4Z",
    fill: "url(#T)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M53.12 31.61c-.04.76-.74 1.34-1.54 1.3-.8-.02-1.4-.65-1.35-1.38.05-.73.72-1.32 1.5-1.3.8.01 1.43.63 1.39 1.38Z",
    fill: "#E489B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M53.1 31.61c-.03.75-.73 1.34-1.53 1.3-.79-.03-1.39-.65-1.34-1.38.04-.73.7-1.32 1.5-1.3.8.01 1.42.63 1.38 1.38Z",
    fill: "#E389B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M53.1 31.61c-.04.75-.73 1.33-1.53 1.3-.79-.03-1.38-.65-1.34-1.38.05-.73.71-1.3 1.5-1.3.8.02 1.42.64 1.38 1.38Z",
    fill: "#E288B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M53.1 31.61c-.05.75-.74 1.33-1.53 1.3-.79-.03-1.38-.65-1.34-1.38.05-.73.71-1.3 1.5-1.3.8.02 1.41.64 1.37 1.38Z",
    fill: "#E188B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M53.1 31.61c-.05.75-.74 1.33-1.53 1.3-.79-.04-1.38-.65-1.33-1.38.04-.73.7-1.3 1.49-1.29.79.02 1.4.63 1.36 1.37Z",
    fill: "#E087B4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.09 31.61c-.05.75-.73 1.32-1.52 1.3-.78-.04-1.37-.65-1.33-1.38.04-.72.7-1.3 1.49-1.28.78 0 1.4.62 1.36 1.36Z",
    fill: "#DF86B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M53.08 31.61c-.04.74-.73 1.32-1.52 1.29-.78-.03-1.36-.65-1.32-1.37.04-.72.7-1.3 1.48-1.28.79.01 1.4.62 1.36 1.36Z",
    fill: "#DE86B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M53.07 31.61c-.04.74-.72 1.31-1.5 1.28-.79-.03-1.37-.64-1.33-1.36.05-.72.7-1.29 1.48-1.27.78 0 1.4.61 1.35 1.35Z",
    fill: "#DD85B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M53.07 31.61c-.05.74-.72 1.3-1.5 1.28-.79-.03-1.37-.64-1.33-1.36.05-.72.7-1.3 1.48-1.28.78.02 1.39.63 1.35 1.36Z",
    fill: "#DC85B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M53.06 31.61c-.04.73-.72 1.3-1.5 1.27-.77-.03-1.35-.63-1.31-1.35.04-.72.7-1.28 1.47-1.27.78.01 1.38.62 1.34 1.35Z",
    fill: "#DB84B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M53.05 31.61c-.04.73-.71 1.3-1.5 1.27-.76-.03-1.34-.63-1.3-1.35.04-.71.7-1.28 1.46-1.27.78.02 1.39.62 1.34 1.35Z",
    fill: "#DA84AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M53.05 31.61c-.04.73-.72 1.3-1.5 1.27-.76-.03-1.34-.64-1.3-1.35.04-.71.7-1.28 1.46-1.26.78.01 1.38.61 1.34 1.34Z",
    fill: "#D983AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M53.04 31.61c-.04.73-.71 1.3-1.49 1.26-.76-.03-1.34-.63-1.3-1.34.04-.7.7-1.27 1.46-1.26.77.01 1.37.61 1.33 1.34Z",
    fill: "#D882AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M53.04 31.61c-.04.73-.71 1.29-1.49 1.26-.76-.03-1.34-.63-1.3-1.34.05-.7.7-1.27 1.46-1.26.77.02 1.37.62 1.33 1.34Z",
    fill: "#D782AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M53.03 31.61c-.04.72-.7 1.29-1.48 1.26-.76-.03-1.34-.63-1.3-1.34.05-.7.7-1.26 1.45-1.25.77.01 1.37.6 1.33 1.33Z",
    fill: "#D681AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M53.02 31.61c-.04.72-.7 1.28-1.47 1.25-.76-.03-1.33-.62-1.3-1.33.05-.7.7-1.26 1.45-1.25.77.02 1.36.6 1.32 1.33Z",
    fill: "#D581AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M53.02 31.6c-.04.73-.7 1.29-1.47 1.26-.76-.03-1.33-.63-1.29-1.33.04-.7.68-1.26 1.44-1.24.77.01 1.36.6 1.32 1.32Z",
    fill: "#D480AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M53.01 31.6c-.04.72-.7 1.28-1.46 1.25-.76-.03-1.33-.62-1.29-1.32.05-.7.69-1.26 1.44-1.24.76.01 1.35.6 1.31 1.32Z",
    fill: "#D37FAA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M53 31.6c-.03.72-.7 1.28-1.45 1.25-.76-.03-1.33-.62-1.28-1.32.04-.7.68-1.25 1.43-1.24.76.02 1.35.6 1.3 1.32Z",
    fill: "#D27FA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M53 31.6c-.04.72-.7 1.27-1.46 1.25-.75-.03-1.32-.62-1.27-1.32.04-.7.67-1.25 1.43-1.23.75.01 1.34.6 1.3 1.3Z",
    fill: "#D17EA8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M53 31.6c-.05.72-.7 1.27-1.46 1.24-.75-.03-1.31-.61-1.27-1.31.04-.7.67-1.24 1.42-1.23.76.01 1.34.6 1.3 1.3Z",
    fill: "#D07EA7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M52.98 31.6c-.04.72-.69 1.27-1.44 1.24-.75-.03-1.31-.62-1.27-1.3.04-.7.67-1.25 1.42-1.23.75.01 1.34.6 1.3 1.3Z",
    fill: "#CF7DA7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.98 31.6c-.04.71-.69 1.26-1.44 1.23-.74-.02-1.3-.61-1.27-1.3.05-.69.68-1.24 1.42-1.22.75.01 1.33.6 1.3 1.3Z",
    fill: "#CE7DA6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M52.97 31.6c-.04.71-.68 1.26-1.43 1.23-.75-.03-1.3-.61-1.26-1.3.04-.69.66-1.23 1.4-1.22.75.01 1.33.6 1.3 1.3Z",
    fill: "#CD7CA5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M52.97 31.6c-.04.7-.69 1.25-1.44 1.22-.74-.03-1.3-.6-1.25-1.3.04-.68.66-1.22 1.4-1.2.75.01 1.33.59 1.29 1.29Z",
    fill: "#CC7BA4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M52.96 31.6c-.04.7-.68 1.25-1.43 1.22-.74-.03-1.3-.6-1.25-1.29.04-.68.66-1.23 1.4-1.21.74.01 1.32.59 1.28 1.29Z",
    fill: "#CB7BA3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M52.96 31.6c-.04.7-.69 1.25-1.43 1.22-.73-.03-1.29-.6-1.25-1.29.04-.68.67-1.22 1.4-1.2.74 0 1.32.58 1.28 1.28Z",
    fill: "#CA7AA3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M52.95 31.6c-.04.7-.68 1.24-1.42 1.21-.73-.03-1.29-.6-1.24-1.28.04-.68.66-1.22 1.39-1.2.73.01 1.3.58 1.27 1.28Z",
    fill: "#C97AA2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.94 31.6c-.04.7-.67 1.24-1.41 1.21-.73-.03-1.29-.6-1.24-1.28.04-.68.65-1.21 1.38-1.2.74.01 1.31.58 1.27 1.28Z",
    fill: "#C879A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M52.94 31.6c-.04.7-.68 1.23-1.41 1.2-.73-.02-1.28-.6-1.24-1.27.04-.68.66-1.21 1.39-1.2.73.02 1.3.59 1.26 1.28Z",
    fill: "#C878A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M52.93 31.6c-.04.7-.67 1.23-1.4 1.2-.73-.03-1.28-.6-1.24-1.27.04-.67.66-1.2 1.38-1.19.73.01 1.3.58 1.26 1.27Z",
    fill: "#C7789F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M52.92 31.6c-.03.7-.66 1.23-1.4 1.2-.72-.03-1.27-.6-1.23-1.27.04-.67.66-1.2 1.38-1.19.73.02 1.3.58 1.25 1.27Z",
    fill: "#C6779F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M52.92 31.6c-.04.69-.67 1.22-1.4 1.2-.72-.03-1.27-.6-1.23-1.27.04-.67.65-1.2 1.37-1.18.73.01 1.3.57 1.26 1.26Z",
    fill: "#C5779E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M52.91 31.6c-.04.68-.66 1.22-1.39 1.19-.72-.03-1.26-.59-1.22-1.26.04-.67.65-1.2 1.37-1.18.72.01 1.28.57 1.24 1.25Z",
    fill: "#C4769D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M52.9 31.6c-.03.68-.66 1.21-1.38 1.18-.72-.02-1.26-.59-1.22-1.25.04-.67.65-1.2 1.36-1.18.73.02 1.29.57 1.25 1.25Z",
    fill: "#C3759C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M52.9 31.6c-.04.68-.66 1.2-1.38 1.18-.72-.02-1.26-.59-1.22-1.25.04-.66.65-1.19 1.36-1.17.72.01 1.28.57 1.24 1.24Z",
    fill: "#C2759B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M52.9 31.6c-.04.68-.67 1.2-1.39 1.18-.7-.03-1.25-.59-1.2-1.25.03-.66.64-1.19 1.35-1.17.71.01 1.27.57 1.23 1.24Z",
    fill: "#C1749B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M52.89 31.6c-.04.68-.66 1.2-1.38 1.17-.7-.02-1.24-.58-1.2-1.24.04-.66.64-1.18 1.35-1.16.71 0 1.27.56 1.23 1.23Z",
    fill: "#C0749A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M52.88 31.6c-.04.67-.65 1.2-1.37 1.17-.7-.03-1.24-.58-1.2-1.24.04-.66.64-1.18 1.34-1.16.72.01 1.27.56 1.23 1.23Z",
    fill: "#BF7399"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M52.87 31.6c-.03.67-.65 1.2-1.36 1.17-.7-.03-1.24-.58-1.2-1.24.04-.65.64-1.17 1.34-1.16.71.02 1.26.56 1.22 1.23Z",
    fill: "#BE7398"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M52.87 31.6c-.04.67-.65 1.19-1.36 1.16-.7-.02-1.24-.58-1.2-1.23.04-.65.64-1.17 1.34-1.15.7 0 1.26.56 1.22 1.22Z",
    fill: "#BD7297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M52.86 31.6c-.04.66-.65 1.18-1.36 1.16-.7-.03-1.23-.58-1.19-1.23.04-.65.63-1.17 1.33-1.15.71.01 1.26.56 1.22 1.22Z",
    fill: "#BC7197"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M52.86 31.6c-.04.66-.65 1.18-1.35 1.15-.7-.02-1.23-.57-1.2-1.22.05-.65.64-1.16 1.34-1.15.7.02 1.24.56 1.2 1.22Z",
    fill: "#BB7196"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M52.85 31.6c-.04.66-.65 1.17-1.35 1.15-.7-.03-1.22-.57-1.18-1.22.04-.65.63-1.16 1.32-1.15.7.02 1.25.56 1.2 1.22Z",
    fill: "#BA7095"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M52.84 31.6c-.03.66-.64 1.17-1.34 1.15-.7-.03-1.22-.57-1.18-1.22.04-.64.63-1.15 1.32-1.14.7.01 1.24.55 1.2 1.21Z",
    fill: "#B97094"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M52.84 31.6c-.04.66-.64 1.17-1.34 1.14-.7-.02-1.22-.57-1.18-1.21.04-.64.62-1.15 1.31-1.14.7.02 1.24.56 1.2 1.21Z",
    fill: "#B86F94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M52.83 31.6c-.04.65-.63 1.16-1.33 1.14-.7-.03-1.22-.57-1.18-1.2.04-.65.63-1.16 1.32-1.14.69.01 1.23.55 1.2 1.2Z",
    fill: "#B76E93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M52.83 31.6c-.04.65-.64 1.16-1.33 1.13-.69-.02-1.21-.56-1.17-1.2.03-.64.62-1.14 1.3-1.13.7.01 1.23.55 1.2 1.2Z",
    fill: "#B66E92"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M52.82 31.6c-.04.65-.63 1.16-1.33 1.13-.68-.02-1.2-.56-1.16-1.2.04-.64.62-1.14 1.3-1.12.7 0 1.23.54 1.19 1.19Z",
    fill: "#B56D91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M52.81 31.6c-.03.64-.63 1.15-1.32 1.13-.68-.03-1.2-.56-1.16-1.2.04-.63.62-1.13 1.3-1.12.69.01 1.22.54 1.18 1.19Z",
    fill: "#B46D90"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M52.8 31.6c-.03.64-.62 1.15-1.3 1.12-.7-.02-1.2-.56-1.17-1.19.04-.63.62-1.13 1.3-1.12.68.02 1.21.54 1.18 1.19Z",
    fill: "#B36C90"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M52.8 31.6c-.03.64-.63 1.14-1.31 1.12-.68-.02-1.2-.56-1.16-1.19.04-.63.62-1.13 1.3-1.11.68 0 1.2.54 1.17 1.18Z",
    fill: "#B26C8F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M52.8 31.6c-.04.64-.63 1.14-1.31 1.11-.68-.02-1.2-.55-1.15-1.18.03-.63.6-1.13 1.28-1.11.68.01 1.21.54 1.17 1.18Z",
    fill: "#B16B8E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M52.79 31.6c-.04.64-.62 1.13-1.3 1.11-.68-.02-1.19-.55-1.15-1.18.04-.63.61-1.12 1.28-1.1.68 0 1.2.53 1.17 1.17Z",
    fill: "#B06A8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M52.78 31.6c-.03.63-.62 1.13-1.3 1.1-.67-.02-1.18-.54-1.14-1.17.04-.62.6-1.12 1.28-1.1.67 0 1.2.53 1.16 1.17Z",
    fill: "#AF6A8C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M52.78 31.6c-.04.63-.62 1.13-1.3 1.1-.67-.02-1.18-.54-1.14-1.17.04-.62.6-1.11 1.28-1.1.67.01 1.2.54 1.16 1.17Z",
    fill: "#AE698C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M52.77 31.6c-.04.63-.62 1.12-1.3 1.1-.66-.02-1.16-.55-1.13-1.17.04-.62.6-1.1 1.27-1.1.68.02 1.2.54 1.16 1.17Z",
    fill: "#AD698B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.76 31.6c-.03.63-.61 1.12-1.28 1.1-.67-.03-1.17-.55-1.13-1.17.04-.62.6-1.1 1.26-1.1.67.02 1.19.54 1.15 1.17Z",
    fill: "#AC688A"
  }))), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M52.83 31.59c-.05.77-.75 1.38-1.58 1.35-.8-.03-1.42-.67-1.37-1.43.05-.76.73-1.36 1.54-1.34.82 0 1.45.64 1.4 1.42Z",
    fill: "#3794C7"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M52.83 31.59c-.05.77-.76 1.38-1.58 1.35-.8-.03-1.42-.67-1.37-1.43a1.5 1.5 0 0 1 1.54-1.35c.82.02 1.45.65 1.4 1.43Z",
    fill: "#3895C7"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M52.82 31.58c-.04.78-.75 1.38-1.57 1.35-.8-.03-1.42-.67-1.37-1.42.05-.76.73-1.36 1.54-1.35.82.02 1.45.65 1.4 1.42Z",
    fill: "#3996C8"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M52.82 31.58c-.04.78-.75 1.38-1.57 1.35-.81-.03-1.42-.66-1.37-1.42.05-.76.73-1.36 1.54-1.35.81.02 1.44.65 1.4 1.42Z",
    fill: "#3A97C8"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M52.82 31.59c-.05.77-.75 1.37-1.57 1.34-.81-.03-1.42-.66-1.37-1.42.05-.76.73-1.36 1.53-1.34.82 0 1.45.64 1.4 1.42Z",
    fill: "#3B98C9"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M52.81 31.58c-.04.78-.75 1.38-1.56 1.35-.8-.03-1.42-.67-1.37-1.43.05-.75.73-1.35 1.54-1.34.8.02 1.44.65 1.4 1.42Z",
    fill: "#3C99C9"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 31.58c-.03.78-.74 1.38-1.56 1.35-.8-.03-1.41-.67-1.36-1.43.04-.75.73-1.35 1.53-1.34.81.02 1.44.65 1.4 1.42Z",
    fill: "#3D9ACA"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 31.58c-.04.77-.74 1.38-1.56 1.35-.8-.03-1.4-.67-1.36-1.43.05-.75.73-1.35 1.53-1.34.81.02 1.44.65 1.4 1.42Z",
    fill: "#3E9BCA"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 31.58c-.04.77-.74 1.38-1.56 1.35-.8-.03-1.4-.67-1.36-1.43.05-.75.73-1.35 1.53-1.34.8.02 1.44.65 1.4 1.42Z",
    fill: "#3F9CCB"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 31.58c-.04.77-.75 1.37-1.56 1.35a1.37 1.37 0 0 1-1.36-1.43c.04-.75.72-1.35 1.52-1.34.82.02 1.44.65 1.4 1.42Z",
    fill: "#409DCB"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 31.58c-.05.77-.75 1.37-1.56 1.34-.8-.03-1.41-.66-1.36-1.42.05-.75.73-1.35 1.52-1.34.81.02 1.44.65 1.4 1.42Z",
    fill: "#419ECC"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 31.58a1.48 1.48 0 0 1-1.56 1.34c-.8-.03-1.4-.66-1.36-1.42.05-.75.72-1.35 1.52-1.34.8.02 1.44.65 1.4 1.42Z",
    fill: "#429FCC"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M52.79 31.58a1.48 1.48 0 0 1-1.55 1.34c-.8-.03-1.4-.66-1.36-1.42.05-.75.72-1.35 1.52-1.34.8.02 1.43.65 1.39 1.42Z",
    fill: "#43A0CD"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M52.79 31.58c-.05.77-.75 1.37-1.56 1.34-.8-.03-1.4-.66-1.35-1.42.05-.75.72-1.35 1.52-1.34.8.02 1.43.65 1.39 1.42Z",
    fill: "#44A1CD"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M52.78 31.58a1.47 1.47 0 0 1-1.55 1.34c-.8-.03-1.4-.67-1.35-1.42.05-.75.72-1.35 1.52-1.34.8.02 1.43.65 1.38 1.42Z",
    fill: "#45A2CE"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M52.78 31.58a1.47 1.47 0 0 1-1.55 1.34c-.8-.03-1.4-.67-1.35-1.42.04-.75.72-1.35 1.52-1.34.8.02 1.42.65 1.38 1.42Z",
    fill: "#46A3CE"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M52.78 31.57a1.47 1.47 0 0 1-1.55 1.35c-.8-.03-1.4-.67-1.35-1.42.04-.75.72-1.35 1.51-1.34.8.02 1.43.65 1.39 1.41Z",
    fill: "#47A4CE"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M52.77 31.57a1.47 1.47 0 0 1-1.54 1.35c-.8-.03-1.4-.67-1.35-1.42.05-.75.72-1.35 1.51-1.34.8.02 1.43.65 1.38 1.41Z",
    fill: "#48A5CF"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M52.77 31.57a1.47 1.47 0 0 1-1.54 1.35c-.8-.03-1.4-.67-1.35-1.42.04-.75.72-1.35 1.51-1.33.8 0 1.42.64 1.38 1.4Z",
    fill: "#49A6CF"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M52.77 31.57a1.47 1.47 0 0 1-1.55 1.34c-.79-.02-1.39-.66-1.34-1.41.04-.75.72-1.35 1.5-1.34.81.02 1.43.65 1.39 1.41Z",
    fill: "#4AA7D0"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M52.76 31.57a1.47 1.47 0 0 1-1.54 1.34c-.79-.03-1.39-.66-1.34-1.42.05-.75.72-1.34 1.5-1.33.8.02 1.43.65 1.38 1.41Z",
    fill: "#4BA8D0"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M52.76 31.57a1.47 1.47 0 0 1-1.54 1.34 1.35 1.35 0 0 1-1.34-1.41c.04-.75.71-1.35 1.5-1.34.8.02 1.42.65 1.38 1.41Z",
    fill: "#4CA9D1"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M52.75 31.57a1.47 1.47 0 0 1-1.53 1.34 1.35 1.35 0 0 1-1.34-1.41c.05-.75.72-1.35 1.5-1.33.8 0 1.42.64 1.37 1.4Z",
    fill: "#4DAAD1"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M52.75 31.57a1.46 1.46 0 0 1-1.53 1.34 1.35 1.35 0 0 1-1.34-1.42c.05-.74.72-1.34 1.5-1.33.8.02 1.41.65 1.37 1.41Z",
    fill: "#4EABD2"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M52.75 31.57a1.46 1.46 0 0 1-1.53 1.34 1.35 1.35 0 0 1-1.34-1.42c.04-.75.71-1.34 1.5-1.33.8.02 1.41.65 1.37 1.41Z",
    fill: "#4FACD2"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M52.74 31.57a1.46 1.46 0 0 1-1.52 1.34 1.35 1.35 0 0 1-1.34-1.42c.05-.74.71-1.34 1.5-1.33.8.02 1.4.65 1.36 1.41Z",
    fill: "#50ADD3"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M52.74 31.57a1.46 1.46 0 0 1-1.53 1.34 1.34 1.34 0 0 1-1.33-1.42c.04-.74.71-1.34 1.5-1.33.8.02 1.4.65 1.36 1.41Z",
    fill: "#51AED3"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M52.74 31.57a1.46 1.46 0 0 1-1.53 1.33 1.35 1.35 0 0 1-1.33-1.4c.04-.76.71-1.35 1.5-1.34.79.02 1.4.65 1.36 1.4Z",
    fill: "#52AFD4"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M52.73 31.57a1.46 1.46 0 0 1-1.52 1.33 1.34 1.34 0 0 1-1.33-1.41c.05-.75.71-1.34 1.5-1.33.79.02 1.4.64 1.35 1.4Z",
    fill: "#53B0D4"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M52.73 31.57a1.46 1.46 0 0 1-1.52 1.33 1.35 1.35 0 0 1-1.33-1.4c.04-.76.71-1.35 1.5-1.34.78.02 1.4.64 1.35 1.4Z",
    fill: "#54B1D5"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M52.73 31.57a1.46 1.46 0 0 1-1.52 1.33 1.34 1.34 0 0 1-1.33-1.4c.04-.76.71-1.35 1.5-1.34.78.02 1.39.64 1.35 1.4Z",
    fill: "#54B1D5"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M52.72 31.56a1.45 1.45 0 0 1-1.51 1.34 1.34 1.34 0 0 1-1.33-1.41c.05-.75.7-1.34 1.49-1.33.79.02 1.4.64 1.35 1.4Z",
    fill: "#55B2D5"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M52.72 31.56a1.45 1.45 0 0 1-1.52 1.34 1.34 1.34 0 0 1-1.32-1.41c.04-.75.7-1.34 1.49-1.33.78.02 1.4.64 1.35 1.4Z",
    fill: "#56B3D6"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M52.72 31.56a1.45 1.45 0 0 1-1.52 1.34 1.34 1.34 0 0 1-1.32-1.41c.04-.75.7-1.34 1.49-1.33.78.02 1.39.64 1.35 1.4Z",
    fill: "#57B4D6"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M52.71 31.56a1.45 1.45 0 0 1-1.51 1.34 1.34 1.34 0 0 1-1.32-1.41c.05-.75.7-1.34 1.49-1.33.78.02 1.39.64 1.34 1.4Z",
    fill: "#58B5D7"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 31.56a1.45 1.45 0 0 1-1.5 1.33 1.34 1.34 0 0 1-1.32-1.4c.04-.75.7-1.34 1.48-1.33.79.02 1.4.64 1.35 1.4Z",
    fill: "#59B6D7"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 31.56a1.45 1.45 0 0 1-1.5 1.33 1.34 1.34 0 0 1-1.32-1.4c.04-.75.7-1.34 1.48-1.33.78.02 1.39.64 1.35 1.4Z",
    fill: "#5AB7D8"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 31.56a1.44 1.44 0 0 1-1.5 1.33 1.33 1.33 0 0 1-1.32-1.4c.05-.75.7-1.34 1.48-1.33.78.02 1.39.64 1.34 1.4Z",
    fill: "#5BB8D8"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 31.56a1.45 1.45 0 0 1-1.5 1.33 1.34 1.34 0 0 1-1.32-1.4c.04-.75.7-1.34 1.48-1.33.78.02 1.38.64 1.34 1.4Z",
    fill: "#5CB9D9"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 31.56a1.44 1.44 0 0 1-1.5 1.33 1.33 1.33 0 0 1-1.32-1.4c.05-.75.7-1.34 1.48-1.33.78.02 1.38.64 1.34 1.4Z",
    fill: "#5DBAD9"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7 31.56a1.44 1.44 0 0 1-1.51 1.33 1.33 1.33 0 0 1-1.31-1.4c.05-.75.7-1.34 1.48-1.33.77.02 1.38.64 1.33 1.4Z",
    fill: "#5EBBDA"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M52.69 31.56a1.44 1.44 0 0 1-1.5 1.33 1.33 1.33 0 0 1-1.31-1.4c.04-.75.7-1.34 1.47-1.33.78.02 1.38.64 1.34 1.4Z",
    fill: "#5FBCDA"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M52.69 31.56a1.44 1.44 0 0 1-1.5 1.32 1.33 1.33 0 0 1-1.3-1.4c.04-.74.7-1.33 1.46-1.32.78.02 1.38.64 1.34 1.4Z",
    fill: "#60BDDB"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M52.68 31.56a1.44 1.44 0 0 1-1.5 1.32 1.33 1.33 0 0 1-1.3-1.4c.05-.74.7-1.33 1.47-1.32.78.02 1.38.64 1.33 1.4Z",
    fill: "#61BEDB"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M52.68 31.56a1.44 1.44 0 0 1-1.5 1.32 1.33 1.33 0 0 1-1.3-1.4c.04-.74.7-1.33 1.47-1.32.77.02 1.37.64 1.33 1.4Z",
    fill: "#62BFDB"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M52.68 31.56a1.44 1.44 0 0 1-1.5 1.32 1.33 1.33 0 0 1-1.3-1.4c.05-.74.7-1.33 1.47-1.31.77 0 1.37.63 1.33 1.39Z",
    fill: "#63C0DC"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M52.67 31.55a1.43 1.43 0 0 1-1.49 1.33 1.32 1.32 0 0 1-1.3-1.4c.05-.74.7-1.33 1.47-1.32.77.02 1.37.64 1.32 1.4Z",
    fill: "#64C1DC"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M52.67 31.55a1.43 1.43 0 0 1-1.5 1.33 1.33 1.33 0 0 1-1.3-1.4c.05-.74.7-1.33 1.47-1.32.78.02 1.37.64 1.33 1.4Z",
    fill: "#65C2DD"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M52.67 31.55a1.43 1.43 0 0 1-1.5 1.33 1.32 1.32 0 0 1-1.29-1.4c.05-.74.7-1.33 1.46-1.32.77.02 1.37.64 1.33 1.4Z",
    fill: "#66C3DD"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M52.66 31.55a1.43 1.43 0 0 1-1.48 1.33 1.32 1.32 0 0 1-1.3-1.4c.05-.74.7-1.33 1.46-1.32.77.02 1.37.64 1.32 1.4Z",
    fill: "#67C4DE"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M52.66 31.55a1.43 1.43 0 0 1-1.49 1.32 1.32 1.32 0 0 1-1.3-1.4c.05-.73.7-1.32 1.47-1.3.77 0 1.36.63 1.32 1.38Z",
    fill: "#68C5DE"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M52.66 31.55a1.43 1.43 0 0 1-1.49 1.32 1.32 1.32 0 0 1-1.29-1.4c.05-.73.7-1.32 1.46-1.3.77 0 1.36.63 1.32 1.38Z",
    fill: "#69C6DF"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M52.65 31.55a1.43 1.43 0 0 1-1.48 1.32 1.32 1.32 0 0 1-1.29-1.4c.05-.73.7-1.32 1.46-1.3.76 0 1.36.63 1.31 1.38Z",
    fill: "#6AC7DF"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M52.65 31.55a1.43 1.43 0 0 1-1.48 1.32 1.32 1.32 0 0 1-1.3-1.4c.05-.73.7-1.32 1.46-1.3.77 0 1.36.63 1.32 1.38Z",
    fill: "#6BC8E0"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M52.65 31.55c-.05.76-.71 1.35-1.48 1.32a1.32 1.32 0 0 1-1.29-1.4c.05-.73.7-1.32 1.45-1.3.77 0 1.36.63 1.32 1.38Z",
    fill: "#6CC9E0"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M52.64 31.55c-.04.76-.7 1.35-1.47 1.32a1.32 1.32 0 0 1-1.29-1.4c.05-.73.7-1.32 1.45-1.3.76 0 1.36.63 1.31 1.38Z",
    fill: "#6DCAE1"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M52.64 31.55c-.04.76-.7 1.35-1.47 1.32a1.31 1.31 0 0 1-1.29-1.4c.05-.73.7-1.32 1.45-1.3.76 0 1.35.63 1.31 1.38Z",
    fill: "#6ECBE1"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M52.64 31.55c-.05.75-.7 1.34-1.48 1.32a1.31 1.31 0 0 1-1.28-1.4c.05-.73.7-1.32 1.45-1.3.76 0 1.35.63 1.3 1.38Z",
    fill: "#6FCCE2"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M52.63 31.55c-.04.75-.7 1.34-1.47 1.32a1.31 1.31 0 0 1-1.28-1.4c.05-.73.7-1.32 1.45-1.3.76 0 1.35.62 1.3 1.38Z",
    fill: "#70CDE2"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M52.63 31.55c-.04.75-.7 1.34-1.47 1.32a1.31 1.31 0 0 1-1.28-1.4c.05-.73.7-1.32 1.45-1.3.76 0 1.35.62 1.3 1.38Z",
    fill: "#91DBE8"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 46.79c-6.54.28-13.06.28-19.6 0a1.07 1.07 0 0 1-1-1 233.7 233.7 0 0 1 0-19.58c.03-.53.48-.98 1-1 6.54-.28 13.06-.28 19.6 0 .52.02.97.47 1 1 .27 6.52.27 13.06 0 19.58-.03.53-.48.98-1 1Z",
    fill: "url(#U)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M20.79 46.78c-6.54.28-13.04.28-19.58 0a1.07 1.07 0 0 1-1-1 233.4 233.4 0 0 1 0-19.56c.03-.53.48-.98 1-1 6.54-.28 13.04-.28 19.58 0 .52.02.97.47 1 1 .27 6.51.27 13.05 0 19.57-.02.52-.48.97-1 1Z",
    fill: "url(#V)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M20.78 46.78c-6.53.28-13.03.28-19.56 0a1.07 1.07 0 0 1-1-1 233.1 233.1 0 0 1 0-19.56c.03-.52.48-.97 1-1 6.53-.28 13.03-.28 19.56 0 .53.03.98.48 1 1 .27 6.52.27 13.04 0 19.56-.02.52-.47.97-1 1Z",
    fill: "url(#W)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M20.77 46.77c-6.52.28-13.02.28-19.54 0a1.07 1.07 0 0 1-1-1 232.8 232.8 0 0 1 0-19.54c.02-.53.47-.97 1-1 6.52-.28 13.02-.28 19.54 0 .53.03.98.47 1 1 .27 6.51.27 13.03 0 19.54-.02.53-.47.98-1 1Z",
    fill: "url(#X)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M20.77 46.76c-6.52.28-13.02.28-19.54 0a1.06 1.06 0 0 1-1-1c-.26-6.5-.26-13.02 0-19.52.03-.53.48-.98 1-1 6.52-.28 13.02-.28 19.54 0 .52.02.97.47 1 1 .26 6.5.26 13.02 0 19.53-.03.52-.48.97-1 1Z",
    fill: "url(#Y)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M20.76 46.76c-6.52.28-13 .28-19.52 0a1.06 1.06 0 0 1-1-1c-.27-6.5-.27-13.01 0-19.52.03-.52.48-.97 1-1 6.52-.27 13-.27 19.52 0 .52.03.97.48 1 1 .27 6.5.27 13.02 0 19.52-.03.52-.48.97-1 1Z",
    fill: "url(#Z)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 46.75c-6.5.28-13 .28-19.5 0a1.07 1.07 0 0 1-1-1c-.27-6.5-.27-13 0-19.5.03-.52.47-.97 1-1 6.5-.27 13-.27 19.5 0 .53.03.97.48 1 1 .27 6.5.27 13 0 19.5-.03.53-.47.98-1 1Z",
    fill: "url(#aa)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M20.74 46.74c-6.5.28-12.98.28-19.48 0a1.06 1.06 0 0 1-1-1C0 39.26 0 32.76.26 26.26c.02-.52.47-.97 1-.99 6.5-.28 12.98-.28 19.48 0 .53.02.98.47 1 1 .27 6.49.27 13 0 19.49-.02.52-.47.97-1 1Z",
    fill: "url(#ab)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M20.74 46.74c-6.5.27-12.98.27-19.48 0a1.06 1.06 0 0 1-1-1C0 39.25 0 32.75.27 26.26c.03-.52.48-.97 1-1 6.5-.27 12.98-.27 19.48 0 .52.03.97.48 1 1 .26 6.5.26 13 0 19.48-.03.53-.48.97-1 1Z",
    fill: "url(#ac)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M20.73 46.73c-6.5.28-12.97.28-19.46 0a1.06 1.06 0 0 1-1-1C0 39.26 0 32.76.28 26.28c.03-.52.48-.97 1-1 6.5-.27 12.96-.27 19.46 0 .52.03.97.48 1 1 .26 6.48.26 12.98 0 19.47-.03.52-.48.97-1 .99Z",
    fill: "url(#ad)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M20.72 46.72c-6.49.28-12.95.28-19.44 0a1.06 1.06 0 0 1-1-.99c-.27-6.48-.27-12.97 0-19.45.03-.53.47-.97 1-1 6.49-.27 12.95-.27 19.44 0 .52.03.97.47 1 1 .26 6.48.26 12.97 0 19.45-.03.52-.47.97-1 1Z",
    fill: "url(#ae)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 46.72c-6.48.27-12.94.27-19.43 0a1.06 1.06 0 0 1-.99-1C.02 39.25.02 32.76.3 26.28c.02-.52.47-.97 1-1 6.48-.27 12.94-.27 19.42 0 .53.03.97.48 1 1 .27 6.48.27 12.97 0 19.44-.03.53-.47.97-1 1Z",
    fill: "url(#af)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 46.7a226 226 0 0 1-19.41 0 1.06 1.06 0 0 1-1-.98C.04 39.24.04 32.76.3 26.29c.03-.52.48-.97 1-1a226 226 0 0 1 19.42 0c.52.03.97.48.99 1 .27 6.47.27 12.96 0 19.43-.02.52-.47.97-1 .99Z",
    fill: "url(#ag)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 46.7c-6.48.28-12.93.28-19.4 0a1.06 1.06 0 0 1-1-.99C.05 39.24.05 32.76.3 26.3c.03-.52.48-.96 1-.98 6.47-.28 12.92-.28 19.4 0 .52.02.97.46.99.98.27 6.47.27 12.95 0 19.42-.02.52-.47.97-.99 1Z",
    fill: "url(#ah)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 46.7c-6.48.27-12.92.27-19.4 0a1.06 1.06 0 0 1-.99-1c-.27-6.46-.27-12.93 0-19.4.03-.52.47-.97 1-.99 6.47-.28 12.91-.28 19.38 0 .52.02.97.47 1 .99.26 6.46.26 12.94 0 19.4-.03.53-.48.97-1 1Z",
    fill: "url(#ai)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M20.68 46.69c-6.46.28-12.9.28-19.37 0a1.06 1.06 0 0 1-.99-.99c-.27-6.46-.27-12.93 0-19.4.02-.51.47-.96.99-.98 6.47-.28 12.9-.28 19.37 0 .52.02.97.47 1 .99.26 6.46.26 12.93 0 19.4-.03.51-.47.96-1 .98Z",
    fill: "url(#aj)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M20.68 46.68c-6.46.28-12.9.28-19.36 0a1.06 1.06 0 0 1-.99-.99c-.27-6.45-.27-12.92 0-19.38.02-.52.47-.96.99-.99 6.46-.27 12.9-.27 19.36 0 .52.03.96.47.99 1 .27 6.45.27 12.92 0 19.37-.03.52-.47.97-1 1Z",
    fill: "url(#ak)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M20.67 46.68c-6.46.27-12.89.27-19.34 0a1.06 1.06 0 0 1-1-1c-.26-6.44-.26-12.9 0-19.36.03-.52.48-.96 1-.99 6.45-.27 12.88-.27 19.34 0 .52.03.97.47.99 1 .27 6.44.27 12.9 0 19.36-.02.52-.47.96-.99.99Z",
    fill: "url(#al)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 46.67c-6.45.28-12.87.28-19.33 0a1.06 1.06 0 0 1-.98-.99c-.27-6.45-.27-12.9 0-19.35.02-.52.46-.97.98-.99 6.46-.28 12.88-.28 19.33 0 .52.02.97.47 1 .99.26 6.45.26 12.9 0 19.35-.03.52-.48.97-1 .99Z",
    fill: "url(#am)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 46.66c-6.45.28-12.87.28-19.32 0a1.05 1.05 0 0 1-.99-.98c-.27-6.45-.27-12.9 0-19.35.03-.52.47-.96.99-.98 6.45-.28 12.87-.28 19.32 0 .52.02.96.46.98.98.27 6.45.27 12.9 0 19.35-.02.52-.46.96-.98.98Z",
    fill: "url(#an)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M20.65 46.66c-6.44.27-12.86.27-19.3 0a1.05 1.05 0 0 1-.99-.99C.1 39.23.1 32.78.36 26.34c.02-.52.47-.96.99-.98 6.44-.28 12.86-.28 19.3 0 .52.02.96.46.98.98.27 6.44.27 12.9 0 19.33-.02.52-.46.96-.98.99Z",
    fill: "url(#ao)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M20.64 46.65c-6.44.27-12.85.27-19.29 0a1.05 1.05 0 0 1-.98-.99C.1 39.23.1 32.78.37 26.35c.02-.52.47-.97.98-.99 6.44-.27 12.85-.27 19.3 0 .5.02.95.47.98.99.26 6.43.26 12.88 0 19.31-.03.52-.47.97-.99.99Z",
    fill: "url(#ap)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M20.63 46.64c-6.43.28-12.84.28-19.27 0a1.05 1.05 0 0 1-.98-.98C.1 39.23.1 32.79.38 26.36c.02-.53.46-.97.98-1a224.5 224.5 0 0 1 19.27 0c.52.03.97.47.99 1 .27 6.42.27 12.87 0 19.3-.02.52-.47.96-.99.98Z",
    fill: "url(#aq)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M20.63 46.64c-6.43.27-12.83.27-19.26 0a1.05 1.05 0 0 1-.98-.99c-.27-6.43-.27-12.86 0-19.3.02-.51.46-.95.98-.98 6.43-.27 12.83-.27 19.26 0 .52.03.96.47.98.99.27 6.43.27 12.86 0 19.3-.02.5-.46.95-.98.98Z",
    fill: "url(#ar)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M20.62 46.63c-6.42.28-12.82.28-19.24 0a1.05 1.05 0 0 1-.98-.98C.13 39.22.13 32.79.4 26.37c.02-.52.46-.96.98-.99 6.42-.27 12.82-.27 19.24 0 .52.03.96.47.98.99.27 6.42.27 12.85 0 19.28-.02.51-.46.96-.98.98Z",
    fill: "url(#as)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M20.61 46.62c-6.42.28-12.8.28-19.23 0a1.05 1.05 0 0 1-.98-.98C.13 39.22.13 32.79.4 26.37c.02-.52.47-.96.98-.98 6.42-.28 12.81-.28 19.23 0 .52.02.96.46.98.98.27 6.42.27 12.85 0 19.27-.02.52-.46.96-.98.98Z",
    fill: "url(#at)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 46.62c-6.4.27-12.8.27-19.21 0a1.05 1.05 0 0 1-.98-.99C.14 39.22.14 32.8.4 26.38c.02-.52.46-.96.98-.98 6.41-.28 12.8-.28 19.22 0 .51.02.95.46.98.98.26 6.41.26 12.84 0 19.25-.03.52-.47.96-.98.99Z",
    fill: "url(#au)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 46.6c-6.41.28-12.8.28-19.2 0a1.05 1.05 0 0 1-.98-.97C.15 39.22.15 32.8.42 26.38c.02-.51.46-.95.98-.98 6.4-.27 12.79-.27 19.2 0 .51.03.96.47.98.98.27 6.41.27 12.84 0 19.25-.02.51-.47.96-.98.98Z",
    fill: "url(#av)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 46.6c-6.4.28-12.78.28-19.19 0a1.05 1.05 0 0 1-.98-.98C.16 39.22.16 32.8.42 26.4c.03-.51.47-.96.98-.98 6.4-.27 12.79-.27 19.2 0 .5.02.95.47.97.98.27 6.4.27 12.82 0 19.23-.02.52-.46.96-.98.98Z",
    fill: "url(#aw)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 46.6c-6.4.27-12.77.27-19.17 0a1.05 1.05 0 0 1-.98-.98C.17 39.22.17 32.8.43 26.4c.02-.52.47-.96.98-.98 6.4-.28 12.77-.28 19.17 0 .52.02.96.46.98.98.27 6.4.27 12.81 0 19.22-.02.51-.46.95-.98.98Z",
    fill: "url(#ax)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 46.59c-6.4.27-12.77.27-19.16 0a1.05 1.05 0 0 1-.98-.98c-.27-6.4-.27-12.8 0-19.2.02-.52.46-.96.98-.98 6.4-.28 12.76-.28 19.16 0 .51.02.95.46.97.97.27 6.4.27 12.81 0 19.21-.02.51-.46.96-.97.98Z",
    fill: "url(#ay)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M20.57 46.58c-6.39.28-12.75.28-19.14 0a1.05 1.05 0 0 1-.98-.98c-.27-6.39-.27-12.8 0-19.19.02-.51.46-.95.98-.98 6.39-.27 12.75-.27 19.14 0 .51.03.96.47.98.98.27 6.4.27 12.8 0 19.2-.02.5-.47.95-.98.97Z",
    fill: "url(#az)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 46.58c-6.38.27-12.74.27-19.13 0a1.04 1.04 0 0 1-.97-.98c-.27-6.4-.27-12.8 0-19.18.02-.52.46-.96.97-.98 6.39-.28 12.75-.28 19.13 0 .52.02.96.46.98.98a230 230 0 0 1 0 19.18c-.02.51-.46.95-.98.98Z",
    fill: "url(#aA)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 46.57c-6.38.27-12.73.27-19.11 0a1.04 1.04 0 0 1-.98-.98C.2 39.21.2 32.81.46 26.42c.03-.51.47-.95.98-.97 6.38-.28 12.73-.28 19.11 0 .52.02.96.46.98.97.27 6.39.27 12.79 0 19.17-.02.51-.46.96-.98.98Z",
    fill: "url(#aB)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 46.56c-6.38.28-12.73.28-19.1 0a1.04 1.04 0 0 1-.98-.97C.2 39.2.2 32.8.47 26.43c.02-.51.46-.95.98-.98 6.37-.27 12.72-.27 19.1 0 .51.03.95.47.97.98.27 6.38.27 12.77 0 19.16-.02.5-.46.95-.97.97Z",
    fill: "url(#aC)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 46.55c-6.37.28-12.72.28-19.09 0a1.04 1.04 0 0 1-.97-.97C.2 39.2.2 32.82.48 26.44c.02-.52.46-.96.97-.98 6.37-.27 12.72-.27 19.09 0 .51.02.95.46.97.98.27 6.37.27 12.76 0 19.14-.02.51-.46.95-.97.97Z",
    fill: "url(#aD)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 46.55c-6.36.27-12.7.27-19.07 0a1.04 1.04 0 0 1-.97-.98C.22 39.2.22 32.82.49 26.44c.02-.51.46-.95.97-.97 6.37-.28 12.7-.28 19.07 0 .52.02.95.46.98.97.26 6.38.26 12.76 0 19.13-.03.52-.46.96-.98.98Z",
    fill: "url(#aE)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53 46.54c-6.37.28-12.7.28-19.06 0a1.04 1.04 0 0 1-.98-.97C.23 39.2.23 32.82.5 26.45c.03-.51.47-.95.98-.97 6.36-.28 12.7-.28 19.06 0 .5.02.95.46.97.97.26 6.37.26 12.75 0 19.12-.03.51-.46.95-.97.97Z",
    fill: "url(#aF)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 46.54c-6.36.27-12.69.27-19.05 0a1.04 1.04 0 0 1-.97-.98C.24 39.2.24 32.82.5 26.46c.02-.51.46-.95.97-.98 6.36-.27 12.7-.27 19.05 0 .5.03.95.47.97.98.26 6.36.26 12.74 0 19.1-.02.51-.46.95-.97.98Z",
    fill: "url(#aG)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M20.51 46.53c-6.35.27-12.68.27-19.03 0a1.04 1.04 0 0 1-.97-.97c-.27-6.37-.27-12.74 0-19.1.02-.5.46-.95.97-.97a220.6 220.6 0 0 1 19.03 0c.51.02.95.46.97.97.27 6.36.27 12.73 0 19.1-.02.5-.46.95-.97.97Z",
    fill: "url(#aH)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 46.52c-6.34.27-12.67.27-19.01 0a1.04 1.04 0 0 1-.97-.97c-.27-6.36-.27-12.72 0-19.08.02-.51.46-.95.97-.97 6.34-.27 12.67-.27 19.01 0 .51.02.95.46.97.97.27 6.36.27 12.72 0 19.08-.02.51-.46.95-.97.97Z",
    fill: "url(#aI)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 46.51c-6.35.28-12.66.28-19 0a1.04 1.04 0 0 1-.97-.97C.26 39.2.26 32.83.53 26.48c.02-.52.46-.95.97-.98 6.34-.27 12.65-.27 19 0 .5.03.94.46.97.98.26 6.35.26 12.7 0 19.06-.03.51-.46.95-.97.97Z",
    fill: "#fff"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M7 32H4.26v-2.72H7v2.73ZM8.27 28h-5.3v5.31h5.3V28Z",
    fill: "#40393C"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32 30.02H4.95v1.37h1.37v-1.37ZM4.27 40.21H7v2.73H4.27V40.2ZM3 44.23h5.29v-5.31h-5.3v5.31Z",
    fill: "#40393C"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32 40.95H4.95v1.37h1.37v-1.37ZM17.3 30.02h-1.37v1.37h1.37v-1.37Z",
    fill: "#40393C"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 32h-2.72v-2.72h2.72v2.73Zm-4-4.01v5.31h5.28V28h-5.29ZM10.76 30.9h1.61V28H9.9v1.61h.87v1.3ZM4.62 34.4H2.96v1.62h1.66v-1.61ZM19.25 34.4H17.6v1.62h1.66v-1.61ZM17.62 42.64h-3v1.61h4.6v-2.64h-1.6v1.03ZM19.25 37.62H17.6v1.62h1.66v-1.62ZM17.58 36.01h-1.66v1.62h1.66V36ZM11.38 36.01H9.7v1.62h1.67V36Z",
    fill: "#40393C"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82 36.44v1.62h3.16v-2.04h1.73v-1.61H6.37V36.44H4.82ZM15.39 37.68v-1.62h-1.8V34.4h-1.61v5.31h1.61v-2.04h1.8ZM11.29 39.65H9.68v3.38H13.08V41.4h-1.8v-1.76ZM17.61 39.24h-3.16v1.62h3.16v-1.62ZM6.99 32H4.27v-2.72h2.72V32Zm1.28-4.02H2.98v5.32h5.3v-5.32Z",
    fill: "#40393C"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31 30.01H4.94v1.38h1.37V30Z",
    fill: "#40393C"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27 40.2h2.72v2.73H4.27V40.2Zm-1.29 4.03h5.3V38.9h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31 40.94H4.94v1.38h1.37v-1.38ZM17.3 30.01h-1.37v1.38h1.37V30Z",
    fill: "#2E2E2E"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M17.97 32h-2.72v-2.72h2.72V32Zm-4-4.02v5.32h5.29v-5.32h-5.3ZM10.76 30.9h1.6v-2.91H9.89v1.6h.88v1.3ZM4.62 34.4H2.96v1.62h1.66V34.4ZM19.24 34.4h-1.66v1.62h1.66V34.4ZM17.61 42.63h-2.99v1.62h4.6V41.6h-1.6v1.02ZM19.24 37.62h-1.66v1.62h1.66v-1.62ZM17.57 36h-1.66v1.62h1.66v-1.61ZM11.37 36H9.71v1.62h1.66v-1.61ZM4.81 36.44v1.61h3.16V36.02H9.7V34.4H6.36v2.04H4.82ZM15.38 37.67v-1.62h-1.8V34.4h-1.6v5.32h1.6v-2.05h1.8ZM11.28 39.65h-1.6v3.38h1.6v-.01h1.8V41.4h-1.8v-1.75Z",
    fill: "#2E2E2E"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 39.24h-3.15v1.62h3.16v-1.62Z",
    fill: "#40393C"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98 32H4.26v-2.73h2.72V32Zm1.29-4.02h-5.3v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 30H4.95v1.38H6.3v-1.37ZM4.26 40.2h2.72v2.73H4.26V40.2Zm-1.28 4.02h5.29v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 40.94H4.95v1.37H6.3v-1.37ZM17.29 30h-1.37v1.38h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M17.96 32h-2.71v-2.73h2.71V32Zm-4-4.02v5.31h5.3v-5.31h-5.3ZM10.75 30.9h1.61v-2.92H9.88v1.61h.87v1.3ZM4.61 34.4H2.95V36h1.66V34.4ZM19.24 34.4h-1.66V36h1.66V34.4ZM17.6 42.63h-2.98v1.61h4.59V41.6h-1.6v1.03ZM19.24 37.61h-1.66v1.62h1.66v-1.62ZM17.57 36h-1.66v1.62h1.66V36ZM11.37 36H9.7v1.62h1.66V36ZM4.8 36.43v1.62h3.17V36H9.7V34.4H6.36V36.43H4.81ZM15.38 37.67v-1.62h-1.8V34.4h-1.61v5.31h1.6v-2.04h1.8ZM11.28 39.64H9.67v3.38H13.07V41.4h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 39.23h-3.16v1.62h3.16v-1.62ZM6.97 32H4.26v-2.73h2.71v2.72Zm1.3-4.03h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 30H4.93v1.37H6.3V30ZM4.26 40.2h2.71v2.72H4.26V40.2Zm-1.29 4.02h5.3V38.9h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 40.93H4.93v1.37H6.3v-1.37ZM17.28 30h-1.36v1.37h1.36V30Z",
    fill: "#2E2E2E"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M17.96 32h-2.72v-2.73h2.72v2.72Zm-4-4.03v5.32h5.29v-5.32h-5.3ZM10.75 30.89h1.6v-2.92H9.88v1.62h.88v1.3ZM4.6 34.4H2.96V36H4.6v-1.6ZM19.24 34.4h-1.67V36h1.67v-1.6ZM17.6 42.62h-3v1.62h4.6V41.6h-1.6v1.02ZM19.24 37.6h-1.67v1.63h1.67V37.6ZM17.57 36H15.9v1.61h1.67V36ZM11.36 36H9.7v1.61h1.66V36ZM4.8 36.42v1.62h3.16V36.01H9.7v-1.62H6.35V36.42H4.8ZM15.37 37.66v-1.62h-1.8V34.4h-1.6v5.32h1.6v-2.05h1.8ZM11.27 39.64h-1.6v3.38h1.6V43h1.8v-1.62h-1.8v-1.75Z",
    fill: "#2E2E2E"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 39.23h-3.16v1.61h3.16v-1.61ZM6.97 31.99H4.25v-2.73h2.72v2.73Zm1.29-4.02h-5.3v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 30H4.92v1.37h1.36V30ZM4.25 40.19h2.72v2.73H4.25v-2.73ZM2.96 44.2h5.3V38.9h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 40.93H4.92v1.37h1.36v-1.37ZM17.28 30H15.9v1.37h1.37V30Z",
    fill: "#2E2E2E"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 31.99h-2.71v-2.73h2.71v2.73Zm-4-4.02v5.31h5.3v-5.31h-5.3ZM10.74 30.88h1.61v-2.91H9.87v1.61h.87v1.3ZM4.6 34.39H2.94V36H4.6V34.4ZM19.23 34.39h-1.66V36h1.66V34.4ZM17.6 42.62h-3v1.61h4.6V41.6h-1.6v1.03ZM19.23 37.6h-1.66v1.62h1.66V37.6ZM17.56 35.99H15.9v1.62h1.66v-1.62ZM11.35 35.99H9.7v1.62h1.66v-1.62ZM4.8 36.42v1.62h3.16V36h1.73V34.4H6.35V36.42H4.8ZM15.37 37.66v-1.62h-1.8v-1.65h-1.61v5.31h1.6v-2.05h1.8ZM11.26 39.63h-1.6v3.38H13.06v-1.62h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 39.22h-3.17v1.62h3.16v-1.62ZM6.96 31.98H4.25v-2.73h2.71v2.73Zm1.3-4.02h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29 30H4.92v1.36h1.37V30ZM4.25 40.18h2.71v2.73H4.25v-2.73Zm-1.3 4.03h5.3v-5.32h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29 40.92H4.92v1.37h1.37v-1.37ZM17.27 30H15.9v1.36h1.37V30Z",
    fill: "#2E2E2E"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 31.98h-2.72v-2.73h2.72v2.73Zm-4-4.02v5.32h5.29v-5.32h-5.3ZM10.74 30.88h1.6v-2.92H9.87v1.62h.88v1.3ZM4.6 34.38H2.92V36H4.6v-1.62ZM19.22 34.38h-1.66V36h1.66v-1.62ZM17.59 42.6h-3v1.63h4.6v-2.64h-1.6v1.02ZM19.22 37.6h-1.66v1.61h1.66V37.6ZM17.55 35.98H15.9v1.62h1.66v-1.62ZM11.35 35.98H9.69v1.62h1.66v-1.62ZM4.79 36.41v1.62h3.16V36h1.73v-1.62H6.34V36.41H4.8ZM15.36 37.65v-1.62h-1.8v-1.65h-1.6v5.32h1.6v-2.05h1.8ZM11.26 39.63H9.65V43h1.61V43h1.8v-1.62h-1.8v-1.75ZM17.59 39.22h-3.17v1.61h3.17v-1.61ZM6.96 31.98H4.24v-2.73h2.72v2.73Zm1.28-4.02H2.95v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28 29.99H4.92v1.37h1.36v-1.37ZM4.24 40.18h2.72v2.73H4.24v-2.73ZM2.95 44.2h5.3V38.9h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28 40.91H4.92v1.38h1.36V40.9ZM17.27 29.99H15.9v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M17.94 31.98h-2.71v-2.73h2.71v2.73Zm-4-4.02v5.31h5.29v-5.31h-5.3ZM10.73 30.87h1.61v-2.91H9.85v1.61h.88v1.3ZM4.6 34.38H2.92v1.61h1.66v-1.61ZM19.22 34.38h-1.66v1.61h1.66v-1.61ZM17.58 42.6H14.6v1.62h4.6v-2.64h-1.6v1.02ZM19.22 37.6h-1.66v1.61h1.66v-1.62ZM17.55 35.98h-1.66v1.62h1.66v-1.62ZM11.34 35.98H9.68v1.62h1.66v-1.62ZM4.79 36.4v1.62h3.16V36h1.73v-1.61H6.33v1.61h.01v.42H4.79ZM15.35 37.64v-1.61h-1.8v-1.65h-1.6v5.31h1.6v-2.05h1.8ZM11.26 39.62H9.65V43H13.05v-1.62h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M17.58 39.21h-3.16v1.62h3.16V39.2ZM6.95 31.97H4.24v-2.73h2.71v2.73Zm1.29-4.02h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28 29.98H4.9v1.37h1.37v-1.37ZM4.24 40.17h2.71v2.73H4.24v-2.73Zm-1.3 4.03h5.3v-5.32h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28 40.91H4.9v1.37h1.37v-1.37ZM17.26 29.98H15.9v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M17.94 31.97h-2.72v-2.73h2.72v2.73Zm-4-4.02v5.32h5.28v-5.32h-5.29ZM10.73 30.87h1.6v-2.92H9.85v1.62h.88v1.3ZM4.58 34.37H2.92V36h1.66v-1.62ZM19.21 34.37h-1.66V36h1.66v-1.62ZM17.58 42.6h-3v1.62h4.6v-2.64h-1.6v1.02ZM19.21 37.59h-1.66v1.61h1.66V37.6ZM17.54 35.97h-1.66v1.62h1.66v-1.62ZM11.34 35.97H9.68v1.62h1.66v-1.62ZM4.78 36.4v1.62h3.16V35.99h1.73v-1.62H6.33V36.4H4.78ZM15.35 37.64v-1.62h-1.8v-1.65h-1.6v5.32h1.6v-2.05h1.8ZM11.25 39.62h-1.6V43h1.6v-.01h1.8v-1.62h-1.8v-1.75Z",
    fill: "#2E2E2E"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M17.58 39.2H14.4v1.62h3.17v-1.61ZM6.95 31.97H4.23v-2.73h2.72v2.73Zm1.29-4.02h-5.3v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27 29.97H4.9v1.38h1.37v-1.38ZM4.23 40.17h2.72v2.73H4.23v-2.73Zm-1.29 4.02h5.3v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27 40.9H4.9v1.38h1.37V40.9ZM17.26 29.97h-1.37v1.38h1.37v-1.38Z",
    fill: "#2E2E2E"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 31.97h-2.72v-2.73h2.72v2.73Zm-4-4.02v5.31h5.29v-5.31h-5.3ZM10.72 30.86h1.6v-2.91H9.85v1.61h.88v1.3ZM4.58 34.37H2.92v1.61h1.66v-1.61ZM19.2 34.37h-1.65v1.61h1.66v-1.61ZM17.57 42.6h-2.99v1.61h4.6v-2.64h-1.6v1.02ZM19.2 37.58h-1.65v1.62h1.66v-1.62ZM17.54 35.97h-1.66v1.62h1.66v-1.62ZM11.33 35.97H9.67v1.62h1.66v-1.62ZM4.77 36.4V38h3.17V35.98h1.73v-1.61H6.32V36.4H4.78ZM15.34 37.63v-1.61h-1.8v-1.65h-1.6v5.31h1.6v-2.05h1.8ZM11.24 39.61h-1.6V43H13.03v-1.62h-1.8V39.6ZM17.57 39.2h-3.16v1.62h3.16V39.2ZM6.94 31.96H4.23v-2.73h2.71v2.73Zm1.29-4.02h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27 29.97H4.9v1.37h1.37v-1.37ZM4.22 40.16h2.72v2.73H4.22v-2.73Zm-1.28 4.02h5.29v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27 40.9H4.9v1.37h1.37V40.9ZM17.25 29.97h-1.37v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 31.96H15.2v-2.73h2.72v2.73Zm-4-4.02v5.32h5.28v-5.32h-5.29ZM10.71 30.86h1.61v-2.92H9.84v1.62h.88v1.3ZM4.57 34.36H2.91v1.62h1.66v-1.62ZM19.2 34.36h-1.66v1.62h1.66v-1.62ZM17.57 42.59h-3v1.62h4.6v-2.64h-1.6v1.02ZM19.2 37.58h-1.66v1.61h1.66v-1.61ZM17.53 35.96h-1.66v1.62h1.66v-1.62ZM11.33 35.96H9.67v1.62h1.66v-1.62ZM4.77 36.4V38h3.16V35.98h1.73v-1.62H6.32V36.4H4.77ZM15.34 37.63V36h-1.8v-1.65h-1.6v5.32h1.6v-2.05h1.8ZM11.24 39.6H9.63V43h1.6v-.01h1.8v-1.62h-1.8V39.6ZM17.56 39.2H14.4v1.61h3.16V39.2ZM6.94 31.96H4.22v-2.73h2.72v2.73Zm1.28-4.02H2.93v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26 29.96H4.9v1.38h1.37v-1.38ZM4.22 40.16h2.72v2.73H4.22v-2.73Zm-1.29 4.02h5.3v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26 40.9H4.9v1.37h1.37v-1.38ZM17.24 29.96h-1.36v1.38h1.36v-1.38Z",
    fill: "#2E2E2E"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 31.96H15.2v-2.73h2.72v2.73Zm-4-4.02v5.31h5.29v-5.31h-5.3ZM10.7 30.85h1.62v-2.91H9.83v1.61h.88v1.3ZM4.57 34.36H2.9v1.61h1.66v-1.61ZM19.2 34.36h-1.66v1.61h1.66v-1.61ZM17.56 42.58h-2.99v1.62h4.6v-2.64h-1.6v1.02ZM19.2 37.57h-1.66v1.62h1.66v-1.62ZM17.53 35.96h-1.66v1.61h1.66v-1.61ZM11.32 35.96H9.66v1.61h1.66v-1.61ZM4.76 36.39V38h3.16V35.97h1.73v-1.61H6.31V36.39H4.77ZM15.33 37.62v-1.61h-1.8v-1.65h-1.6v5.31h1.6v-2.05h1.8ZM11.23 39.6h-1.6v3.38H13.02v-1.62h-1.8V39.6ZM17.56 39.2H14.4v1.6h3.16v-1.6ZM6.93 31.95H4.21v-2.73h2.72v2.73Zm1.29-4.02h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 29.96H4.9v1.37h1.36v-1.37ZM4.21 40.15h2.72v2.73H4.21v-2.73Zm-1.28 4.02h5.29v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 40.89H4.9v1.37h1.36V40.9ZM17.24 29.96h-1.37v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M17.91 31.95H15.2v-2.73h2.71v2.73Zm-4-4.02v5.32h5.3v-5.32h-5.3ZM10.7 30.85h1.61v-2.92H9.83v1.62h.87v1.3ZM4.56 34.35H2.9v1.62h1.66v-1.62ZM19.19 34.35h-1.66v1.62h1.66v-1.62ZM17.56 42.58h-3v1.62h4.6v-2.64h-1.6v1.02ZM19.19 37.57h-1.66v1.61h1.66v-1.61ZM17.52 35.95h-1.66v1.62h1.66v-1.62ZM11.32 35.95H9.65v1.62h1.67v-1.62ZM4.76 36.38V38h3.16V35.97h1.73v-1.62H6.3V36.38H4.76ZM15.33 37.62V36h-1.8v-1.65h-1.61v5.32h1.61v-2.05h1.8ZM11.23 39.6H9.62v3.38h1.6v-.01h1.8v-1.62h-1.8V39.6ZM17.55 39.19H14.4v1.61h3.16V39.2ZM6.92 31.95H4.21v-2.73h2.71v2.73Zm1.3-4.02h-5.3v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 29.95H4.88v1.38h1.37v-1.38ZM4.2 40.15h2.73v2.73H4.2v-2.73Zm-1.28 4.02h5.3v-5.32h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 40.88H4.88v1.38h1.37v-1.38ZM17.24 29.95h-1.37v1.38h1.37v-1.38Z",
    fill: "#2E2E2E"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 31.95h-2.7v-2.73h2.7v2.73Zm-4-4.02v5.31h5.3v-5.31h-5.3ZM10.7 30.84h1.6v-2.91H9.83v1.61h.88v1.3ZM4.56 34.34H2.9v1.62h1.66v-1.62ZM19.18 34.34h-1.66v1.62h1.66v-1.62ZM17.55 42.57h-2.99v1.62h4.6v-2.64h-1.6v1.02ZM19.18 37.56h-1.66v1.62h1.66v-1.62ZM17.51 35.95h-1.66v1.61h1.66v-1.61ZM11.31 35.95H9.65v1.61h1.66v-1.61ZM4.75 36.38v1.61h3.16V35.96h1.73v-1.62H6.3v2.04H4.76ZM15.32 37.61V36h-1.8v-1.65h-1.6v5.31h1.6v-2.05h1.8ZM11.22 39.59h-1.6v3.38H13.01v-1.62h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 39.18h-3.16v1.62h3.16v-1.62ZM6.92 31.94H4.2v-2.73h2.72v2.73Zm1.29-4.02H2.9v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 29.95H4.88v1.37h1.36v-1.37ZM4.2 40.14h2.72v2.73H4.2v-2.73Zm-1.28 4.02H8.2v-5.31H2.9v5.31Z",
    fill: "#2E2E2E"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 40.88H4.88v1.37h1.36v-1.37ZM17.23 29.95h-1.37v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 31.94H15.2v-2.73h2.71v2.73Zm-4-4.02v5.31h5.29v-5.31h-5.3ZM10.7 30.84h1.6v-2.92H9.82v1.61h.87v1.3ZM4.55 34.34H2.9v1.62h1.66v-1.62ZM19.18 34.34h-1.66v1.62h1.66v-1.62ZM17.54 42.57h-2.99v1.61h4.6v-2.63h-1.6v1.02ZM19.18 37.56h-1.66v1.61h1.66v-1.61ZM17.51 35.94h-1.66v1.62h1.66v-1.62ZM11.3 35.94H9.65v1.62h1.67v-1.62ZM4.75 36.37V38H7.9V35.96h1.73v-1.62H6.3V36.37H4.75ZM15.32 37.6V36h-1.8v-1.66H11.9v5.32h1.6V37.6h1.8ZM11.22 39.58H9.6v3.39h1.6v-.01h1.8v-1.62h-1.8v-1.76ZM17.54 39.18h-3.16v1.61h3.16v-1.61ZM6.91 31.94H4.2V29.2H6.9v2.73Zm1.3-4.03H2.9v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 29.94H4.87v1.38h1.37v-1.38ZM4.2 40.14H6.9v2.73H4.2v-2.73ZM2.9 44.16h5.3v-5.32H2.9v5.32Z",
    fill: "#2E2E2E"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24 40.87H4.87v1.38h1.37v-1.38ZM17.22 29.94h-1.36v1.38h1.36v-1.38Z",
    fill: "#2E2E2E"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 31.94h-2.72V29.2h2.72v2.73Zm-4-4.03v5.32h5.29v-5.32h-5.3ZM10.69 30.83h1.6v-2.91H9.82v1.6h.88v1.31ZM4.55 34.33H2.88v1.62h1.67v-1.62ZM19.17 34.33h-1.66v1.62h1.66v-1.62ZM17.54 42.56h-3v1.62h4.6v-2.64h-1.6v1.02ZM19.17 37.55h-1.66v1.62h1.66v-1.62ZM17.5 35.94h-1.66v1.61h1.66v-1.61ZM11.3 35.94H9.64v1.61h1.66v-1.61ZM4.74 36.37v1.61H7.9V35.95h1.73v-1.62H6.3v2.04H4.75ZM15.31 37.6V36h-1.8v-1.65h-1.6v5.31h1.6V37.6h1.8ZM11.21 39.58h-1.6v3.38H13v-1.62h-1.8v-1.76ZM17.54 39.17h-3.16v1.62h3.16v-1.62ZM6.9 31.93H4.2V29.2h2.7v2.73Zm1.3-4.02H2.9v5.31h5.3v-5.31Z",
    fill: "#2E2E2E"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 29.94H4.87v1.37h1.36v-1.37ZM4.2 40.13h2.7v2.73H4.2v-2.73Zm-1.3 4.02h5.3v-5.31H2.9v5.31Z",
    fill: "#2E2E2E"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 40.87H4.87v1.37h1.36v-1.37ZM17.22 29.94h-1.37v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 31.93h-2.72V29.2h2.71v2.73Zm-4.01-4.02v5.31h5.29v-5.31h-5.3ZM10.68 30.83h1.61V27.9H9.81v1.61h.87v1.3ZM4.54 34.33H2.88v1.62h1.66v-1.62ZM19.17 34.33H17.5v1.62h1.66v-1.62ZM17.53 42.56h-2.99v1.61h4.6v-2.63h-1.6v1.02ZM19.17 37.55H17.5v1.61h1.66v-1.61ZM17.5 35.93h-1.66v1.62h1.66v-1.62ZM11.3 35.93H9.62v1.62h1.66v-1.62Z",
    fill: "#2E2E2E"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73 36.36v1.62H7.9V35.95h1.73v-1.62H6.28v1.62h.01v.41H4.73ZM15.3 37.6v-1.62h-1.8v-1.65h-1.6v5.32h1.6V37.6h1.8ZM11.2 39.57H9.6v3.39h1.6v-.01H13v-1.62h-1.8v-1.76ZM17.53 39.17h-3.16v1.61h3.16v-1.61ZM6.9 31.93H4.2V29.2H6.9v2.73ZM8.2 27.9h-5.3v5.32h5.3V27.9Z",
    fill: "#2E2E2E"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 29.93H4.86v1.38h1.37v-1.38ZM4.19 40.13H6.9v2.73H4.2v-2.73Zm-1.3 4.02h5.3v-5.32h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 40.86H4.86v1.38h1.37v-1.38ZM17.21 29.93h-1.37v1.38h1.37v-1.38Z",
    fill: "#2E2E2E"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M17.89 31.93h-2.72V29.2h2.72v2.73Zm-4-4.03v5.32h5.28V27.9h-5.29ZM10.68 30.82h1.6v-2.91H9.8v1.6h.88v1.31ZM4.53 34.32H2.87v1.62h1.66v-1.62ZM19.16 34.32H17.5v1.62h1.66v-1.62ZM17.53 42.55h-3v1.62h4.6v-2.64h-1.6v1.02ZM19.16 37.54H17.5v1.62h1.66v-1.62ZM17.5 35.93h-1.67v1.61h1.66v-1.61ZM11.29 35.93H9.63v1.61h1.66v-1.61ZM4.73 36.36v1.61h3.16V35.94h1.73v-1.62H6.28v2.04H4.73ZM15.3 37.6v-1.62h-1.8v-1.65h-1.6v5.31h1.6v-2.05h1.8ZM11.2 39.57H9.59v3.38H13v-1.62h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 39.16h-3.17v1.62h3.17v-1.62ZM6.9 31.92H4.18V29.2H6.9v2.73Zm1.28-4.02H2.9v5.31h5.3V27.9Z",
    fill: "#2E2E2E"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22 29.93H4.86v1.37h1.36v-1.37ZM4.18 40.12H6.9v2.73H4.18v-2.73ZM2.9 44.14h5.3v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22 40.86H4.86v1.37h1.36v-1.37ZM17.2 29.93h-1.36v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M17.88 31.92h-2.71V29.2h2.71v2.73Zm-4-4.02v5.31h5.29V27.9h-5.3ZM10.67 30.81h1.61v-2.9h-.29v-.01H9.8v1.61h.88v1.3ZM4.53 34.32H2.87v1.62h1.66v-1.62ZM19.16 34.32H17.5v1.62h1.66v-1.62ZM17.52 42.55h-2.99v1.61h4.6v-2.63h-1.6v1.02ZM19.16 37.54H17.5v1.61h1.66v-1.61ZM17.49 35.92h-1.66v1.62h1.66v-1.62ZM11.28 35.92H9.62v1.62h1.66v-1.62Z",
    fill: "#2E2E2E"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72 36.35v1.62H7.9V35.94h1.73v-1.62H6.27v1.62h.01v.41H4.72ZM15.3 37.59v-1.62h-1.8v-1.65h-1.61v5.32h1.6v-2.05h1.8ZM11.2 39.56H9.59v3.38H12.99v-1.62h-1.8v-1.76ZM17.52 39.16h-3.16v1.61h3.16v-1.62ZM6.9 31.92H4.16v-2.73H6.9v2.73Zm1.28-4.03h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22 29.92H4.85v1.38h1.37v-1.38ZM4.18 40.12h2.71v2.73H4.18v-2.73Zm-1.3 4.02h5.3v-5.32h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22 40.85H4.85v1.38h1.37v-1.38ZM17.2 29.92h-1.37v1.38h1.37v-1.38Z",
    fill: "#2E2E2E"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M17.88 31.92h-2.72v-2.73h2.72v2.73Zm-4-4.03v5.32h5.28v-5.32h-5.29ZM10.67 30.8h1.6v-2.9H9.8v1.6h.88v1.3ZM4.52 34.31H2.86v1.62h1.66v-1.62ZM19.15 34.31H17.5v1.62h1.66v-1.62ZM17.52 42.54h-3v1.62h4.6v-2.64h-1.6v1.02ZM19.15 37.53H17.5v1.62h1.66v-1.62ZM17.48 35.92h-1.66v1.61h1.66v-1.61ZM11.28 35.92H9.62v1.61h1.66v-1.61ZM4.72 36.35v1.61h3.16V35.93h1.73v-1.62H6.27v2.04H4.72ZM15.29 37.58v-1.61h-1.8v-1.65h-1.6v5.31h1.6v-2.05h1.8ZM11.19 39.56H9.58v3.38h3.41v-1.62h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M17.52 39.15h-3.17v1.62h3.17v-1.62ZM6.89 31.91H4.17v-2.73h2.72v2.73Zm1.28-4.02H2.88v5.31h5.3V27.9Z",
    fill: "#2E2E2E"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21 29.92H4.84v1.37h1.37v-1.37ZM4.17 40.11h2.72v2.73H4.17v-2.73Zm-1.29 4.02h5.3v-5.31h-5.3v5.31Z",
    fill: "#2E2E2E"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21 40.85H4.84v1.37h1.37v-1.37ZM17.2 29.92h-1.37v1.37h1.37v-1.37Z",
    fill: "#2E2E2E"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M17.87 31.91h-2.72v-2.73h2.72v2.73Zm-4-4.02v5.31h5.29V27.9h-5.3ZM10.66 30.8h1.6v-2.9h-.28v-.01h-2.2v1.61h.88v1.3ZM4.52 34.3H2.86v1.63h1.66V34.3ZM19.15 34.3h-1.66v1.63h1.66V34.3ZM17.51 42.54h-2.99v1.61h4.6v-2.63h-1.6v1.02ZM19.15 37.53h-1.66v1.61h1.66v-1.61ZM17.48 35.91h-1.66v1.62h1.66V35.9ZM11.27 35.91H9.61v1.62h1.66V35.9ZM4.71 36.34v1.62h3.17v-2.04H9.6v-1.61H6.26V36.34H4.72ZM15.28 37.58v-1.62h-1.8v-1.65h-1.6v5.32h1.6v-2.05h1.8ZM11.18 39.55h-1.6v3.38H12.97V41.3h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M17.51 39.14h-3.16v1.62h3.16v-1.62ZM6.88 31.9H4.17v-2.72h2.71v2.73Zm1.29-4.02h-5.3v5.32h5.3v-5.32Z",
    fill: "#2E2E2E"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 29.91H4.85v1.38H6.2V29.9ZM4.16 40.1h2.72v2.73H4.17v-2.72Zm-1.28 4.03h5.29V38.8h-5.3v5.32Z",
    fill: "#2E2E2E"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 40.84H4.85v1.38H6.2v-1.38ZM17.19 29.91h-1.37v1.38h1.37V29.9Z",
    fill: "#2E2E2E"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 31.9h-2.71v-2.72h2.71v2.73Zm-4-4.02v5.32h5.3v-5.32h-5.3ZM10.65 30.8h1.61v-2.91H9.78v1.6h.87v1.3ZM4.51 34.3H2.85v1.62h1.66V34.3ZM19.14 34.3h-1.66v1.62h1.66V34.3ZM17.5 42.53h-2.98v1.62h4.59V41.5h-1.6v1.02ZM19.14 37.52h-1.66v1.62h1.66v-1.62ZM17.47 35.9h-1.66v1.62h1.66v-1.61ZM11.27 35.9H9.6v1.62h1.66v-1.61ZM4.7 36.34v1.61h3.17V35.92H9.6V34.3H6.26v2.04H4.71ZM15.28 37.57v-1.62h-1.8v-1.64h-1.6v5.31h1.6v-2.05h1.8ZM11.18 39.55H9.57v3.38H12.97V41.3h-1.8v-1.76Z",
    fill: "#2E2E2E"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 39.14h-3.16v1.62h3.16v-1.62Z",
    fill: "#2E2E2E"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88 31.9H4.16v-2.73h2.72v2.73Zm1.28-4.02H2.87v5.31h5.3v-5.31Z",
    fill: "#40393C"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 29.9H4.83v1.38H6.2v-1.37ZM4.16 40.1h2.71v2.73H4.16V40.1Zm-1.29 4.02h5.3v-5.31h-5.3v5.31Z",
    fill: "#40393C"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 40.84H4.83v1.37H6.2v-1.37ZM17.18 29.9h-1.36v1.38h1.36v-1.37Z",
    fill: "#40393C"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 31.9h-2.72v-2.73h2.72v2.73Zm-4-4.02v5.31h5.29v-5.31h-5.3ZM10.65 30.8h1.6v-2.92H9.78v1.61h.88v1.3ZM4.5 34.3H2.86v1.61H4.5V34.3ZM19.14 34.3h-1.67v1.61h1.67V34.3ZM17.5 42.53h-2.99v1.61h4.6v-2.63h-1.6v1.02ZM19.14 37.51h-1.67v1.62h1.67v-1.62ZM17.47 35.9H15.8v1.62h1.67V35.9ZM11.26 35.9H9.6v1.62h1.66V35.9ZM4.7 36.33v1.62h3.16V35.9H9.6V34.3H6.25V36.33H4.7ZM15.27 37.57v-1.62h-1.8V34.3h-1.6v5.31h1.6v-2.04h1.8ZM11.17 39.54h-1.6v3.38H12.96V41.3h-1.8v-1.76ZM17.5 39.13h-3.16v1.62h3.16v-1.62Z",
    fill: "#40393C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 14.16,
    y1: 5.98,
    x2: 44.17,
    y2: 5.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 26.7,
    y1: 15.94,
    x2: 27.16,
    y2: 21.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 21.42,
    y1: 22.24,
    x2: 21.61,
    y2: 24.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 29.12,
    y1: 22.29,
    x2: 29.28,
    y2: 24.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 17.28,
    y1: 30.9,
    x2: 27.1,
    y2: 30.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 17.28,
    y1: 30.86,
    x2: 26.97,
    y2: 30.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 21.99,
    y1: 29.23,
    x2: 22.19,
    y2: 31.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 28.2,
    y1: 30.8,
    x2: 33.64,
    y2: 30.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 28.2,
    y1: 30.76,
    x2: 33.5,
    y2: 30.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 30.73,
    y1: 29.33,
    x2: 30.91,
    y2: 31.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 26.08,
    y1: 38.07,
    x2: 31.52,
    y2: 38.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 26.08,
    y1: 38.03,
    x2: 31.38,
    y2: 38.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 28.64,
    y1: 36.59,
    x2: 28.78,
    y2: 38.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 34.85,
    y1: 30.73,
    x2: 40.29,
    y2: 30.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 34.85,
    y1: 30.7,
    x2: 40.15,
    y2: 30.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 37.38,
    y1: 29.27,
    x2: 37.56,
    y2: 31.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 17.28,
    y1: 34.41,
    x2: 27.1,
    y2: 34.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 17.28,
    y1: 34.37,
    x2: 26.97,
    y2: 34.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 22.02,
    y1: 32.7,
    x2: 22.17,
    y2: 35.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 28.2,
    y1: 34.49,
    x2: 35.66,
    y2: 34.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 28.2,
    y1: 34.45,
    x2: 35.53,
    y2: 34.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 31.75,
    y1: 32.88,
    x2: 31.92,
    y2: 35.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 17.3,
    y1: 45.21,
    x2: 27.12,
    y2: 45.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 17.31,
    y1: 45.17,
    x2: 26.99,
    y2: 45.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 22.06,
    y1: 43.5,
    x2: 22.2,
    y2: 46.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 28.22,
    y1: 45.31,
    x2: 33.66,
    y2: 45.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 28.23,
    y1: 45.28,
    x2: 33.53,
    y2: 45.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 30.8,
    y1: 43.81,
    x2: 30.92,
    y2: 46.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 34.87,
    y1: 45.36,
    x2: 40.31,
    y2: 45.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 34.87,
    y1: 45.32,
    x2: 40.18,
    y2: 45.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 37.44,
    y1: 43.86,
    x2: 37.57,
    y2: 46.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 17.25,
    y1: 48.76,
    x2: 27.07,
    y2: 48.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 17.26,
    y1: 48.71,
    x2: 26.94,
    y2: 48.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 22.01,
    y1: 47.06,
    x2: 22.14,
    y2: 49.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 28.17,
    y1: 48.99,
    x2: 35.64,
    y2: 49.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 28.18,
    y1: 48.94,
    x2: 35.51,
    y2: 48.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 31.76,
    y1: 47.37,
    x2: 31.88,
    y2: 49.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 17.34,
    y1: 38,
    x2: 24.8,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 17.34,
    y1: 37.96,
    x2: 24.67,
    y2: 37.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 20.9,
    y1: 36.37,
    x2: 21.06,
    y2: 38.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3AF6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 21.83,
    y1: 52.57,
    x2: 21.12,
    y2: 67.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DEE0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D7D9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C4C6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#BDBFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9195AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 37.38,
    y1: 21.1,
    x2: 55.82,
    y2: 33.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#848FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#717FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D79D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 39.04,
    y1: 30.32,
    x2: 46.28,
    y2: 32.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#76D0E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 52.61,
    y1: 30.56,
    x2: 54.21,
    y2: 32.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EA9AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17EB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C0CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C1D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C2D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C3D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C7D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC8D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCAD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCBD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCDD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0CEDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CFDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D0DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D2DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D4DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D8E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD9E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDAE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDBE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DFE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E0E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 2.31,
    y1: 27.21,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E1E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 2.31,
    y1: 27.22,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 2.31,
    y1: 27.22,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E3EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 2.31,
    y1: 27.22,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E4EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 2.31,
    y1: 27.22,
    x2: 18.34,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 2.31,
    y1: 27.22,
    x2: 18.33,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 2.31,
    y1: 27.22,
    x2: 18.33,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 2.31,
    y1: 27.22,
    x2: 18.33,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E8ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 2.31,
    y1: 27.22,
    x2: 18.33,
    y2: 43.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE9EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(90.00004 -1 .6321 56.88979 -15 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4671B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#7C9EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7C9EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A74B7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.3792 0 0 10.3196 28.97 5.87)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF5FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReceiptsMobile);
export default __webpack_public_path__ + "static/media/no-receipts-mobile.0b85d65a2bbc87c50f057e50227eb287.svg";
export { ForwardRef as ReactComponent };